import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ReactDOM from 'react-dom'
import api from '../services/api'
import SortableTh, { sortRows } from '../components/SortableTh'
import Paginacao, { usePaginacao } from '../components/Paginacao'
import { substituirTagsEmail, construirTagItem, dadosSeguradoraParaTags } from '../utils/emailTags'
import { linkWhatsAppWeb, montarMensagemApoliceWhatsApp, htmlParaTextoWhatsApp, ajustarModeloWhatsApp } from '../utils/whatsapp'
import { useNavegacaoLista } from '../hooks/useNavegacaoLista'
import SenhaMasterModal from '../components/SenhaMasterModal'
import IconExcluir from '../components/icons/IconExcluir'
import IconAcoes from '../components/icons/IconAcoes'
import IconVisualizar from '../components/icons/IconVisualizar'
import IconEditar from '../components/icons/IconEditar'
import { avisar, confirmar } from '../components/Avisos'
import SelecaoMultipla from '../components/SelecaoMultipla'
import IconSinistro from '../components/icons/IconSinistro'
import IconAssistencia from '../components/icons/IconAssistencia'
import { conferirDadosCliente } from '../components/ConferirCliente'

// Consulta de Apolices (pedido do usuario, 26/10): a lista abre vazia e so mostra o que foi
// buscado ou filtrado. Filtro avancado igual ao do Acompanhamento de Propostas, salvo neste
// navegador ate o "Limpar filtros"; so vale com o quadradinho "Filtro" marcado.
const CHAVE_FILTROS_APOLICES = 'apolices.filtros'
const FILTROS_APOLICES_VAZIOS = { seguradoras: [], ramos: [], status: [], periodoCampo: 'data_inicio', periodoDe: '', periodoAte: '', sinistro: '', assistencia: '' }
const DATAS_PERIODO_APOLICES = [
  { campo: 'data_inicio', label: 'Vigência inicial' },
  { campo: 'data_vencimento', label: 'Vigência final' },
]
const STATUS_FILTRO_APOLICES = [
  { valor: 'emitido', label: 'Emitido' },
  { valor: 'vencida', label: 'Vencida' },
  { valor: 'cancelada', label: 'Cancelada' },
]
const lerFiltrosApolices = () => {
  try { return JSON.parse(localStorage.getItem(CHAVE_FILTROS_APOLICES)) || {} } catch { return {} }
}
const temCriterioApolices = (f) => !!(f.seguradoras.length || f.ramos.length || f.status.length || f.periodoDe || f.periodoAte || f.sinistro || f.assistencia)

const seguradorasPadrao = ['Akad','Aliro','Allianz','Azul','Bradesco','Essor','HDI','Itaú','Mitsui','Porto','Suhai','Tokio Marine','Yelum']
const ramos = ['Acidentes Pessoais','Automóvel','Bike','Carta Verde','Condomínio','Empresarial','Equipamentos','Residencial','Responsabilidade Civil','Vida em Grupo','Vida Individual','Viagem']
const formasPag = ['Boleto','Débito em Conta','Cartão de Crédito','Pix','Restituição','Sem cobrança']
const tiposDoc = ['Proposta','Apólice','Endosso','Devolvida']
// Vida Individual: beneficiarios a partir do 2o, [{ nome, pct, parentesco }] dentro de coberturas_dinamicas
const CHAVE_BENEFICIARIOS_EXTRAS = 'Beneficiários adicionais'

const tiposPropostaApolice = ['Novo','Renovação Interna','Renovação Externa','Refeito']
export const tiposEndosso = ['Alteração na Apólice','Alteração Cadastral','Alteração de Item','Alteração de CEP de Pernoite','Alteração de Local de Risco','Alteração por Sinistro','Substituição','Cancelamento de Item','Cancelamento por Falecimento','Cancelamento por Falta de Pagamento','Cancelamento por Sinistro','Cancelamento por Solicitação','Inclusão de item','Prorrogação de apólice','Reintegração de Cobertura']
// PDF de proposta de endosso cuja apolice nao esta cadastrada pra esse cliente (backend devolve
// endosso_sem_apolice): nao vira proposta nova, o usuario cadastra a apolice original antes.
export const textoEndossoSemApolice = (data) => {
  const numero = data?.endosso_sem_apolice?.numero_apolice
  return `Este PDF é um endosso${numero ? ` da apólice nº ${numero}` : ''}, que não está cadastrada no sistema para ${data?.cliente_nome || 'este cliente'}. Cadastre a apólice original primeiro e depois importe o endosso de novo.`
}
// Endosso de frota (Porto Auto Frota): o PDF so traz os itens mexidos, cada um com a operacao
// (exclusao/inclusao/alteracao). Parte dos itens do documento de origem: exclusao sai, alteracao
// atualiza o item que casa por chassi (ou placa), inclusao entra no fim. Devolve
// [{ original, fonte }] — original null = item novo, fonte null = item repetido sem mudanca.
export const montarItensEndossoFrota = (itensOriginais, itensPdf) => {
  const norm = v => String(v || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
  const casa = (original, pdf) => (norm(pdf.item_chassi) && norm(original.item_chassi) === norm(pdf.item_chassi))
    || (norm(pdf.item_placa) && norm(original.item_placa) === norm(pdf.item_placa))
  const lista = (itensOriginais || []).map(original => ({ original, fonte: null }))
  for (const pdf of itensPdf || []) {
    const alvo = lista.find(r => r.original && !r.fonte && !r.excluir && casa(r.original, pdf))
    if (pdf.operacao_endosso === 'exclusao') { if (alvo) alvo.excluir = true; continue }
    if (alvo) alvo.fonte = pdf
    else lista.push({ original: null, fonte: pdf })
  }
  return lista.filter(r => !r.excluir)
}
const tiposCancelamentoEndosso = ['Cancelamento de Item','Cancelamento por Falecimento','Cancelamento por Falta de Pagamento','Cancelamento por Sinistro','Cancelamento por Solicitação']
const getTipos = (tipoDoc) => {
  if (tipoDoc === 'Endosso') return tiposEndosso
  if (tipoDoc === 'Devolvida') return []
  return tiposPropostaApolice
}
const formasRecComissao = ['À vista','Parcelada','Esgotamento','Restituição']
const chaveSeguradora = valor => String(valor || '')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/\bseguros?\b/g, '').replace(/[^a-z0-9]/g, '')

// Aceita valor negativo (endosso com restituição ao segurado): o "-" digitado em qualquer
// posição da string marca o valor como negativo.
const parseMoney = v => {
  const s = (v || '').toString()
  const negativo = s.includes('-')
  const n = parseFloat(s.replace(/[^0-9,]/g, '').replace(',', '.')) || 0
  return negativo ? -n : n
}
export const formatMoney = v => {
  const n = parseFloat(v) || 0
  const sinal = n < 0 ? '-' : ''
  return sinal + 'R$ ' + Math.abs(n).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

const maskPct = v => {
  v = v.replace(/\D/g, '')
  if (!v) return ''
  while (v.length < 3) v = '0' + v
  const int = v.slice(0, -2)
  const dec = v.slice(-2)
  return (parseInt(int) || '0') + ',' + dec + '%'
}

const parsePct = v => parseFloat((v || '').replace('%','').replace(',','.')) || 0

// % do beneficiario (Vida): aceita ate 2 casas decimais ("7,5%", "33,33%"), sem as mascaras de
// inteiro dos demais campos de % (pedido do usuario, 26/10 — apolice Yelum com 7,5%).
const digitarPctDecimal = v => {
  const [int = '', ...resto] = String(v || '').replace('.', ',').replace(/[^\d,]/g, '').split(',')
  return resto.length ? `${int.slice(0, 3)},${resto.join('').slice(0, 2)}` : int.slice(0, 3)
}
const formatarPctDecimal = v => {
  const n = parsePct(digitarPctDecimal(v))
  return digitarPctDecimal(v).replace(',', '') === '' ? '' : `${String(Math.round(n * 100) / 100).replace('.', ',')}%`
}

const maskCPF = v => {
  v = v.replace(/\D/g, '').slice(0, 11)
  v = v.replace(/(\d{3})(\d)/, '$1.$2')
  v = v.replace(/(\d{3})(\d)/, '$1.$2')
  v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  return v
}

const addDays = (dateStr, days) => {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  d.setDate(d.getDate() + parseInt(days))
  return d.toISOString().split('T')[0]
}

const nextMonthSameDay = (dateStr, day, primeiraParcela) => {
  if (!dateStr || !day) return ''
  const base = new Date(dateStr)
  const diaFixo = parseInt(day)
  let ano = base.getFullYear()
  let mes = base.getMonth() + 1
  if (mes > 11) { mes = 0; ano++ }
  const ultimoDia = new Date(ano, mes + 1, 0).getDate()
  const dia = Math.min(diaFixo, ultimoDia)
  let resultado = new Date(ano, mes, dia)
  if (primeiraParcela) {
    const diff = Math.round((resultado - new Date(primeiraParcela)) / (1000 * 60 * 60 * 24))
    if (diff < 20) {
      mes = resultado.getMonth() + 1
      ano = resultado.getFullYear()
      if (mes > 11) { mes = 0; ano++ }
      const ultimoDia2 = new Date(ano, mes + 1, 0).getDate()
      resultado = new Date(ano, mes, Math.min(diaFixo, ultimoDia2))
    }
  }
  return resultado.toISOString().split('T')[0]
}

// Regras de vencimento da Azul Seguros/Porto Seguro (confirmadas pelo usuario em 2026-08-28,
// vem do texto padrao da secao "FORMA DE PAGAMENTO" da proposta): 1ª parcela conta a partir da
// DATA DA PROPOSTA (nao da vigencia, diferente do prazo manual usado pelas demais seguradoras).
// Boleto e Débito em Conta: +10 dias. Pix: +13 dias. Cartão de Crédito: parcelas ja vao
// autorizadas com a Administradora na transmissao da proposta, entao TODAS ficam na propria data
// da proposta (0 dias, todas iguais). Restituição (endosso com valor negativo) sempre +15 dias,
// independente da forma de pagamento original.
const PRAZO_1A_PARCELA_AZUL_PORTO = { 'Boleto': 10, 'Débito em Conta': 10, 'Pix': 13, 'Cartão de Crédito': 0 }
const SEGURADORAS_REGRA_PRAZO_FIXO = ['azul', 'porto']

const gerarParcelas = (qtd, vigencia_inicio, prazo_primeira, dia_fixo, forma_pagamento, valorTotal, parcelasAtuais, seguradora, data_proposta) => {
  const n = parseInt(qtd) || 0
  if (!n) return []
  // Valor negativo (endosso com restituição ao segurado): forma de pagamento da parcela vira
  // "Restituição" automaticamente.
  const restituicao = valorTotal < 0
  const valorParcela = valorTotal !== 0 ? formatMoney(valorTotal / n) : ''
  const regraAzulPorto = SEGURADORAS_REGRA_PRAZO_FIXO.includes(chaveSeguradora(seguradora)) && data_proposta
  // Bradesco e Suhai: 1ª parcela sempre 7 dias depois da data da proposta (mesma regra do backend
  // em importar_pdf.js > enriquecerDados).
  const regraBradesco = ['Bradesco', 'Suhai'].includes(seguradora) && data_proposta
  const regraFixa = regraAzulPorto || regraBradesco
  const cartaoTodasNaProposta = regraAzulPorto && forma_pagamento === 'Cartão de Crédito' && !restituicao
  const parcelas = []
  for (let i = 0; i < n; i++) {
    let vencimento = ''
    if (i === 0 && seguradora === 'Tokio Marine' && parcelasAtuais?.[0]?.vencimento) {
      // A Tokio imprime a data exata de vencimento no quadro de cobranca; ela pode ser anterior
      // ao inicio da vigencia, portanto nao deve ser recalculada a partir da vigencia.
      vencimento = parcelasAtuais[0].vencimento
    } else if (regraFixa && (i === 0 || cartaoTodasNaProposta)) {
      // Azul/Porto: 1ª parcela (e, no Cartão de Crédito, todas as parcelas) conta a partir da
      // data da proposta, com os dias fixos por forma de pagamento (restituição sempre 15 dias).
      const dias = restituicao ? 15 : (regraBradesco ? 7 : (PRAZO_1A_PARCELA_AZUL_PORTO[forma_pagamento] ?? 0))
      vencimento = addDays(data_proposta, dias)
    } else if (i === 0) {
      // 1ª parcela (demais seguradoras): data início vigência + prazo (ou só data início)
      vencimento = (prazo_primeira && parseInt(prazo_primeira) > 0 && vigencia_inicio)
        ? addDays(vigencia_inicio, parseInt(prazo_primeira))
        : (vigencia_inicio || '')
    } else {
      const anterior = parcelas[i - 1].vencimento
      const diaFixoNum = parseInt(dia_fixo) || 0
      if (diaFixoNum > 0 && anterior) {
        // Com dia fixo preenchido (> 0): próximo mês com esse dia
        const primRef = i === 1 ? parcelas[0].vencimento : null
        vencimento = nextMonthSameDay(anterior, diaFixoNum, primRef)
      } else if (anterior) {
        // Sem dia fixo (0 ou vazio): sempre +30 dias da parcela anterior
        vencimento = addDays(anterior, 30)
      }
    }
    parcelas.push({
      numero: i + 1,
      forma_pagamento: restituicao ? 'Restituição' : (parcelasAtuais?.[i]?.forma_pagamento || forma_pagamento || 'Boleto'),
      vencimento,
      valor: valorParcela || parcelasAtuais?.[i]?.valor || '',
      status: parcelasAtuais?.[i]?.status || 'Pendente'
    })
  }
  return parcelas
}

const dataComissao = (dataParcelaSeguro) => {
  if (!dataParcelaSeguro) return ''
  return addDays(dataParcelaSeguro, 15)
}

const gerarParcelasComissao = (formaRecebimento, qtdParcelas, valorComissao, premioLiquido, parcelasAtuais, parcelasSeguro) => {
  // Sem parcela do prêmio (ex.: endosso sem cobrança de valor) -> sem parcela de comissão a receber.
  if (!parcelasSeguro || parcelasSeguro.length === 0) return []
  if (formaRecebimento === 'À vista' || formaRecebimento === 'Restituição') {
    const dataVenc = dataComissao(parcelasSeguro?.[0]?.vencimento)
    return [{ numero: 1, data: dataVenc, valor: valorComissao !== 0 ? formatMoney(valorComissao) : '', status: parcelasAtuais?.[0]?.status || 'Pendente' }]
  }
  if (formaRecebimento === 'Parcelada') {
    const n = parseInt(qtdParcelas) || 1
    const valorParcela = valorComissao !== 0 ? formatMoney(valorComissao / n) : ''
    return Array.from({ length: n }, (_, i) => ({
      numero: i + 1,
      data: dataComissao(parcelasSeguro?.[i]?.vencimento),
      valor: valorParcela || parcelasAtuais?.[i]?.valor || '',
      status: parcelasAtuais?.[i]?.status || 'Pendente'
    }))
  }
  if (formaRecebimento === 'Esgotamento') {
    // Esgotamento parte do valor absoluto (a logica de "descontar do premio ate esgotar a
    // comissao" so faz sentido em modulo) e reaplica o sinal no final — cobre tambem o caso de
    // endosso com restituicao, onde premio e comissao ficam negativos.
    const n = parseInt(qtdParcelas) || 1
    const sinal = valorComissao < 0 ? -1 : 1
    const premioLiquidoAbs = Math.abs(premioLiquido)
    const valorComissaoAbs = Math.abs(valorComissao)
    const premioLiquidoParcela = premioLiquidoAbs > 0 && n > 0 ? premioLiquidoAbs / n : 0
    if (premioLiquidoParcela <= 0 || valorComissaoAbs <= 0) {
      return parcelasAtuais?.length ? parcelasAtuais : [{ numero: 1, data: '', valor: '', status: 'Pendente' }]
    }
    const result = []
    let restante = valorComissaoAbs
    for (let i = 0; i < n; i++) {
      if (restante <= 0) break
      const pagar = Math.min(premioLiquidoParcela, restante)
      restante = Math.round((restante - pagar) * 100) / 100
      result.push({
        numero: i + 1,
        data: dataComissao(parcelasSeguro?.[i]?.vencimento),
        valor: formatMoney(pagar * sinal),
        status: parcelasAtuais?.[i]?.status || 'Pendente'
      })
    }
    return result
  }
  return parcelasAtuais?.length ? parcelasAtuais : [{ numero: 1, data: '', valor: '', status: 'Pendente' }]
}

const tiposAnexo = ['Proposta','Proposta Assinada','Apólice','Endosso','Certificado','Boleto','Pix','Cálculo','Print','Nota Fiscal','Outros']

function AnexosAba({ apoliceId, salvarApolice, onEnviarEmail, onEnviarWhatsApp, refreshKey }) {
  const [anexos, setAnexos] = useState([])
  const [novoAnexo, setNovoAnexo] = useState(null)
  const [enviando, setEnviando] = useState(false)
  const [selecionados, setSelecionados] = useState(new Set())
  // novoAnexo = { arquivo: File, tipo: '' } | null

  const toggleSelecionado = (id) => setSelecionados(prev => {
    const novo = new Set(prev)
    if (novo.has(id)) novo.delete(id); else novo.add(id)
    return novo
  })

  const carregarAnexos = (aid) => {
    if (!aid) { setAnexos([]); return }
    api.get(`/apolices/${aid}/anexos`)
      .then(r => setAnexos(Array.isArray(r.data) ? r.data : []))
      .catch(() => setAnexos([]))
  }
  // refreshKey muda quando o pai anexa o PDF importado em segundo plano (ex.: ao criar o
  // documento pra poder anexar) — sem isso a lista so recarrega quando apoliceId muda de valor.
  useEffect(() => { carregarAnexos(apoliceId) }, [apoliceId, refreshKey])

  const iniciarNovo = () => setNovoAnexo({ arquivo: null, tipo: '' })

  const selecionarArquivo = (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    if (file.size > 5 * 1024 * 1024) { avisar('Arquivo muito grande. Máximo 5MB.'); return }
    setNovoAnexo(n => ({ ...n, arquivo: file }))
  }

  const confirmarAnexo = async () => {
    if (!novoAnexo?.arquivo) { avisar('Selecione um arquivo.'); return }
    if (!novoAnexo?.tipo) { avisar('Selecione o tipo do documento.'); return }
    setEnviando(true)
    try {
      let aid = apoliceId
      if (!aid) {
        aid = await salvarApolice()
        if (!aid) { setEnviando(false); return }
      }
      const dados = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = ev => resolve(ev.target.result)
        reader.onerror = reject
        reader.readAsDataURL(novoAnexo.arquivo)
      })
      await api.post(`/apolices/${aid}/anexos`, {
        tipo: novoAnexo.tipo,
        nome: novoAnexo.arquivo.name,
        tamanho: novoAnexo.arquivo.size,
        dados
      })
      carregarAnexos(aid)
      setNovoAnexo(null)
    } catch (err) {
      avisar('Erro ao enviar anexo: ' + (err.response?.data?.erro || err.message))
    } finally {
      setEnviando(false)
    }
  }

  const remover = async (id) => {
    if (!(await confirmar('Remover este anexo?'))) return
    try {
      await api.delete(`/apolices/anexos/${id}`)
      carregarAnexos(apoliceId)
    } catch (err) {
      avisar('Erro ao remover anexo: ' + (err.response?.data?.erro || err.message))
    }
  }

  const visualizar = async (a) => {
    try {
      const { data } = await api.get(`/apolices/anexos/${a.id}/dados`)
      const parts = data.dados.split(',')
      const mimeType = parts[0].split(':')[1].split(';')[0]
      const byteStr = atob(parts[1])
      const ab = new ArrayBuffer(byteStr.length)
      const ia = new Uint8Array(ab)
      for (let x = 0; x < byteStr.length; x++) ia[x] = byteStr.charCodeAt(x)
      const blob = new Blob([ab], { type: mimeType })
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
    } catch (err) {
      avisar('Erro ao abrir anexo: ' + (err.response?.data?.erro || err.message))
    }
  }

  const getIcon = (nome) => {
    if (!nome) return '📄'
    const ext = nome.split('.').pop().toLowerCase()
    if (ext === 'pdf') return '📕'
    if (['jpg','jpeg','png'].includes(ext)) return '🖼️'
    return '📄'
  }

  return (
    <>
      {/* Lista de anexos existentes */}
      {anexos.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          {onEnviarEmail && (
            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 8, marginBottom: 8 }}>
              <button type="button" className="btn btn-primary btn-sm" disabled={selecionados.size === 0}
                onClick={() => { onEnviarEmail(anexos.filter(a => selecionados.has(a.id))); setSelecionados(new Set()) }}>
                ✉ Enviar selecionados {selecionados.size > 0 ? `(${selecionados.size})` : ''}
              </button>
              {onEnviarWhatsApp && (
                <button type="button" className="btn btn-sm" disabled={selecionados.size === 0}
                  style={{ background: '#25D366', borderColor: '#25D366', color: '#fff' }}
                  onClick={() => { onEnviarWhatsApp(anexos.filter(a => selecionados.has(a.id))); setSelecionados(new Set()) }}>
                  WhatsApp {selecionados.size > 0 ? `(${selecionados.size})` : ''}
                </button>
              )}
            </div>
          )}
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <tbody>
              {anexos.map((a, i) => (
                <tr key={a.id || i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  {onEnviarEmail && (
                    <td style={{ padding: '8px 4px 8px 10px', width: 24 }}>
                      <input type="checkbox" checked={selecionados.has(a.id)} onChange={() => toggleSelecionado(a.id)} style={{ cursor: 'pointer' }} />
                    </td>
                  )}
                  <td style={{ padding: '8px 10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 11, background: 'var(--primary-light)', color: 'var(--primary)', padding: '3px 8px', borderRadius: 6, fontWeight: 500, flexShrink: 0 }}>
                        {a.tipo}
                      </span>
                      <span style={{ fontSize: 18 }}>{getIcon(a.nome)}</span>
                      <button type="button" onClick={() => visualizar(a)} style={{
                        background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                        fontSize: 12, color: 'var(--primary)', textDecoration: 'underline',
                        fontFamily: 'inherit', wordBreak: 'break-all', textAlign: 'left'
                      }}>
                        {a.nome}
                      </button>
                    </div>
                  </td>
                  <td style={{ padding: '8px 10px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button type="button" className="btn btn-secondary btn-sm btn-icon" title="Visualizar" style={{ color: 'var(--primary)' }} onClick={() => visualizar(a)}><IconVisualizar size={14} /></button>
                      <button type="button" className="btn btn-danger btn-sm btn-icon" title="Remover" onClick={() => remover(a.id)}><IconExcluir size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {anexos.length === 0 && !novoAnexo && (
        <div style={{ padding: 32, textAlign: 'center', color: '#aaa', background: '#f8f9fa', borderRadius: 8, marginBottom: 16 }}>
          Nenhum anexo adicionado ainda.
        </div>
      )}

      {/* Formulário de novo anexo */}
      {novoAnexo && (
        <div style={{ background: '#f8f9fa', border: '1px solid #e0e0e0', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 12 }}>Novo Anexo</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 200px', gap: 12, marginBottom: 12 }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Arquivo</label>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png"
                onChange={selecionarArquivo}
                style={{ fontSize: 13, padding: '6px 0', display: 'block', width: '100%' }} />
              {novoAnexo.arquivo && (
                <span style={{ fontSize: 11, color: '#3B6D11', marginTop: 4, display: 'block' }}>
                  ✓ {novoAnexo.arquivo.name}
                </span>
              )}
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Tipo do Documento</label>
              <select className="form-select" value={novoAnexo.tipo}
                onChange={e => setNovoAnexo(n => ({ ...n, tipo: e.target.value }))}>
                <option value="">Selecione...</option>
                {tiposAnexo.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" className="btn btn-primary btn-sm" onClick={confirmarAnexo} disabled={enviando}>{enviando ? 'Enviando...' : '✓ Salvar anexo'}</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNovoAnexo(null)}>Cancelar</button>
          </div>
        </div>
      )}

      {!novoAnexo && (
        <button type="button" className="btn btn-secondary" onClick={iniciarNovo}>
          + Adicionar novo anexo
        </button>
      )}

      <div style={{ marginTop: 12, fontSize: 11, color: '#aaa' }}>
        Formatos aceitos: PDF, JPG, PNG. Tamanho máximo: 5MB por arquivo.
      </div>
    </>
  )
}


// Ramos de seguro de pessoas: aliquota de IOF e 0,38% (fixa por lei), diferente dos 7,38% padrao
// dos demais ramos (bens/danos).
const RAMOS_IOF_038 = ['Vida Individual', 'Vida em Grupo', 'Acidentes Pessoais', 'Viagem']
const iofPadraoPorRamo = (ramo) => RAMOS_IOF_038.includes(ramo) ? '0,38' : '7,38'

const initForm = {
  status: 'em_analise', cliente_id: '', data_proposta: '', tipo_documento: 'Proposta', motivo: '',
  fase_documento: 'Proposta', documento_origem_id: null, documento_raiz_id: null,
  seguradora: '', ramo: '', numero_proposta: '', numero_apolice: '', link_assinatura: '',
  vigencia_inicio: '', vigencia_fim: '', forma_pagamento: 'Boleto',
  quantidade_parcelas: '', prazo_primeira_parcela: '', dia_fixo_parcelas: '',
  parcelas: [],
  premio_liquido: '', pl_duo: '', combinado_residencial: '', adicional: '', desconto: '', iof_pct: '7,38', iof_valor: '', premio_total: '', comissao_pct: '',
  valor_premio: '', comissao: '', forma_recebimento_comissao: 'À vista',
  parcelas_comissao: [],
  // Indicação: quem indicou o cliente (so pra proposta Novo/Renovação Externa)
  indicacao_cliente_id: null, indicacao_nome: '',
  // Itens Auto
  numero_apolice_renovada: '',
  item_numero: '', item_fipe: '', item_modelo: '', item_ano_fab: '', item_ano_mod: '',
  item_zero_km: 'Não', item_placa: '', item_chassi: '', item_cor: '',
  item_passageiros: '', item_combustivel: 'Flex', item_gnv: 'Não',
  item_bonus: '', item_codigo_ci: '',
  item_casco: 'Sem cobertura', item_pct_fipe: '', item_franquia: 'Obrigatória',
  item_rcf_mat: '', item_rcf_corp: '', item_danos_morais: '',
  item_app_morte: '', item_app_invalidez: '', item_app_dmh: '',
  item_assist24h: '', item_vidros: '', item_carro_reserva: '', item_obs: '',
  cond_nome: '', cond_cpf: '', cond_nascimento: '', cond_estado_civil: '',
  item_uso: '', item_uso_carga_tipo: '', item_condutores_jovens: '',
  // Emissão
  emissao_data: '', emissao_numero_apolice: '', emissao_numero_endosso: '', emissao_numero_apolice_duo: '',
  emissao_data_envio: '', emissao_forma_envio: [], emissao_obs: '',
  // Endosso
  endosso_observacao: '',
  eh_endosso: false,
}

const sec = (t) => (
  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.06em', margin: '0 0 12px', paddingBottom: 6, borderBottom: '2px solid var(--primary-light)' }}>{t}</div>
)

export default function Apolices({
  modalOnly = false,
  hideNavigation = false,
  initialDocument = null,
  initialFormOverrides = null,
  focarEmissao = false,
  focarEnvio = false,
  onCloseModal = null,
  onSaved = null,
  voltarLabel = 'Propostas'
} = {}) {
  const navigate = useNavigate()
  // So usado fora do modalOnly: quando alguem chega direto num documento vindo de outra tela (ex.:
  // botao Ver de Renovacoes.jsx), guarda pra onde o "‹ Voltar" deve navegar em vez de so fechar o
  // modal e mostrar a lista de /apolices (ver sessionStorage abrirApoliceId/voltarPara mais abaixo).
  const [voltarExterno, setVoltarExterno] = useState(null) // { path, label } | null
  const [apolices, setApolices] = useState([])
  const [clientes, setClientes] = useState([])
  const [seguradoras, setSeguradoras] = useState(seguradorasPadrao)
  const [parametrosComissao, setParametrosComissao] = useState([])
  const [modal, setModal] = useState(false)
  const [importando, setImportando] = useState(false)
  const pdfInputRef = useRef(null)
  const ultimoPdfImportadoRef = useRef(null)
  // Itens copiados pelo ultimo endossar() — lidos logo em seguida, antes do re-render atualizar itensParaCopiar
  const itensEndossoRef = useRef([])
  const [form, setForm] = useState(initForm)
  const [editId, setEditId] = useState(null)
  const editIdRef = useRef(null)
  const setEditIdSync = (id) => { editIdRef.current = id; setEditId(id) }
  const [loading, setLoading] = useState(false)
  // Volta de Sinistros/Assistencias (botao vermelho/amarelo da lista): restaura a busca digitada,
  // senao a lista (que abre vazia) sumiria.
  const [busca, setBusca] = useState(() => {
    const salva = hideNavigation ? null : sessionStorage.getItem('apolicesBuscaVoltar')
    if (salva === null) return ''
    sessionStorage.removeItem('apolicesBuscaVoltar')
    return salva
  })
  const [mostrarSugestoesBusca, setMostrarSugestoesBusca] = useState(false)
  const [filtroCliente, setFiltroCliente] = useState('')
  const [filtroApoliceId, setFiltroApoliceId] = useState('')
  const [usarFiltro, setUsarFiltro] = useState(() => !!lerFiltrosApolices().usarFiltro)
  const [filtros, setFiltros] = useState(() => {
    const salvos = lerFiltrosApolices().filtros || {}
    return Object.fromEntries(Object.entries(FILTROS_APOLICES_VAZIOS).map(([k, v]) => [k, salvos[k] ?? v]))
  })
  const setFiltroAv = (campo, valor) => setFiltros(f => ({ ...f, [campo]: valor }))
  const [sinistrosLista, setSinistrosLista] = useState([])
  const [assistenciasLista, setAssistenciasLista] = useState([])
  useEffect(() => {
    if (hideNavigation) return
    try { localStorage.setItem(CHAVE_FILTROS_APOLICES, JSON.stringify({ usarFiltro, filtros })) } catch { /* sem localStorage: so nao persiste */ }
  }, [usarFiltro, filtros, hideNavigation])
  // Sinistros/assistencias so pro filtro "Sinistro"/"Assistência" da consulta (nao na tela embutida)
  useEffect(() => {
    if (hideNavigation) return
    api.get('/sinistros').then(r => setSinistrosLista(Array.isArray(r.data) ? r.data : [])).catch(() => setSinistrosLista([]))
    api.get('/assistencias').then(r => setAssistenciasLista(Array.isArray(r.data) ? r.data : [])).catch(() => setAssistenciasLista([]))
  }, [hideNavigation])
  const [carregandoVer, setCarregandoVer] = useState(false)
  const [itensParaCopiar, setItensParaCopiar] = useState([])
  const [anexoPdfPendente, setAnexoPdfPendente] = useState(null)
  const [anexosRefreshKey, setAnexosRefreshKey] = useState(0)
  const [acoesAbertoId, setAcoesAbertoId] = useState(null)
  // Posicao do menu de Acoes em coordenadas de viewport (position:fixed) — nao pode ser
  // position:absolute relativo ao table-wrap porque esse (overflow-x:auto, que forca
  // overflow-y:auto tambem) corta o menu sempre que a tabela tem poucas linhas (ex.: busca
  // filtrando pra 1 resultado so): nem abrindo pra baixo nem pra cima sobra espaco dentro do
  // wrap pro menu inteiro. Fixed escapa desse clipping e usa a janela toda como referencia.
  const [acoesMenuPos, setAcoesMenuPos] = useState(null)
  const acoesMenuRef = useRef(null)
  const tableWrapRef = useRef(null)
  const emissaoCardRef = useRef(null)
  const numeroApoliceInputRef = useRef(null)
  const envioCardRef = useRef(null)
  const dataEnvioInputRef = useRef(null)
  // Veio da "Acompanhamento de Propostas" pelo botao Emitir: rola ate o card Dados de Emissão e
  // foca o campo Número da Apólice assim que o modal terminar de montar.
  useEffect(() => {
    if (!modal || !focarEmissao) return
    const t = setTimeout(() => {
      emissaoCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      numeroApoliceInputRef.current?.focus()
    }, 0)
    return () => clearTimeout(t)
  }, [modal, focarEmissao])

  useEffect(() => {
    if (!modal || !focarEnvio) return
    const timer = setTimeout(() => {
      envioCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      dataEnvioInputRef.current?.focus()
    }, 180)
    return () => clearTimeout(timer)
  }, [modal, focarEnvio])
  useEffect(() => {
    if (acoesAbertoId == null) return
    const handler = (e) => { if (acoesMenuRef.current && !acoesMenuRef.current.contains(e.target)) setAcoesAbertoId(null) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [acoesAbertoId])
  // Ordenacao inicial: fim de vigencia, da mais atual pra mais antiga — e o que mais importa pra
  // saber rapido o que esta prestes a vencer/ja venceu, sem precisar clicar na coluna toda vez.
  const [sortCol, setSortCol] = useState('vigencia')
  const [sortDir, setSortDir] = useState('desc')
  const toggleSort = (key) => {
    if (sortCol === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    else { setSortCol(key); setSortDir('asc') }
  }
  const [aba, setAba] = useState('dados')
  const [confirmacao, setConfirmacao] = useState(null) // { tipo: 'salvar' | 'cancelar' | 'fechar' }
  const [pedirSenhaMasterExcluir, setPedirSenhaMasterExcluir] = useState(false)
  const [formInicial, setFormInicial] = useState(null)
  const [historicoDocumentos, setHistoricoDocumentos] = useState([])
  const [emailModal, setEmailModal] = useState(null) // { anexo }
  const [whatsModal, setWhatsModal] = useState(null) // { anexos, telefones, telefone, texto, carregando, erro }
  const [erroEmail, setErroEmail] = useState('')
  const [emailEnviado, setEmailEnviado] = useState(false)
  const [emailTemplates, setEmailTemplates] = useState([])
  const [emailForm, setEmailForm] = useState({ templateId: '', destinatario: '', assunto: '', corpo: '' })
  const [enviandoEmail, setEnviandoEmail] = useState(false)
  const [itensParaEmail, setItensParaEmail] = useState([])
  const [seguradoraParaEmail, setSeguradoraParaEmail] = useState(null)
  const [clienteBusca, setClienteBusca] = useState('')
  const [mostrarSugestoesCliente, setMostrarSugestoesCliente] = useState(false)
  const [clienteImportadoPendente, setClienteImportadoPendente] = useState(null)
  const [indicacaoBusca, setIndicacaoBusca] = useState('')
  const [mostrarSugestoesIndicacao, setMostrarSugestoesIndicacao] = useState(false)

  // Colapsa espacos/quebras de linha em um so espaco: nomes importados de PDF (parser) as vezes
  // vem com \n embutido onde o nome quebrava de linha no documento original. Sem isso, o texto
  // digitado (so espacos) nunca bate com o nome cadastrado (com \n) e cliente_id fica vazio mesmo
  // com o campo mostrando o nome certo na tela — trava silenciosamente o salvamento de Itens/Anexos.
  const colapsarEspacos = (valor) => String(valor || '').replace(/\s+/g, ' ').trim()
  const normalizarTexto = (valor) => colapsarEspacos(valor).toLowerCase()
  const normalizarDocumento = (valor) => String(valor || '').replace(/\D/g, '')
  const montarClienteImportadoPendente = (data, nomeFallback = '') => ({
    nome: data.cliente_nome || nomeFallback || '',
    cpf_cnpj: data.cliente_cpf || '',
    sexo: data.cliente_sexo || '',
    data_nascimento: data.cliente_data_nascimento || '',
    rg: data.cliente_rg || '',
    estado_civil: data.cliente_estado_civil || '',
    profissao: data.cliente_profissao || '',
    cep: data.cliente_cep || '',
    endereco: data.cliente_endereco || '',
    numero: data.cliente_numero || '',
    complemento: data.cliente_complemento || '',
    bairro: data.cliente_bairro || '',
    cidade: data.cliente_cidade || '',
    estado: data.cliente_estado || '',
    telefones: data.cliente_telefone ? [{ numero: data.cliente_telefone, nome: '' }] : undefined,
    emails: data.cliente_email ? [data.cliente_email] : undefined
  })

  const clientesFiltrados = (() => {
    const termo = normalizarTexto(clienteBusca)
    const termoDoc = normalizarDocumento(clienteBusca)
    if (!termo && !termoDoc) return []

    return clientes
      .map(cliente => {
        const nome = normalizarTexto(cliente.nome)
        const cpf = normalizarDocumento(cliente.cpf_cnpj)
        let prioridade = -1

        if (termo && nome.startsWith(termo)) prioridade = 0
        else if (termo && nome.split(/\s+/).some(parte => parte.startsWith(termo))) prioridade = 1
        else if (termoDoc && cpf.startsWith(termoDoc)) prioridade = 2
        else if (termo && nome.includes(termo)) prioridade = 3

        return { cliente, prioridade }
      })
      .filter(item => item.prioridade >= 0)
      .sort((a, b) => {
        if (a.prioridade !== b.prioridade) return a.prioridade - b.prioridade
        return String(a.cliente.nome || '').localeCompare(String(b.cliente.nome || ''))
      })
      .slice(0, 8)
      .map(item => item.cliente)
  })()

  const indicacoesFiltradas = (() => {
    const termo = normalizarTexto(indicacaoBusca)
    if (!termo) return []
    return clientes
      .filter(c => normalizarTexto(c.nome).includes(termo))
      .sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || '')))
      .slice(0, 8)
  })()

  // Preenche o form da Proposta com os dados vindos do backend (rota de regex ou o `dados`
  // ja mesclado do piloto de IA — mesmo formato). Resolve/cria o cliente pelo CPF antes.
  // baseForm: quando informado (ex.: endosso sugerido pela importacao de PDF, ver
  // handleImportarPdf), os dados extraidos sao mesclados sobre ESSE form em vez do `form` atual do
  // componente — necessario porque `form` so reflete o resultado de um `setForm` anterior (ex.:
  // endossar()) no proximo render, nao de forma sincrona dentro do mesmo `await`.
  const preencherFormularioComDados = async (data, baseForm) => {
    const base = baseForm || form
    const cpfImportado = normalizarDocumento(data.cliente_cpf || '')
    const clientePorCpf = (!data.cliente_id && cpfImportado)
      ? clientes.find(c => normalizarDocumento(c.cpf_cnpj) === cpfImportado)
      : null
    let clienteResolvidoId = data.cliente_id || clientePorCpf?.id || ''
    let nomeResolvido = data.cliente_nome || clientePorCpf?.nome || ''
    let clienteImportado = montarClienteImportadoPendente(data, nomeResolvido)

    // Nenhum cliente com esse CPF ja cadastrado: cadastra automaticamente com os dados que o
    // PDF trouxe (nome + CPF sao obrigatorios pro cadastro), em vez de deixar o Segurado
    // pendente esperando o usuario lembrar de clicar em "+ Novo Cliente" antes de salvar.
    if (!clienteResolvidoId && clienteImportado.nome?.trim() && clienteImportado.cpf_cnpj?.trim()) {
      try {
        const { data: novoCliente } = await api.post('/clientes', clienteImportado)
        clienteResolvidoId = novoCliente.id
        nomeResolvido = novoCliente.nome
        setClientes(prev => [...prev, novoCliente])
        clienteImportado = null
      } catch {
        // CPF invalido, duplicado ou outro erro de validacao — cai no fluxo manual de sempre
        // (campo "Cliente não cadastrado" + botão "+ Novo Cliente").
      }
    }
    ultimoPdfImportadoRef.current = data
    // Usa o `base` (o `form` atual, ou o form recem-montado por quem chamou — ver comentario da
    // assinatura da funcao) e nao uma funcao de atualizacao, porque o resultado tambem e devolvido
    // pra quem chamou criar a proposta/item na hora, sem esperar o re-render refletir o setForm.
    const merged = {
      ...base,
      seguradora: data.seguradora || base.seguradora,
      ramo: data.ramo || base.ramo,
      numero_proposta: data.numero_proposta || base.numero_proposta,
      // Proposta de endosso traz o nº da apolice endossada (ex.: HDI "Endosso da Apólice 800781")
      numero_apolice: base.numero_apolice || data.numero_apolice || '',
      vigencia_inicio: data.vigencia_inicio || base.vigencia_inicio,
      vigencia_fim: data.vigencia_fim || base.vigencia_fim,
      forma_pagamento: data.forma_pagamento || base.forma_pagamento,
      // "Sem cobrança" (premio zerado no PDF, ver enriquecerDados no backend): sem parcelas
      quantidade_parcelas: data.forma_pagamento === 'Sem cobrança' ? '' : (data.quantidade_parcelas || base.quantidade_parcelas),
      dia_fixo_parcelas: data.dia_fixo_parcelas || base.dia_fixo_parcelas,
      premio_liquido: data.premio_liquido || base.premio_liquido,
      iof_pct: ['', '7,38', '0,38'].includes(base.iof_pct) ? iofPadraoPorRamo(data.ramo || base.ramo) : base.iof_pct,
      iof_valor: data.iof_valor || base.iof_valor,
      premio_total: data.premio_total || base.premio_total,
      cliente_id: clienteResolvidoId || base.cliente_id,
      parcelas: data.forma_pagamento === 'Sem cobrança' ? [] : (data.parcelas && data.parcelas.length > 0 ? data.parcelas : base.parcelas),
      item_modelo: data.item_modelo || base.item_modelo,
      item_ano_fab: data.item_ano_fab || base.item_ano_fab,
      item_ano_mod: data.item_ano_mod || base.item_ano_mod,
      item_placa: data.item_placa || base.item_placa,
      item_chassi: data.item_chassi || base.item_chassi,
      item_fipe: data.item_fipe || base.item_fipe,
      item_passageiros: data.item_passageiros || base.item_passageiros,
      item_zero_km: data.item_zero_km || base.item_zero_km,
      item_combustivel: data.item_combustivel || base.item_combustivel,
      item_gnv: data.item_gnv || base.item_gnv,
      item_bonus: data.item_bonus || base.item_bonus,
      item_codigo_ci: data.item_codigo_ci || base.item_codigo_ci,
      item_casco: data.item_casco || base.item_casco,
      item_rcf_corp: data.item_rcf_corp != null ? data.item_rcf_corp : base.item_rcf_corp,
      item_rcf_mat: data.item_rcf_mat != null ? data.item_rcf_mat : base.item_rcf_mat,
      item_app_morte: data.item_app_morte != null ? data.item_app_morte : base.item_app_morte,
      item_app_invalidez: data.item_app_invalidez != null ? data.item_app_invalidez : base.item_app_invalidez,
      item_obs: data.item_obs || base.item_obs,
      cond_nome: data.cond_nome || base.cond_nome,
      cond_cpf: data.cond_cpf || base.cond_cpf,
      cond_nascimento: data.cond_nascimento || base.cond_nascimento,
      cond_estado_civil: data.cond_estado_civil || base.cond_estado_civil,
      item_uso: data.item_uso || base.item_uso,
      item_uso_carga_tipo: data.item_uso_carga_tipo || base.item_uso_carga_tipo,
      item_condutores_jovens: data.item_condutores_jovens || base.item_condutores_jovens,
      // Local segurado (Residencial/Empresarial) — so vai pro item, o backend da apolice ignora
      ...Object.fromEntries(['res_cep', 'res_endereco', 'res_numero', 'res_complemento', 'res_bairro', 'res_cidade', 'res_estado', 'res_construcao', 'res_tipo', 'res_uso', 'res_atividade']
        .map(c => [c, data[c] || base[c] || ''])),
      coberturas_dinamicas: data.coberturas_dinamicas || base.coberturas_dinamicas,
      // Auto + Residencial (Proteção Combinada/DUO) — so vai pro item, como os res_*
      combinado_residencial: data.combinado_residencial || base.combinado_residencial || '',
      coberturas_residencial: data.coberturas_residencial || base.coberturas_residencial || {},
      data_proposta: data.data_proposta || base.data_proposta,
      // Renovacao interna / Refeito: o backend casou a apolice anterior impressa no PDF com uma
      // apolice do mesmo cliente (importar_pdf.js > vincularApoliceAnterior) — mesmo vinculo do "Renovar".
      ...(data.documento_origem_id ? {
        motivo: data.motivo || base.motivo,
        numero_apolice_renovada: data.numero_apolice_renovada || base.numero_apolice_renovada,
        documento_origem_id: data.documento_origem_id,
        documento_raiz_id: data.documento_raiz_id || data.documento_origem_id
      } : {}),
      // Sem vinculo: o leitor classifica Novo x Renovação Externa (pelo bonus). Nao mexe num
      // documento que ja nasceu vinculado (ex.: aberto pelo "Renovar") nem num endosso.
      ...(!data.documento_origem_id && data.motivo && !base.documento_origem_id && !base.eh_endosso
        ? { motivo: data.motivo } : {}),
      adicional: data.adicional || base.adicional,
      // HDI DUO: premio liquido do residencial combinado (soma com o do Auto nos calculos)
      pl_duo: data.pl_duo || base.pl_duo,
      combinado_residencial: data.combinado_residencial || base.combinado_residencial,
      comissao_pct: data.comissao_pct || base.comissao_pct,
      prazo_primeira_parcela: data.prazo_primeira_parcela || base.prazo_primeira_parcela,
      comissao: (() => {
        const pl = parseMoney(data.premio_liquido) + parseMoney(data.pl_duo)
        const pct = parsePct(data.comissao_pct)
        // !== 0 (nao > 0): premio liquido negativo (endosso com restituicao) tem que refletir
        // numa comissao tambem negativa, nao ficar zerada — mesmo criterio de `calcularValores`.
        const val = pl !== 0 && pct > 0 ? pl * (pct / 100) : 0
        return val !== 0 ? formatMoney(val) : base.comissao
      })(),
      forma_recebimento_comissao: (() => {
        const pl = parseMoney(data.premio_liquido) + parseMoney(data.pl_duo)
        const pct = parsePct(data.comissao_pct)
        const val = pl !== 0 && pct > 0 ? pl * (pct / 100) : 0
        return val < 0 ? 'Restituição' : base.forma_recebimento_comissao
      })(),
    }
    // Recalcula as parcelas aqui (nao so via setField) porque o fluxo de importacao com tudo ja
    // resolvido (criarApoliceEItemDoImport) salva a proposta direto, sem passar pelos gatilhos
    // manuais do form — sem isso as regras de vencimento por forma de pagamento (Azul/Porto,
    // ver gerarParcelas) nunca rodariam nesse caminho.
    const recalculado = recalcular(merged)
    // Valor de cada parcela impresso no PDF prevalece sobre o total / quantidade do recalculo.
    if (Array.isArray(data.parcelas) && data.parcelas.length === recalculado.parcelas.length) {
      recalculado.parcelas = recalculado.parcelas.map((p, i) => data.parcelas[i]?.valor ? { ...p, valor: data.parcelas[i].valor } : p)
    }
    setForm(recalculado)
    if (clienteResolvidoId) {
      setClienteImportadoPendente(null)
    } else {
      setClienteImportadoPendente(clienteImportado)
    }
    setClienteBusca(colapsarEspacos(nomeResolvido) || 'Cliente não cadastrado')
    return recalculado
  }

  // Sobe o PDF importado como anexo tipo "Proposta" (mesmo formato que AnexosAba usa pro anexo
  // manual). So funciona com um apoliceId ja existente - documento novo ainda sem id fica com o
  // arquivo guardado em anexoPdfPendente ate ser salvo.
  const enviarAnexoProposta = async (aid, file) => {
    try {
      const dados = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = ev => resolve(ev.target.result)
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
      await api.post(`/apolices/${aid}/anexos`, { tipo: 'Proposta', nome: file.name, tamanho: file.size, dados })
      setAnexosRefreshKey(k => k + 1)
    } catch {
      // Falha silenciosa: o PDF ja preencheu o formulario, usuario pode anexar manualmente se precisar.
    }
  }

  // Cria a proposta, o item (Automóvel/Carta Verde, com as coberturas extraidas) e anexa o
  // proprio PDF, tudo de uma vez, logo apos a leitura — sem esperar o usuario clicar em
  // "+ Adicionar Item" ou "Salvar". So roda quando o Segurado/Seguradora/Ramo ja vieram
  // resolvidos do PDF (mesma exigencia de salvarApoliceAutomatico).
  const criarApoliceEItemDoImport = async (merged, file, itensOrigem = itensParaCopiar) => {
    try {
      const dadosApolice = {
        ...merged,
        valor_premio: parseMoney(merged.valor_premio),
        comissao: parseMoney(merged.comissao),
        premio_liquido: parseMoney(merged.premio_liquido),
        pl_duo: parseMoney(merged.pl_duo),
        adicional: parseMoney(merged.adicional),
        desconto: parseMoney(merged.desconto),
        iof_valor: parseMoney(merged.iof_valor),
        premio_total: parseMoney(merged.premio_total)
      }
      const r = await api.post('/apolices', dadosApolice)
      const novoId = r.data?.id
      if (!novoId) return

      if (['Automóvel', 'Carta Verde', 'Residencial', 'Empresarial'].includes(merged.ramo)) {
        try {
          const { data: coberturas } = await api.get(`/coberturas/${encodeURIComponent(merged.seguradora)}/${encodeURIComponent(merged.ramo)}`)
          const listaCob = Array.isArray(coberturas) ? coberturas : []
          // Endosso puramente cadastral (ex.: so corrige endereco/dado do segurado) nao repete
          // dados de veiculo/coberturas no PDF — a oferta contratada continua sendo a mesma da
          // apolice/endosso de origem. Usa o item ja copiado por endossar() (itensParaCopiar) como
          // base nesse caso, em vez de criar um item do zero e deixar tudo em branco; o que o PDF
          // efetivamente trouxer ainda sobrescreve por cima, campo a campo, logo abaixo.
          const itemOriginal = itensOrigem[0]
          // Frota (ex.: Porto Auto Frota): o PDF traz um item por veiculo em `itens` — cria todos.
          // Os demais casos seguem com o item unico montado a partir dos campos item_* do topo.
          const itensPdf = ultimoPdfImportadoRef.current?.itens
          const fontes = Array.isArray(itensPdf) && itensPdf.length > 1 ? itensPdf.map(it => ({ ...merged, ...it })) : [merged]
          const montarItem = (fonte, original) => {
            const itemBase = original ? { ...initIF(merged.ramo), ...original } : initIF(merged.ramo)
            const camposTexto = ['Residencial', 'Empresarial'].includes(merged.ramo)
              ? ['res_cep', 'res_endereco', 'res_numero', 'res_complemento', 'res_bairro', 'res_cidade', 'res_estado', 'res_construcao', 'res_tipo', 'res_uso', 'res_atividade', 'item_obs']
              : ['item_fipe', 'item_modelo', 'item_ano_fab', 'item_ano_mod', 'item_zero_km', 'item_placa', 'item_chassi', 'item_passageiros', 'item_combustivel', 'item_gnv', 'item_bonus', 'item_codigo_ci', 'item_casco', 'item_obs', 'cond_nome', 'cond_cpf', 'cond_nascimento', 'cond_estado_civil', 'item_uso', 'item_uso_carga_tipo', 'item_condutores_jovens']
            camposTexto.forEach(c => { if (fonte[c]) itemBase[c] = fonte[c] })
            if (fonte.combinado_residencial && RAMOS_AUTO_COMBINADO.includes(merged.ramo)) {
              itemBase.combinado_residencial = fonte.combinado_residencial
              itemBase.coberturas_residencial = fonte.coberturas_residencial || {}
              CAMPOS_LOCAL_RISCO.forEach(c => { if (fonte[c]) itemBase[c] = fonte[c] })
            }
            // Endosso de substituicao de veiculo: o carro do item copiado sai inteiro, inclusive
            // campo que o PDF do carro novo nao traz (ex.: 0Km ainda sem placa — fica em branco,
            // nunca com a placa do carro antigo). Vale quando o leitor marca a substituicao ou
            // quando o chassi do PDF e' diferente do chassi do item copiado (qualquer seguradora).
            const chassiTrocado = original && fonte.item_chassi && original.item_chassi &&
              String(fonte.item_chassi).toUpperCase() !== String(original.item_chassi).toUpperCase()
            if (ultimoPdfImportadoRef.current?.endosso_substituicao_veiculo || chassiTrocado) {
              CAMPOS_VEICULO_SUBSTITUICAO.forEach(c => { itemBase[c] = fonte[c] || initIF(merged.ramo)[c] })
            }
            const camposMoeda = ['item_rcf_mat', 'item_rcf_corp', 'item_app_morte', 'item_app_invalidez']
            camposMoeda.forEach(c => { if (fonte[c] != null && fonte[c] !== '') itemBase[c] = fmtMoney(fonte[c]) })
            const vals = {}
            listaCob.forEach(c => {
              const valorOriginal = pegarCobertura(original?.coberturas_dinamicas, c.campo)
              vals[c.campo] = (valorOriginal !== undefined && valorOriginal !== null) ? valorOriginal : ''
            })
            if (fonte.coberturas_dinamicas && typeof fonte.coberturas_dinamicas === 'object') {
              listaCob.forEach(c => {
                const v = pegarCobertura(fonte.coberturas_dinamicas, c.campo)
                if (v !== undefined && v !== null && v !== '') vals[c.campo] = c.tipo === 'moeda' ? fmtMoney(v) : v
              })
              const casco = fonte.coberturas_dinamicas['Valor do Casco'] ?? original?.coberturas_dinamicas?.['Valor do Casco']
              if (casco) vals['Valor do Casco'] = fmtMoney(casco)
            } else {
              listaCob.forEach(c => {
                const v = valorLegado(fonte, c.campo)
                if (v !== undefined && v !== '') vals[c.campo] = v
              })
            }
            return { ...itemBase, apolice_id: novoId, coberturas_dinamicas: vals }
          }
          if (ultimoPdfImportadoRef.current?.endosso_frota && Array.isArray(itensPdf) && merged.eh_endosso) {
            // Endosso de frota: repete os itens da origem e aplica exclusao/inclusao/alteracao do PDF.
            for (const { original, fonte } of montarItensEndossoFrota(itensOrigem, itensPdf)) {
              if (!fonte) {
                const { id, apolice_id, created_at, ...resto } = original
                await api.post('/itens', { ...resto, apolice_id: novoId })
              } else {
                await api.post('/itens', {
                  ...montarItem(fonte, original),
                  descricao_item: original?.descricao_item && !fonte.item_modelo ? original.descricao_item : (fonte.item_modelo || fonte.item_placa || '')
                })
              }
            }
          } else {
            for (const fonte of fontes) {
              await api.post('/itens', montarItem(fonte, fontes.length > 1 ? null : itemOriginal))
            }
          }
          if (itemOriginal) setItensParaCopiar([])
        } catch {
          // Falha silenciosa: usuario ainda pode clicar em "+ Adicionar Item" manualmente.
        }
      } else if (itensOrigem.length > 0) {
        // Outros ramos (endosso): o PDF nao traz item — copia os do documento de origem como estao.
        await Promise.all(itensOrigem.map(({ id, apolice_id, created_at, ...resto }) =>
          api.post('/itens', { ...resto, apolice_id: novoId }).catch(() => {})))
        setItensParaCopiar([])
      }

      if (file) await enviarAnexoProposta(novoId, file)

      // So atualiza o id do documento (o que faz Itens/Anexos buscarem do servidor) depois que
      // item e anexo ja foram criados, pra abrir a proposta ja mostrando tudo pronto.
      setEditIdSync(novoId)
    } catch (err) {
      avisar('Erro ao salvar proposta automaticamente: ' + (err.response?.data?.erro || err.message))
    }
  }

  // Fluxo de sempre pra PDF de proposta (nao endosso): preenche o form e ja salva se Segurado/
  // Seguradora/Ramo vieram resolvidos, ou guarda o PDF pendente senao. Extraido do handleImportarPdf
  // original pra ser reaproveitado tambem quando o usuario recusa a sugestao de Endosso.
  const preencherEDecidirSalvar = async (data, file) => {
    const merged = await preencherFormularioComDados(data)
    if (editIdRef.current) {
      // Documento ja existe (edicao): so precisa anexar o PDF, o form ja foi atualizado.
      await enviarAnexoProposta(editIdRef.current, file)
    } else if (merged.cliente_id && merged.seguradora && merged.ramo) {
      // Documento novo com Segurado/Seguradora/Ramo resolvidos: ja salva tudo.
      await criarApoliceEItemDoImport(merged, file)
    } else {
      // Segurado ainda pendente (CPF nao bateu e nao deu pra cadastrar sozinho): guarda o PDF
      // pra anexar quando o usuario resolver o Segurado e salvar manualmente.
      setAnexoPdfPendente(file)
      // Frota com varios veiculos: deixa os itens na fila de pendentes (aparecem na aba Itens e
      // sao gravados no Salvar, ver copiarItensPendentes).
      if (Array.isArray(data.itens) && data.itens.length > 1) {
        setItensParaCopiar(data.itens.map(it => ({ ...initIF(merged.ramo), ...it, ramo: merged.ramo })))
      }
    }
  }

  const handleImportarPdf = async (file) => {
    if (!file) return
    setImportando(true)
    try {
      const formData = new FormData()
      formData.append('pdf', file)
      const { data } = await api.post('/apolices/importar-pdf', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      // Cliente ja cadastrado: confere se a proposta traz endereco/telefone/e-mail/estado civil/
      // profissao diferentes do cadastro e pergunta o que atualizar (pedido do usuario, 26/10).
      if (data.cliente_id) await conferirDadosCliente(data.cliente_id, data)
      if (form.eh_endosso && !editIdRef.current) {
        // Ja veio do botao "Endossar" (endosso ainda nao salvo): nao pergunta de novo. Salva o
        // endosso com o item copiado + o que o PDF trouxe (troca o carro na substituicao).
        const merged = await preencherFormularioComDados(data, form)
        await criarApoliceEItemDoImport(merged, file, itensParaCopiar)
        return
      }
      if (data.endosso_sugerido && !editIdRef.current) {
        // PDF parece ser um Endosso de uma apolice ja cadastrada (mesmo cliente+placa+seguradora
        // e mesma vigencia final) — nunca decide sozinho, pergunta antes de criar qualquer coisa.
        setConfirmacao({ tipo: 'endossoSugerido', data, endossoInfo: data.endosso_sugerido, file })
        return
      }
      if (data.endosso_sem_apolice && !editIdRef.current) {
        avisar(textoEndossoSemApolice(data), 'atencao')
        return
      }
      await preencherEDecidirSalvar(data, file)
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao ler o PDF. Verifique se é um PDF da Azul Seguros ou Porto Seguro.'
      avisar(msg, 'erro')
    } finally {
      setImportando(false)
    }
  }


  const fecharModal = () => {
    setModal(false)
    setMostrarSugestoesCliente(false)
    if (onCloseModal) onCloseModal()
    if (!hideNavigation && voltarExterno) {
      const destino = voltarExterno.path
      setVoltarExterno(null)
      navigate(destino)
    }
  }

  const carregar = () => {
    return Promise.all([
      api.get('/apolices'),
      api.get('/clientes'),
      api.get('/cadastro/seguradoras'),
      api.get('/cadastro/parametros-comissao')
    ]).then(([apolicesRes, clientesRes, seguradorasRes, parametrosRes]) => {
      setApolices(apolicesRes.data)
      setClientes(clientesRes.data)
      setSeguradoras((seguradorasRes.data || []).map(item => item.nome))
      setParametrosComissao(Array.isArray(parametrosRes.data) ? parametrosRes.data : [])
      return { apolices: apolicesRes.data, clientes: clientesRes.data }
    })
  }

  const restaurarFormularioPendente = (raw, clientesLista = []) => {
    try {
      const pendente = JSON.parse(raw)
      const clienteCriadoId = sessionStorage.getItem('clienteCriadoId')
      if (clienteCriadoId) sessionStorage.removeItem('clienteCriadoId')
      const clienteCriado = clienteCriadoId
        ? clientesLista.find(c => String(c.id) === String(clienteCriadoId))
        : null

      setEditIdSync(pendente.editId || null)
      setHistoricoDocumentos([])
      setMostrarSugestoesCliente(false)
      setClienteImportadoPendente(clienteCriado ? null : (pendente.clienteImportadoPendente || null))
      setClienteBusca(colapsarEspacos(clienteCriado?.nome || pendente.clienteBusca || ''))
      setForm({
        ...initForm,
        ...(pendente.form || {}),
        cliente_id: clienteCriado?.id || pendente.form?.cliente_id || ''
      })
      setModal(true)
      setAba(pendente.aba || 'dados')
      return true
    } catch {
      return false
    }
  }

  const abrirCadastroCliente = () => {
    const nomeFallback = normalizarTexto(clienteBusca) === normalizarTexto('Cliente não cadastrado')
      ? ''
      : clienteBusca
    const clientePrefill = clienteImportadoPendente || montarClienteImportadoPendente(ultimoPdfImportadoRef.current || {}, nomeFallback)

    sessionStorage.setItem('novoCliente', '1')
    sessionStorage.setItem('voltarPara', '/apolices')
    sessionStorage.setItem('abrirNovaApolice', '1')
    sessionStorage.setItem('abrirApoliceAba', aba)
    sessionStorage.setItem('apoliceFormPendente', JSON.stringify({
      form,
      editId: editIdRef.current,
      aba,
      clienteBusca,
      clienteImportadoPendente
    }))

    if (clientePrefill?.nome || clientePrefill?.cpf_cnpj || clientePrefill?.sexo || clientePrefill?.data_nascimento) {
      sessionStorage.setItem('novoClientePrefill', JSON.stringify(clientePrefill))
    }
    else sessionStorage.removeItem('novoClientePrefill')

    navigate('/clientes', {
      state: {
        novoCliente: true,
        novoClientePrefill: clientePrefill,
        voltarPara: '/apolices'
      }
    })
  }

  const irParaCliente = () => {
    sessionStorage.setItem('abrirClienteId', String(form.cliente_id))
    if (hideNavigation) {
      sessionStorage.setItem('voltarPara', '/propostas')
      sessionStorage.setItem('voltarClienteLabel', 'Proposta')
      if (editIdRef.current) sessionStorage.setItem('reabrirPropostaId', String(editIdRef.current))
      else sessionStorage.removeItem('reabrirPropostaId')
    } else {
      sessionStorage.setItem('voltarPara', '/apolices')
      sessionStorage.setItem('voltarClienteLabel', 'Apólices')
      sessionStorage.removeItem('reabrirPropostaId')
      if (editIdRef.current) {
        sessionStorage.setItem('abrirApoliceId', String(editIdRef.current))
        sessionStorage.setItem('abrirApoliceAba', aba)
      } else {
        sessionStorage.removeItem('abrirApoliceId')
      }
    }
    navigate('/clientes')
  }

  // Status automatico: so promove PARA emitido/vencida/cancelada quando o Nº oficial e preenchido.
  // Antes disso, o status fica com o que o usuario escolheu manualmente (em_analise/pendente/
  // recusada — ver seletor de Status no card Dados) e nao e mais sobrescrito para 'pendente' so
  // por estar sem numero, como funcionava antes.
  // Para Endosso, quem indica "emitido" e o proprio Nº do Endosso, nao o Nº da Apólice (que so
  // reflete a apolice original, travado e ja preenchido desde a criacao do endosso).
  // Endosso de Cancelamento (tiposCancelamentoEndosso): ao ser emitido, o status vira 'cancelada'
  // automaticamente (apolice deixa de ter cobertura a partir da emissao).
  // 'cancelada' e 'recusada' sao terminais: uma vez nesses status, nunca mais e recalculado.
  useEffect(() => {
    if (!modal || form.status === 'cancelada' || form.status === 'recusada') return
    const numeroEmissao = form.eh_endosso ? form.emissao_numero_endosso : form.emissao_numero_apolice
    if (!numeroEmissao) return
    const ehEndossoCancelamento = form.eh_endosso && tiposCancelamentoEndosso.includes(form.motivo)
    const novo = ehEndossoCancelamento ? 'cancelada' : (form.vigencia_fim && new Date(form.vigencia_fim) < new Date() ? 'vencida' : 'emitido')
    if (novo !== form.status) setField('status', novo)
  }, [modal, form.eh_endosso, form.tipo_documento, form.motivo, form.emissao_numero_apolice, form.emissao_numero_endosso, form.vigencia_fim])

  // Salvar formInicial toda vez que o modal abre
  useEffect(() => {
    if (modal) {
      setFormInicial(JSON.stringify(form))
    }
  }, [modal])
  useEffect(() => {
    if (modalOnly) {
      carregar().then(({ clientes: listaClientes }) => {
        if (initialDocument) abrirModal(initialDocument)
        else {
          setEditIdSync(null)
          setAba('dados')
          setHistoricoDocumentos([])
          setForm({ ...initForm, ...(initialFormOverrides || {}) })
          // Se veio com cliente_id pre-preenchido (ex.: vindo do CRM), mostra o nome no campo de
          // busca tambem, nao so o id internamente.
          const clientePrefill = initialFormOverrides?.cliente_id
            ? listaClientes.find(c => String(c.id) === String(initialFormOverrides.cliente_id))
            : null
          setClienteBusca(colapsarEspacos(clientePrefill?.nome || ''))
          setModal(true)
        }
      })
      return
    }
    carregar().then(({ apolices, clientes }) => {
      const clienteId = sessionStorage.getItem('filtroClienteId')
      if (clienteId) { sessionStorage.removeItem('filtroClienteId'); setFiltroCliente(clienteId) }

      const apoliceIdFiltro = sessionStorage.getItem('filtroApoliceId')
      if (apoliceIdFiltro) { sessionStorage.removeItem('filtroApoliceId'); setFiltroApoliceId(apoliceIdFiltro) }

      const abrirNovaApolice = sessionStorage.getItem('abrirNovaApolice')
      if (abrirNovaApolice) {
        sessionStorage.removeItem('abrirNovaApolice')
        const abaInicial = sessionStorage.getItem('abrirApoliceAba') || 'dados'
        sessionStorage.removeItem('abrirApoliceAba')
        const formPendente = sessionStorage.getItem('apoliceFormPendente')
        if (formPendente) {
          sessionStorage.removeItem('apoliceFormPendente')
          if (restaurarFormularioPendente(formPendente, clientes)) return
        }
        abrirModal()
        setAba(abaInicial)
        return
      }

      const apoliceId = sessionStorage.getItem('abrirApoliceId')
      if (apoliceId) {
        sessionStorage.removeItem('abrirApoliceId')
        const abaInicial = sessionStorage.getItem('abrirApoliceAba') || 'dados'
        sessionStorage.removeItem('abrirApoliceAba')
        const voltarPara = sessionStorage.getItem('voltarPara')
        if (voltarPara) {
          sessionStorage.removeItem('voltarPara')
          const label = sessionStorage.getItem('voltarApoliceLabel')
          sessionStorage.removeItem('voltarApoliceLabel')
          setVoltarExterno({ path: voltarPara, label: label || 'Apólices' })
        }
        const apolice = apolices.find(a => String(a.id) === String(apoliceId))
        if (apolice) {
          abrirModal(apolice)
          setAba(abaInicial)
        }
      }
    })
  }, [])

  const abrirModal = (a = null) => {
    setItensParaCopiar([])
    setAnexoPdfPendente(null)
    setEditIdSync(a?.id || null)
    setAba('dados')
    setHistoricoDocumentos([])
    setMostrarSugestoesCliente(false)
    setClienteImportadoPendente(null)
    setClienteBusca(a?.cliente_id ? colapsarEspacos(clientes.find(c => String(c.id) === String(a.cliente_id))?.nome || a.cliente_nome || '') : '')
    setMostrarSugestoesIndicacao(false)
    setIndicacaoBusca(a?.indicacao_nome || '')
    setForm(a ? {
      status: a.status || 'em_analise',
      cliente_id: a.cliente_id || '',
      data_proposta: a.data_proposta?.split('T')[0] || '',
      tipo_documento: a.tipo_documento || 'Proposta',
      fase_documento: a.fase_documento || 'Proposta',
      documento_origem_id: a.documento_origem_id || null,
      documento_raiz_id: a.documento_raiz_id || null,
      motivo: a.motivo || '',
      seguradora: a.seguradora || '',
      ramo: a.ramo || '',
      numero_proposta: a.numero_proposta || '',
      numero_apolice: a.numero_apolice || '',
      link_assinatura: a.link_assinatura || '',
      vigencia_inicio: a.data_inicio?.split('T')[0] || '',
      vigencia_fim: a.data_vencimento?.split('T')[0] || '',
      forma_pagamento: a.forma_pagamento || 'Boleto',
      quantidade_parcelas: a.parcelas?.length ? String(a.parcelas.length) : '',
      prazo_primeira_parcela: a.prazo_primeira_parcela || '',
      dia_fixo_parcelas: a.dia_fixo_parcelas || '',
      parcelas: a.parcelas?.length ? a.parcelas : [],
      premio_liquido: a.premio_liquido ? formatMoney(a.premio_liquido) : '',
      pl_duo: Number(a.pl_duo) ? formatMoney(a.pl_duo) : '',
      combinado_residencial: a.combinado_residencial || '',
      adicional: a.adicional ? formatMoney(a.adicional) : '',
      desconto: a.desconto ? formatMoney(a.desconto) : '',
      iof_pct: a.iof_pct || '7,38',
      iof_valor: a.iof_valor ? formatMoney(a.iof_valor) : '',
      premio_total: a.premio_total ? formatMoney(a.premio_total) : '',
      comissao_pct: a.comissao_pct || '',
      valor_premio: a.valor_premio ? formatMoney(a.valor_premio) : '',
      comissao: a.comissao ? formatMoney(a.comissao) : '',
      forma_recebimento_comissao: a.forma_recebimento_comissao || 'À vista',
      parcelas_comissao: a.parcelas_comissao?.length ? a.parcelas_comissao : [],
      indicacao_cliente_id: a.indicacao_cliente_id || null,
      indicacao_nome: a.indicacao_nome || '',
      numero_apolice_renovada: a.numero_apolice_renovada || '',
      item_numero: a.item_numero || '', item_fipe: a.item_fipe || '',
      item_modelo: a.item_modelo || '', item_ano_fab: a.item_ano_fab || '',
      item_ano_mod: a.item_ano_mod || '', item_zero_km: a.item_zero_km || 'Não',
      item_placa: a.item_placa || '', item_chassi: a.item_chassi || '',
      item_cor: a.item_cor || '', item_passageiros: a.item_passageiros || '',
      item_combustivel: a.item_combustivel || 'Flex', item_gnv: a.item_gnv || 'Não',
      item_bonus: a.item_bonus || '', item_codigo_ci: a.item_codigo_ci || '',
      item_casco: a.item_casco || 'Sem cobertura', item_pct_fipe: a.item_pct_fipe || '',
      item_franquia: a.item_franquia || 'Obrigatória',
      item_rcf_mat: a.item_rcf_mat ? formatMoney(a.item_rcf_mat) : '',
      item_rcf_corp: a.item_rcf_corp ? formatMoney(a.item_rcf_corp) : '',
      item_danos_morais: a.item_danos_morais ? formatMoney(a.item_danos_morais) : '',
      item_app_morte: a.item_app_morte ? formatMoney(a.item_app_morte) : '',
      item_app_invalidez: a.item_app_invalidez ? formatMoney(a.item_app_invalidez) : '',
      item_app_dmh: a.item_app_dmh ? formatMoney(a.item_app_dmh) : '', item_assist24h: a.item_assist24h || '',
      item_vidros: a.item_vidros || '', item_carro_reserva: a.item_carro_reserva || '',
      item_obs: a.item_obs || '',
      emissao_data: a.emissao_data?.split('T')[0] || '',
      emissao_numero_apolice: a.emissao_numero_apolice || '',
      emissao_numero_apolice_duo: a.emissao_numero_apolice_duo || '',
      emissao_numero_endosso: a.emissao_numero_endosso || '',
      emissao_data_envio: a.emissao_data_envio?.split('T')[0] || '',
      emissao_forma_envio: a.emissao_forma_envio || [],
      emissao_obs: a.emissao_obs || '',
      endosso_observacao: a.endosso_observacao || '',
      eh_endosso: !!a.eh_endosso,
    } : initForm)
    if (a?.id) {
      api.get(`/apolices/${a.id}/historico`).then(r => setHistoricoDocumentos(r.data)).catch(() => setHistoricoDocumentos([]))
    }
    setModal(true)
  }

  // Acha o documento mais atual da familia (apolice-mae + endossos emitidos/cancelados/vencidos):
  // a ponta da cadeia, ou seja, o unico que ninguem mais referencia como documento_origem_id. Nao
  // usa created_at porque dados importados/migrados podem ter timestamps que nao refletem a ordem
  // real dos endossos. Inclui 'vencida' porque um endosso emitido com atraso (vigencia da apolice
  // ja tinha passado na hora de preencher o Nº do Endosso) tambem cai nesse status.
  const buscarPontaDaCadeia = (apoliceId) => {
    const familia = apolices.filter(a =>
      (String(a.documento_raiz_id) === String(apoliceId) || String(a.id) === String(apoliceId)) &&
      ['emitido', 'cancelada', 'vencida'].includes(a.status)
    )
    if (familia.length === 0) return apoliceId
    const idsComFilho = new Set(familia.map(a => String(a.documento_origem_id)).filter(Boolean))
    const ponta = familia.find(a => !idsComFilho.has(String(a.id)))
    return (ponta || familia[0]).id
  }

  // Gera um novo documento de Endosso a partir de uma apólice existente: segurado, seguradora,
  // ramo, nº da apólice e nº da apólice renovada sao copiados e travados (aditivo da mesma
  // apólice); vigência, valores, parcelas e emissão ficam em branco para o usuário preencher;
  // % comissão e os itens sao copiados como ponto de partida (editáveis).
  // Comeca como tipo_documento='Proposta' (aparece em "Acompanhamento de Propostas" como uma
  // proposta de endosso pendente) e so vira 'Endosso' quando o Nº do Endosso e preenchido —
  // eh_endosso marca o documento como endosso durante toda essa transicao.
  const endossar = async (apoliceId) => {
    setCarregandoVer(true)
    try {
      // O novo endosso parte do estado mais atual da familia (ultimo endosso ja emitido, se
      // houver — senao a propria apolice-mae): e o que esta valendo no seguro agora, nao
      // necessariamente os dados originais da apolice-mae. Varios endossos podem ter sido feitos;
      // o ultimo e quem manda.
      const baseId = buscarPontaDaCadeia(apoliceId)

      const [{ data: original }, itensRes] = await Promise.all([
        api.get(`/apolices/${baseId}`),
        api.get(`/itens/apolice/${baseId}`).catch(() => ({ data: [] }))
      ])
      setItensParaCopiar(Array.isArray(itensRes.data) ? itensRes.data : [])
      itensEndossoRef.current = Array.isArray(itensRes.data) ? itensRes.data : []
      setAnexoPdfPendente(null)
      setEditIdSync(null)
      setAba('dados')
      setHistoricoDocumentos([])
      setMostrarSugestoesCliente(false)
      setClienteImportadoPendente(null)
      setClienteBusca(colapsarEspacos(original.cliente_nome || clientes.find(c => String(c.id) === String(original.cliente_id))?.nome || ''))
      setIndicacaoBusca('')
      const novoForm = {
        ...initForm,
        cliente_id: original.cliente_id || '',
        seguradora: original.seguradora || '',
        ramo: original.ramo || '',
        numero_apolice: original.numero_apolice || '',
        numero_apolice_renovada: original.numero_apolice_renovada || '',
        vigencia_fim: original.data_vencimento?.split('T')[0] || '',
        tipo_documento: 'Proposta',
        iof_pct: iofPadraoPorRamo(original.ramo),
        eh_endosso: true,
        motivo: '',
        status: 'em_analise',
        forma_pagamento: 'Boleto',
        comissao_pct: original.comissao_pct || '',
        emissao_numero_apolice: original.emissao_numero_apolice || original.numero_apolice || '',
        documento_origem_id: original.id,
        documento_raiz_id: original.documento_raiz_id || original.id,
        fase_documento: 'Proposta'
      }
      setForm(novoForm)
      setModal(true)
      return novoForm
    } catch (err) {
      avisar('Erro ao gerar endosso: ' + (err.response?.data?.erro || err.message))
    } finally {
      setCarregandoVer(false)
    }
  }

  // Gera uma nova Proposta de Renovacao a partir de uma apolice existente: segurado, seguradora,
  // ramo e nº da apólice renovada sao copiados; vigência, nº apólice, valores, parcelas e emissão
  // ficam em branco pois a renovação normalmente sai com numero e condicoes novas da seguradora.
  // documento_origem_id/documento_raiz_id sao preenchidos direto (mesmo mecanismo do endosso), o
  // que faz a renovação aparecer agrupada logo abaixo da apólice original na lista.
  const renovar = async (apoliceId) => {
    setCarregandoVer(true)
    try {
      const baseId = buscarPontaDaCadeia(apoliceId)

      const [{ data: original }, itensRes] = await Promise.all([
        api.get(`/apolices/${baseId}`),
        api.get(`/itens/apolice/${baseId}`).catch(() => ({ data: [] }))
      ])
      setItensParaCopiar(Array.isArray(itensRes.data) ? itensRes.data : [])
      setAnexoPdfPendente(null)
      setEditIdSync(null)
      setAba('dados')
      setHistoricoDocumentos([])
      setMostrarSugestoesCliente(false)
      setClienteImportadoPendente(null)
      setClienteBusca(colapsarEspacos(original.cliente_nome || clientes.find(c => String(c.id) === String(original.cliente_id))?.nome || ''))
      // Nova vigencia comeca onde a anterior termina e dura mais um ano (mesmo dia/mes do ano
      // seguinte), seguindo a convencao usada pelas seguradoras (sem sobreposicao nem gap).
      let novaVigenciaInicio = ''
      let novaVigenciaFim = ''
      if (original.data_vencimento) {
        novaVigenciaInicio = original.data_vencimento.split('T')[0]
        const [y, m, d] = novaVigenciaInicio.split('-').map(Number)
        const fim = new Date(y, m - 1, d)
        fim.setFullYear(fim.getFullYear() + 1)
        novaVigenciaFim = `${fim.getFullYear()}-${String(fim.getMonth() + 1).padStart(2, '0')}-${String(fim.getDate()).padStart(2, '0')}`
      }
      setForm({
        ...initForm,
        cliente_id: original.cliente_id || '',
        seguradora: original.seguradora || '',
        ramo: original.ramo || '',
        numero_apolice_renovada: original.numero_apolice || original.emissao_numero_apolice || '',
        vigencia_inicio: novaVigenciaInicio,
        vigencia_fim: novaVigenciaFim,
        tipo_documento: 'Proposta',
        iof_pct: iofPadraoPorRamo(original.ramo),
        motivo: 'Renovação Interna',
        eh_endosso: false,
        status: 'em_analise',
        forma_pagamento: 'Boleto',
        comissao_pct: original.comissao_pct || '',
        documento_origem_id: original.id,
        documento_raiz_id: original.documento_raiz_id || original.id,
        fase_documento: 'Proposta'
      })
      setModal(true)
    } catch (err) {
      avisar('Erro ao gerar renovação: ' + (err.response?.data?.erro || err.message))
    } finally {
      setCarregandoVer(false)
    }
  }

  // Gera uma Nova Negociação no CRM ja com o segurado da apolice selecionada e o vinculo
  // apolice_origem_id (pra CRM.jsx buscar Nº da apólice/Seguradora/Prêmio Líquido/% Comissão/
  // Prêmio Total automaticamente quando o Tipo NAO for "Novo" — mesmo mecanismo usado pelo botao
  // "Gerar Card Renov." de Renovacoes.jsx, so que aqui o Tipo comeca em "Novo" e fica livre pro
  // usuario escolher (Endosso, Refeito, Renovação Interna...).
  const gerarCardCRM = (a) => {
    sessionStorage.setItem('crmFormPendente', JSON.stringify({
      cliente_id: a.cliente_id,
      etapa: 'prospeccao',
      ramo: a.ramo || 'Automóvel',
      tipo: 'Novo',
      observacoes: '',
      apolice_origem_id: a.id
    }))
    navigate('/crm')
  }

  const abrirDocumentoRelacionado = async (id) => {
    setCarregandoVer(true)
    try {
      const { data } = await api.get(`/apolices/${id}`)
      abrirModal(data)
    } catch (err) {
      avisar('Erro ao abrir documento: ' + (err.response?.data?.erro || err.message))
    } finally {
      setCarregandoVer(false)
    }
  }

  // Dados do documento aberto usados pra substituir as tags ({{nome}}, {{seguradora}}...) do
  // modelo de e-mail escolhido. Ver src/utils/emailTags.js pra lista completa de tags.
  const dadosParaTagsEmail = () => {
    const cliente = clientes.find(c => String(c.id) === String(form.cliente_id))
    const fmtD = (d) => d ? d.split('-').reverse().join('/') : ''
    const nomeCompleto = cliente?.nome || clienteBusca || ''
    return {
      nome: nomeCompleto,
      primeiro_nome: nomeCompleto.trim().split(/\s+/)[0] || '',
      cpf_cnpj: cliente?.cpf_cnpj || '',
      seguradora: form.seguradora || '',
      ramo: form.ramo || '',
      tipo_documento: form.eh_endosso ? 'Endosso' : (form.tipo_documento || ''),
      numero_apolice: form.numero_apolice || form.emissao_numero_apolice || '',
      numero_proposta: form.numero_proposta || '',
      link_assinatura: form.link_assinatura || '',
      vigencia_inicio: fmtD(form.vigencia_inicio),
      vigencia_fim: fmtD(form.vigencia_fim),
      premio_total: form.premio_total || '',
      item: construirTagItem(form.ramo, itensParaEmail[0]),
      ...dadosSeguradoraParaTags(seguradoraParaEmail),
    }
  }

  const abrirEnvioEmail = (anexos) => {
    if (!anexos || anexos.length === 0) { avisar('Selecione ao menos um anexo.'); return }
    const cliente = clientes.find(c => String(c.id) === String(form.cliente_id))
    setEmailForm({ templateId: '', destinatario: cliente?.emails?.[0] || '', assunto: '', corpo: '' })
    setErroEmail('')
    setEmailEnviado(false)
    setEmailModal({ anexos })
    if (emailTemplates.length === 0) {
      api.get('/email/templates').then(r => setEmailTemplates(Array.isArray(r.data) ? r.data : [])).catch(() => setEmailTemplates([]))
    }
    if (editId) {
      api.get(`/itens/apolice/${editId}`).then(r => setItensParaEmail(Array.isArray(r.data) ? r.data : [])).catch(() => setItensParaEmail([]))
    } else {
      setItensParaEmail([])
    }
    if (form.seguradora) {
      api.get('/cadastro/seguradoras').then(r => {
        const lista = Array.isArray(r.data) ? r.data : []
        setSeguradoraParaEmail(lista.find(s => s.nome === form.seguradora) || null)
      }).catch(() => setSeguradoraParaEmail(null))
    } else {
      setSeguradoraParaEmail(null)
    }
  }

  // WhatsApp Web nao aceita anexo pelo link de conversa: abre a conversa do cliente com o texto
  // pronto e baixa os PDFs selecionados pro corretor arrastar pra dentro dela.
  const abrirEnvioWhatsApp = async (anexos) => {
    if (!anexos || anexos.length === 0) { avisar('Selecione ao menos um anexo.'); return }
    const cliente = clientes.find(c => String(c.id) === String(form.cliente_id))
    // So os numeros marcados como WhatsApp no cadastro do cliente; sem nenhum marcado, mostra
    // todos (cadastros antigos ainda nao tem a marcacao).
    const todos = (cliente?.telefones || []).filter(t => t?.numero)
    const marcados = todos.filter(t => t.whatsapp)
    const telefones = marcados.length ? marcados : todos
    setWhatsModal({ anexos, telefones, semMarcado: todos.length > 0 && !marcados.length, telefone: telefones[0]?.numero || '', texto: '', templateId: '', carregando: true, erro: '' })
    const [seguradora, templates] = await Promise.all([
      form.seguradora
        ? api.get('/cadastro/seguradoras').then(r => (Array.isArray(r.data) ? r.data : []).find(s => s.nome === form.seguradora) || null).catch(() => null)
        : null,
      emailTemplates.length ? emailTemplates : api.get('/email/templates').then(r => Array.isArray(r.data) ? r.data : []).catch(() => []),
    ])
    if (!emailTemplates.length) setEmailTemplates(templates)
    const dados = { ...dadosParaTagsEmail(), ...dadosSeguradoraParaTags(seguradora) }
    setWhatsModal(m => m && ({ ...m, dados, carregando: false }))
  }

  // Sem modelo pre-selecionado (igual ao e-mail): o corretor escolhe na hora. Os modelos sao os
  // de e-mail, com as tags preenchidas e o HTML convertido pra texto de WhatsApp.
  // O modelo "Envio da Apólice" usa o mesmo texto do padrao (pedido do usuario 13/10) — o HTML do
  // e-mail convertido saia diferente.
  const aplicarModeloWhatsApp = (templateId) => {
    const tpl = emailTemplates.find(t => String(t.id) === String(templateId))
    if (!tpl) { setWhatsModal(m => ({ ...m, templateId: '', texto: '' })); return }
    const usaPadrao = (tpl.nome || '').trim().toLowerCase() === 'envio da apólice'
    setWhatsModal(m => ({
      ...m,
      templateId,
      texto: usaPadrao ? montarMensagemApoliceWhatsApp(m.dados) : ajustarModeloWhatsApp(htmlParaTextoWhatsApp(substituirTagsEmail(tpl.corpo, m.dados))),
    }))
  }

  const confirmarEnvioWhatsApp = async () => {
    const { anexos, telefone, texto } = whatsModal
    if (telefone.replace(/\D/g, '').length < 10) {
      setWhatsModal(m => ({ ...m, erro: 'Informe o celular com DDD.' }))
      return
    }
    if (!texto.trim()) {
      setWhatsModal(m => ({ ...m, erro: 'Selecione um modelo ou escreva a mensagem.' }))
      return
    }
    // Abre a aba antes de qualquer await (senao o navegador bloqueia como pop-up). Nome fixo
    // reaproveita a mesma aba do WhatsApp Web nos proximos envios.
    window.open(linkWhatsAppWeb(telefone, texto), 'whatsapp-web')
    try {
      for (const a of anexos) {
        const { data } = await api.get(`/apolices/anexos/${a.id}/dados`)
        const link = document.createElement('a')
        link.href = data.dados
        link.download = a.nome || 'apolice.pdf'
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
      setWhatsModal(null)
    } catch (err) {
      setWhatsModal(m => ({ ...m, erro: 'Erro ao baixar anexo: ' + (err.response?.data?.erro || err.message) }))
    }
  }

  const aplicarTemplateEmail = (templateId) => {
    const tpl = emailTemplates.find(t => String(t.id) === String(templateId))
    if (!tpl) { setEmailForm(f => ({ ...f, templateId: '' })); return }
    const dados = dadosParaTagsEmail()
    setEmailForm(f => ({
      ...f,
      templateId,
      assunto: substituirTagsEmail(tpl.assunto, dados),
      corpo: substituirTagsEmail(tpl.corpo, dados),
    }))
  }

  const enviarEmailAnexo = async () => {
    setErroEmail('')
    if (!emailForm.destinatario.trim() || !emailForm.assunto.trim()) {
      setErroEmail('Preencha o destinatário e o assunto.')
      return
    }
    setEnviandoEmail(true)
    try {
      await api.post('/email/enviar', {
        apoliceId: editId,
        anexoIds: emailModal.anexos.map(a => a.id),
        destinatario: emailForm.destinatario.trim(),
        assunto: emailForm.assunto,
        corpo: emailForm.corpo,
      })
      setEmailEnviado(true)
      setTimeout(() => setEmailModal(null), 1400)
    } catch (err) {
      setErroEmail(err.response?.data?.erro || err.message)
    } finally {
      setEnviandoEmail(false)
    }
  }

  const foiAlterado = () => {
    if (!formInicial) return false
    try {
      const atual = JSON.stringify(form)
      return atual !== formInicial
    } catch {
      return false
    }
  }

  // manter: 'datas' preserva os vencimentos ja preenchidos (so recalcula valores) e 'parcelas'
  // preserva as parcelas do premio inteiras — usados quando o campo alterado nao mexe em datas
  // (premio, comissao). Sem isso, mudar a comissao de um documento emitido regerava as datas por
  // vigencia + prazo + 30 dias e apagava os vencimentos lidos do PDF da apolice.
  const recalcular = (novoForm, manter = null) => {
    const valorTotal = parseMoney(novoForm.premio_total) || parseMoney(novoForm.valor_premio)
    // Se forma_pagamento mudou, atualiza forma nas parcelas existentes antes de regerar
    const parcelasBase = novoForm.parcelas.map(p => ({ ...p, forma_pagamento: novoForm.forma_pagamento }))
    let parcelas = gerarParcelas(
      novoForm.quantidade_parcelas, novoForm.vigencia_inicio,
      novoForm.prazo_primeira_parcela, novoForm.dia_fixo_parcelas,
      novoForm.forma_pagamento, valorTotal, parcelasBase,
      novoForm.seguradora, novoForm.data_proposta
    )
    if (manter && novoForm.parcelas.length === parcelas.length) {
      parcelas = manter === 'parcelas'
        ? novoForm.parcelas
        : parcelas.map((p, i) => novoForm.parcelas[i]?.vencimento ? { ...p, vencimento: novoForm.parcelas[i].vencimento } : p)
    }
    const comissaoVal = parseMoney(novoForm.comissao)
    const premioLiquidoNum = parseMoney(novoForm.premio_liquido) + parseMoney(novoForm.pl_duo)
    const parcelas_comissao = gerarParcelasComissao(
      novoForm.forma_recebimento_comissao, novoForm.quantidade_parcelas,
      comissaoVal, premioLiquidoNum, novoForm.parcelas_comissao, parcelas
    )
    return { ...novoForm, parcelas, parcelas_comissao }
  }

  const setField = (campo, valor) => {
    const novo = { ...form, [campo]: valor }
    const gatilhos = ['quantidade_parcelas','vigencia_inicio','prazo_primeira_parcela','dia_fixo_parcelas','forma_pagamento','premio_total','valor_premio','forma_recebimento_comissao','comissao','seguradora','data_proposta']
    const manter = ['forma_recebimento_comissao', 'comissao'].includes(campo) ? 'parcelas'
      : ['premio_total', 'valor_premio'].includes(campo) ? 'datas' : null
    if (gatilhos.includes(campo)) setForm(recalcular(novo, manter))
    else setForm(novo)
  }

  // Troca de Ramo ajusta o IOF padrao (0,38% em Vida Individual/Vida em Grupo/Acidentes
  // Pessoais/Viagem, 7,38% nos demais) — mas so quando o campo ainda esta num valor padrao (nao
  // pisa numa aliquota que o usuario tenha digitado manualmente).
  const onChangeRamo = (novoRamo) => {
    const eraPadrao = ['', '7,38', '0,38'].includes(form.iof_pct)
    if (eraPadrao) setForm(calcularValores('iof_pct', iofPadraoPorRamo(novoRamo), { ...form, ramo: novoRamo }))
    else setField('ramo', novoRamo)
  }

  // Forma de Recebimento da Comissão vem da tabela parametrizada em Cadastro > Comissão, buscada
  // por Seguradora + Ramo + Forma de Pagamento (do prêmio) + quantidade de parcelas — não é uma
  // porcentagem, é qual das opções (À vista/Parcelada/Esgotamento/...) se aplica a esse cenário.
  // So substitui automaticamente enquanto o campo ainda estiver no valor padrao ('À vista'), pelo
  // mesmo motivo do IOF em onChangeRamo: nao pisar numa escolha manual do corretor pra esse caso
  // especifico.
  useEffect(() => {
    if (!modal) return
    if (!form.seguradora || !form.ramo || !form.forma_pagamento || !form.quantidade_parcelas) return
    if (form.forma_recebimento_comissao !== 'À vista') return
    const parcela = parseInt(form.quantidade_parcelas, 10)
    if (!parcela) return
    // Empresarial ainda sem parametrizacao propria na seguradora: usa as regras do Automóvel
    // (pedido do usuario, provisorio) ate que o Empresarial seja cadastrado em Cadastro > Comissão.
    const temRamoProprio = parametrosComissao.some(p => p.seguradora === form.seguradora && p.ramo === form.ramo)
    const ramoRegra = form.ramo === 'Empresarial' && !temRamoProprio ? 'Automóvel' : form.ramo
    const parametro = parametrosComissao.find(p =>
      p.seguradora === form.seguradora && p.ramo === ramoRegra &&
      p.forma_pagamento === form.forma_pagamento && p.parcela === parcela
    )
    if (parametro?.forma_recebimento && parametro.forma_recebimento !== form.forma_recebimento_comissao) {
      setField('forma_recebimento_comissao', parametro.forma_recebimento)
    }
  }, [modal, form.seguradora, form.ramo, form.forma_pagamento, form.quantidade_parcelas, parametrosComissao])

  const setParcela = (i, campo, v) => {
    const p = [...form.parcelas]; p[i] = { ...p[i], [campo]: v }; setForm({ ...form, parcelas: p })
  }

  const addParcelaComissao = () => setForm(f => ({ ...f, parcelas_comissao: [...f.parcelas_comissao, { numero: f.parcelas_comissao.length + 1, data: '', valor: '', status: 'Pendente' }] }))
  const remParcelaComissao = i => setForm(f => ({ ...f, parcelas_comissao: f.parcelas_comissao.filter((_, idx) => idx !== i).map((p, idx) => ({ ...p, numero: idx + 1 })) }))
  const setParcelaComissao = (i, campo, v) => {
    const p = [...form.parcelas_comissao]; p[i] = { ...p[i], [campo]: v }; setForm({ ...form, parcelas_comissao: p })
  }

  // Campo PL DUO so aparece em documento HDI DUO (item com residencial combinado DUO) ou que ja tem valor
  const mostrarPlDuo = form.combinado_residencial === 'DUO' || parseMoney(form.pl_duo) !== 0

  const calcularValores = (campo, valor, base = form) => {
    const novo = { ...base, [campo]: valor }
    // PL DUO (HDI DUO, residencial combinado) soma com o liquido do Auto em IOF, total e comissao
    const pl = parseMoney(campo === 'premio_liquido' ? valor : novo.premio_liquido) + parseMoney(campo === 'pl_duo' ? valor : novo.pl_duo)
    const ad = parseMoney(campo === 'adicional' ? valor : novo.adicional)
    const desc = parseMoney(campo === 'desconto' ? valor : novo.desconto)
    const iofPct = parseFloat((campo === 'iof_pct' ? valor : novo.iof_pct || '0').replace(',', '.')) || 0
    // Restituicao (premio liquido negativo, endosso com devolucao ao segurado) nao tem cobranca
    // de IOF — fica zerado, mesmo que % IOF esteja preenchido.
    const iofVal = pl < 0 ? 0 : pl * (iofPct / 100)
    const total = pl + ad - desc + iofVal
    const comPct = parsePct(campo === 'comissao_pct' ? valor : novo.comissao_pct)
    const comVal = pl * (comPct / 100)
    const atualizado = {
      ...novo,
      // !== 0 (em vez de > 0): premio liquido negativo (endosso com restituicao ao segurado)
      // deve refletir em premio total e comissao tambem negativos, nao ficar em branco (IOF fica
      // zerado nesse caso, ver `iofVal` acima).
      iof_valor: iofVal !== 0 ? formatMoney(iofVal) : '',
      premio_total: total !== 0 ? formatMoney(total) : '',
      valor_premio: total !== 0 ? formatMoney(total) : '',
      comissao: comVal !== 0 ? formatMoney(comVal) : novo.comissao,
      // Comissao negativa (endosso com restituicao) tem que ser devolvida pra seguradora, nao
      // recebida — forca a Forma de Recebimento pra "Restituição" automaticamente, mesmo padrao
      // ja usado pra Forma de Pagamento da parcela do premio (ver `gerarParcelas`).
      forma_recebimento_comissao: comVal < 0 ? 'Restituição' : novo.forma_recebimento_comissao
    }
    return recalcular(atualizado, 'datas')
  }

  // Endosso de cancelamento (tiposCancelamentoEndosso) que esta virando 'cancelada' agora, com
  // parcelas ainda vincendas (nao pagas/nao canceladas): pergunta se as parcelas devem ser
  // canceladas junto (na maioria dos motivos) ou mantidas (ex.: Cancelamento por Sinistro, onde a
  // apolice sera quitada).
  const salvar = async (e) => {
    e.preventDefault()
    // cliente_id pode ficar vazio mesmo com o campo Segurado mostrando um nome na tela — ex.:
    // apos importar PDF de um cliente que ainda nao existe no cadastro ("Cliente não cadastrado").
    // Sem essa checagem o POST/PUT ia direto pro banco e estourava um 500 cru (coluna cliente_id
    // e INTEGER, nao aceita string vazia).
    if (!form.cliente_id) {
      avisar('Selecione ou cadastre o Segurado (Cliente) antes de salvar.')
      return
    }
    const statusInicial = formInicial ? JSON.parse(formInicial).status : null
    const virandoCancelamentoAgora = form.status === 'cancelada' && statusInicial !== 'cancelada'
    const temParcelaVincenda = form.parcelas.some(p => (p.status || 'Pendente') === 'Pendente')
    // Proposta Inicial ou de Renovacao recusada pode encerrar o vinculo com o cliente (o backend so
    // efetiva isso se ele nao tiver nenhum outro documento vigente) — avisa antes de salvar.
    const virandoRecusadaAgora = form.status === 'recusada' && statusInicial !== 'recusada'
    const podeEncerrarVinculo = virandoRecusadaAgora && !form.eh_endosso &&
      ['Novo', 'Renovação Interna', 'Renovação Externa'].includes(form.motivo)
    if (virandoCancelamentoAgora && temParcelaVincenda) {
      setConfirmacao({ tipo: 'salvarCancelamento' })
    } else if (podeEncerrarVinculo) {
      setConfirmacao({ tipo: 'salvarRecusa' })
    } else {
      setConfirmacao({ tipo: 'salvar' })
    }
  }

  // Copia os itens do documento de origem (endosso/renovacao) para o documento recem-criado e
  // limpa a fila de pendentes. Chamado tanto pelo "Salvar" principal quanto pelo salvamento
  // automatico disparado ao clicar "+ Adicionar Item" antes de salvar o documento.
  const copiarItensPendentes = async (novoId) => {
    if (itensParaCopiar.length > 0) {
      await Promise.all(itensParaCopiar.map(item => {
        const { id, apolice_id, created_at, ...resto } = item
        return api.post('/itens', { ...resto, apolice_id: novoId }).catch(() => {})
      }))
    }
    setItensParaCopiar([])
  }

  // Sobe o PDF importado (guardado em anexoPdfPendente enquanto o documento novo ainda nao tinha
  // id) assim que o documento e criado. Mesmos dois pontos de chamada que copiarItensPendentes.
  const enviarAnexoPdfPendente = async (novoId) => {
    if (anexoPdfPendente) {
      await enviarAnexoProposta(novoId, anexoPdfPendente)
      setAnexoPdfPendente(null)
    }
  }

  const salvarApoliceAutomatico = async () => {
    try {
      const dados = {
        ...form,
        valor_premio: parseMoney(form.valor_premio),
        comissao: parseMoney(form.comissao),
        premio_liquido: parseMoney(form.premio_liquido),
        pl_duo: parseMoney(form.pl_duo),
        adicional: parseMoney(form.adicional),
        desconto: parseMoney(form.desconto),
        iof_valor: parseMoney(form.iof_valor),
        premio_total: parseMoney(form.premio_total)
      }
      if (editId) {
        await api.put(`/apolices/${editId}`, dados)
        return editId
      } else {
        if (!form.cliente_id || !form.seguradora || !form.ramo) {
          avisar('Preencha o Segurado, Seguradora e Ramo no card Dados antes de adicionar itens.')
          return null
        }
        const r = await api.post('/apolices', dados)
        const novoId = r.data?.id
        if (novoId) {
          setEditIdSync(novoId)
          await copiarItensPendentes(novoId)
          await enviarAnexoPdfPendente(novoId)
        }
        return novoId
      }
    } catch (err) {
      avisar('Erro ao salvar apólice: ' + (err.response?.data?.erro || err.message))
      return null
    }
  }

  const executarSalvar = async (parcelasOverride) => {
    setConfirmacao(null)
    setLoading(true)
    try {
      const dados = {
        ...form,
        parcelas: parcelasOverride || form.parcelas,
        valor_premio: parseMoney(form.valor_premio),
        comissao: parseMoney(form.comissao),
        premio_liquido: parseMoney(form.premio_liquido),
        pl_duo: parseMoney(form.pl_duo),
        adicional: parseMoney(form.adicional),
        desconto: parseMoney(form.desconto),
        iof_valor: parseMoney(form.iof_valor),
        premio_total: parseMoney(form.premio_total)
      }
      const currentId = editIdRef.current
      if (currentId) {
        await api.put(`/apolices/${currentId}`, dados)
      } else {
        const resp = await api.post('/apolices', dados)
        const novoId = resp.data?.id
        if (novoId) {
          await copiarItensPendentes(novoId)
          await enviarAnexoPdfPendente(novoId)
        }
      }
      setConfirmacao(null)
      fecharModal()
      await carregar()
      if (onSaved) await onSaved()
    } catch (err) { avisar('Erro ao salvar: ' + (err.response?.data?.erro || err.message)) }
    finally { setLoading(false) }
  }

  const confirmarSalvar = () => executarSalvar()

  // cancelarParcelas=true: marca como 'Cancelada' toda parcela do premio ainda 'Pendente'
  // (parcelas vincendas). O backend, ao ver status='cancelada', propaga esse status para a
  // apolice-mae e todos os endossos anteriores da mesma cadeia (documento_raiz_id).
  const confirmarSalvarCancelamento = (cancelarParcelas) => {
    if (!cancelarParcelas) return executarSalvar()
    const parcelasCanceladas = form.parcelas.map(p =>
      (p.status || 'Pendente') === 'Pendente' ? { ...p, status: 'Cancelada' } : p
    )
    setForm(f => ({ ...f, parcelas: parcelasCanceladas }))
    executarSalvar(parcelasCanceladas)
  }

  const confirmarExcluirDocumento = async (senhaMaster) => {
    setLoading(true)
    try {
      await api.delete(`/apolices/${editId}`, { data: { senha_master: senhaMaster } })
      fecharModal()
      await carregar()
      if (onSaved) await onSaved()
    } finally {
      setLoading(false)
    }
  }

  const confirmarSairCliente = async (salvarAntes) => {
    if (salvarAntes) {
      setLoading(true)
      const ok = await salvarApoliceAutomatico()
      setLoading(false)
      if (!ok) return
    }
    setConfirmacao(null)
    irParaCliente()
  }

  const diasParaVencer = d => Math.ceil((new Date(d) - new Date()) / (1000 * 60 * 60 * 24))
  const statusLabel = (status) => {
    if (status === 'emitido') return { label: 'Emitido', cls: 'badge-green' }
    if (status === 'em_analise') return { label: 'Em Análise', cls: 'badge-blue' }
    if (status === 'pendente') return { label: 'Pendente', cls: 'badge-amber' }
    if (status === 'vencida') return { label: 'Vencida', cls: 'badge-amber' }
    if (status === 'recusada') return { label: 'Recusada', cls: 'badge-gray' }
    if (status === 'cancelada') return { label: 'Cancelada', cls: 'badge-red' }
    return { label: status || '—', cls: 'badge-gray' }
  }

  const colunasApolices = [
    { key: 'segurado',   label: 'Segurado',   get: a => a.cliente_nome || '' },
    { key: 'cpf',        label: 'CPF',         get: a => a.cliente_cpf_cnpj || '' },
    { key: 'tipo',       label: 'Tipo',        get: a => a.tipo_documento || '' },
    { key: 'seguradora', label: 'Seguradora', get: a => a.seguradora || '' },
    { key: 'ramo',       label: 'Ramo',        get: a => a.ramo || '' },
    { key: 'numero',     label: 'Nº da\nApólice', get: a => a.numero_apolice || a.emissao_numero_apolice || '' },
    { key: 'numero_endosso', label: 'Nº do\nEndosso', get: a => a.emissao_numero_endosso || '' },
    { key: 'vigencia',   label: 'Vigência',   get: a => a.data_vencimento || '', date: true },
    { key: 'premio',     label: 'Prêmio',      get: a => parseFloat(a.premio_total || a.valor_premio || 0), numeric: true },
    { key: 'status',     label: 'Status',      get: a => statusLabel(a.status).label },
  ]

  const faseLabel = (doc) => doc?.fase_documento || doc?.tipo_documento || 'Documento'

  const selecionarClientePorBusca = (valor) => {
    setClienteBusca(valor)
    setMostrarSugestoesCliente(true)
    const termo = normalizarTexto(valor)
    const termoDoc = valor.replace(/\D/g, '')
    if (!termo) {
      setField('cliente_id', '')
      return
    }
    const cliente = clientes.find(c =>
      normalizarTexto(c.nome) === termo ||
      normalizarTexto(c.nome).startsWith(termo) ||
      c.cpf_cnpj?.toLowerCase?.() === termo ||
      c.cpf_cnpj?.replace(/\D/g, '') === termoDoc ||
      normalizarTexto(`${c.nome} - ${c.cpf_cnpj || ''}`) === termo
    )
    if (cliente) setField('cliente_id', cliente.id)
    else setField('cliente_id', '')
  }

  const selecionarCliente = (cliente) => {
    setClienteBusca(colapsarEspacos(cliente.nome))
    setField('cliente_id', cliente.id)
    setMostrarSugestoesCliente(false)
    setClienteImportadoPendente(null)
  }

  // Indicação: aceita nome de cliente ja cadastrado (vincula indicacao_cliente_id) ou texto livre
  // (pessoa que indicou mas nao e cliente) — nesse caso so indicacao_nome fica preenchido.
  const selecionarIndicacaoPorBusca = (valor) => {
    setIndicacaoBusca(valor)
    setMostrarSugestoesIndicacao(true)
    const termo = normalizarTexto(valor)
    const cliente = termo ? clientes.find(c => normalizarTexto(c.nome) === termo) : null
    setForm(f => ({ ...f, indicacao_nome: valor, indicacao_cliente_id: cliente?.id || null }))
  }

  const selecionarIndicacao = (cliente) => {
    setIndicacaoBusca(colapsarEspacos(cliente.nome))
    setForm(f => ({ ...f, indicacao_nome: colapsarEspacos(cliente.nome), indicacao_cliente_id: cliente.id }))
    setMostrarSugestoesIndicacao(false)
  }

  const statusVenc = d => {
    const dias = diasParaVencer(d)
    if (dias < 0) return { label: 'Vencida', cls: 'badge-red' }
    if (dias <= 30) return { label: `Vence em ${dias}d`, cls: 'badge-amber' }
    return { label: 'Emitido', cls: 'badge-green' }
  }

  // status === 'cancelada' nao pode sumir da lista: um endosso de cancelamento so cancela depois
  // de ja ter sido emitido, entao a apolice/endosso continua aqui, so que com badge "Cancelada".
  // 'vencida' tambem nao pode sumir: uma apolice cujo Nº oficial e preenchido com a vigencia ja
  // encerrada (ex.: cadastro retroativo/teste) vira 'vencida' direto, sem nunca passar por
  // 'emitido' — precisa continuar aparecendo aqui, so que com o badge "Vencida".
  // Sinistro/assistencia ficam ligados a apolice ou a um endosso dela: sobe pelos endossos ate a
  // apolice (nao usa documento_raiz_id, que junta tambem as renovacoes de outros anos).
  const apolicePorIdLista = new Map(apolices.map(a => [String(a.id), a]))
  const apoliceBaseId = (id) => {
    let x = apolicePorIdLista.get(String(id))
    for (let i = 0; i < 50 && x && x.eh_endosso && x.documento_origem_id; i++) x = apolicePorIdLista.get(String(x.documento_origem_id)) || null
    return x ? String(x.id) : String(id)
  }
  const basesComSinistro = new Set(sinistrosLista.map(s => apoliceBaseId(s.apolice_id)))
  const basesComAssistencia = new Set(assistenciasLista.map(s => apoliceBaseId(s.apolice_id)))
  // Botao vermelho/amarelo da lista (mesmo da Renovacoes): abre o sinistro/assistencia mais recente
  // dessa apolice, com retorno pra ca.
  const abrirUltimoDaApolice = (lista, a, chaveId, chaveVoltar, rota) => {
    const base = apoliceBaseId(a.id)
    const alvo = lista.filter(s => apoliceBaseId(s.apolice_id) === base)
      .sort((x, y) => new Date(y.created_at) - new Date(x.created_at))[0]
    if (alvo) sessionStorage.setItem(chaveId, String(alvo.id))
    sessionStorage.setItem(chaveVoltar, '/apolices')
    sessionStorage.setItem('apolicesBuscaVoltar', busca)
    navigate(rota)
  }
  const filtroAvancadoAtivo = temCriterioApolices(filtros)
  const passaFiltroAvancado = (a) => {
    const f = filtros
    const d = (v) => (v ? String(v).slice(0, 10) : '')
    const data = d(a[f.periodoCampo])
    if (f.seguradoras.length && !f.seguradoras.includes(a.seguradora || '')) return false
    if (f.ramos.length && !f.ramos.includes(a.ramo || '')) return false
    if (f.status.length && !f.status.includes(a.status)) return false
    if (f.periodoDe && (!data || data < f.periodoDe)) return false
    if (f.periodoAte && (!data || data > f.periodoAte)) return false
    if (f.sinistro && basesComSinistro.has(apoliceBaseId(a.id)) !== (f.sinistro === 'com')) return false
    if (f.assistencia && basesComAssistencia.has(apoliceBaseId(a.id)) !== (f.assistencia === 'com')) return false
    return true
  }
  // Lista abre vazia: so aparece algo depois de buscar, filtrar ou vir de outra tela ja filtrado.
  const pesquisou = !!(busca.trim() || filtroCliente || filtroApoliceId || filtroAvancadoAtivo)
  const filtradas = !pesquisou ? [] : apolices.filter(a => {
    if (!['emitido', 'cancelada', 'vencida'].includes(a.status)) return false
    if (filtroCliente && String(a.cliente_id) !== String(filtroCliente)) return false
    if (filtroApoliceId && String(a.id) !== String(filtroApoliceId)) return false
    if (filtroAvancadoAtivo && !passaFiltroAvancado(a)) return false
    const q = busca.toLowerCase().trim()
    if (!q) return true
    const qRaw = q.replace(/\D/g, '')
    return a.cliente_nome?.toLowerCase().includes(q) ||
      (a.cliente_cpf_cnpj && (a.cliente_cpf_cnpj.includes(q) || (qRaw && a.cliente_cpf_cnpj.replace(/\D/g, '').includes(qRaw)))) ||
      a.numero_apolice?.toLowerCase().includes(q) ||
      a.emissao_numero_apolice?.toLowerCase().includes(q) ||
      a.numero_proposta?.toLowerCase().includes(q) ||
      a.emissao_numero_endosso?.toLowerCase().includes(q)
  })
  // Sugestoes do dropdown da busca: mostra so o dado que efetivamente bateu com o texto digitado
  // (nome, CPF/CNPJ ou numero), sem repetir a mesma apolice varias vezes por causa de endossos.
  // Clicar numa sugestao poe o valor exato na busca, o que filtra a tabela abaixo por ele.
  const sugestoesBusca = (() => {
    const q = busca.toLowerCase().trim()
    if (!q) return []
    const qRaw = q.replace(/\D/g, '')
    const vistos = new Set()
    const sugestoes = []
    for (const a of filtradas) {
      let valor = null
      if (a.cliente_nome?.toLowerCase().includes(q)) valor = a.cliente_nome
      else if (a.cliente_cpf_cnpj && (a.cliente_cpf_cnpj.includes(q) || (qRaw && a.cliente_cpf_cnpj.replace(/\D/g, '').includes(qRaw)))) valor = a.cliente_cpf_cnpj
      else if (a.numero_apolice?.toLowerCase().includes(q)) valor = a.numero_apolice
      else if (a.emissao_numero_apolice?.toLowerCase().includes(q)) valor = a.emissao_numero_apolice
      else if (a.numero_proposta?.toLowerCase().includes(q)) valor = a.numero_proposta
      else if (a.emissao_numero_endosso?.toLowerCase().includes(q)) valor = a.emissao_numero_endosso
      if (valor && !vistos.has(valor)) { vistos.add(valor); sugestoes.push(valor) }
      if (sugestoes.length >= 8) break
    }
    return sugestoes.map(valor => ({ chave: valor, valor }))
  })()
  const navBusca = useNavegacaoLista(sugestoesBusca.length, (i) => { setMostrarSugestoesBusca(false); setBusca(sugestoesBusca[i].valor) })
  const filtradasOrdenadasBase = sortRows(filtradas, colunasApolices, sortCol, sortDir)
  // Um endosso (eh_endosso=true) sempre aparece logo abaixo da apolice-mae, mesmo com uma
  // ordenacao de coluna ativa — a ordenacao decide a posicao do grupo (apolice-mae + seus
  // endossos), nao a posicao de cada endosso isoladamente. Endossos entre si ficam em ordem
  // cronologica de emissao (o mais recente e o que esta valendo no seguro). Renovacao NAO agrupa
  // aqui: tem vigencia propria e nova, entao aparece como linha independente, ordenada pela sua
  // propria vigencia (o vinculo com a apolice original continua existindo por tras, so nao pauta
  // mais a posicao dela na lista).
  // O grupo e' a APOLICE do endosso (sobe pelos endossos ate ela), nao o documento_raiz_id: a raiz
  // junta tambem as renovacoes, e o endosso ia parar debaixo de outra apolice da familia (outro ano
  // ou outra seguradora — caso Gisele Forvile, 26/10). Endossos na ordem do endosso: inicio da
  // vigencia, depois o numero.
  const agruparComEndossos = (lista) => {
    const filhosPorRaiz = new Map()
    lista.forEach(a => {
      if (!a.documento_origem_id || !a.eh_endosso) return
      const raizId = apoliceBaseId(a.id)
      if (!filhosPorRaiz.has(raizId)) filhosPorRaiz.set(raizId, [])
      filhosPorRaiz.get(raizId).push(a)
    })
    const numEndosso = (x) => parseInt(String(x.emissao_numero_endosso || '').replace(/\D/g, ''), 10) || 0
    filhosPorRaiz.forEach(filhos => filhos.sort((x, y) =>
      String(x.data_inicio || '').localeCompare(String(y.data_inicio || '')) || numEndosso(x) - numEndosso(y) || x.id - y.id))
    const idsPresentes = new Set(lista.map(a => String(a.id)))
    const jaInserido = new Set()
    const resultado = []
    lista.forEach(a => {
      if (jaInserido.has(String(a.id))) return
      const raizId = (a.documento_origem_id && a.eh_endosso) ? apoliceBaseId(a.id) : null
      // Filho (endosso) cuja apolice esta presente na lista: pula, ele sera inserido junto dela abaixo.
      if (raizId && idsPresentes.has(raizId)) return
      resultado.push(a)
      jaInserido.add(String(a.id))
      const filhos = filhosPorRaiz.get(String(a.id)) || []
      filhos.forEach(f => {
        if (jaInserido.has(String(f.id))) return
        resultado.push(f)
        jaInserido.add(String(f.id))
      })
    })
    return resultado
  }
  const filtradasOrdenadas = agruparComEndossos(filtradasOrdenadasBase)
  const paginacao = usePaginacao(filtradasOrdenadas)
  // Ponta da cadeia: documento que ninguem mais referencia como documento_origem_id. So a ponta
  // pode ser endossada/renovada — evita que uma apolice ja endossada/renovada (superada) ofereca
  // Acoes de novo, e garante que uma apolice renovada passe a ter suas proprias Acoes.
  const idsComFilho = new Set(apolices.map(a => a.documento_origem_id).filter(Boolean).map(String))

  const clienteNaoCadastrado = (
    !!clienteImportadoPendente &&
    !form.cliente_id &&
    normalizarTexto(clienteBusca) === normalizarTexto(clienteImportadoPendente.nome || 'Cliente não cadastrado')
  )

  // Endosso gerado a partir de uma apólice: segurado/seguradora/ramo/nº apólice ficam travados,
  // pois o endosso e um aditivo da mesma apólice, nao um documento novo e independente.
  const bloqueadoEndosso = form.eh_endosso && !!form.documento_origem_id
  // Fim da vigência tambem fica travado no endosso — e' a mesma apólice, o prazo original nao
  // muda — exceto quando o proprio endosso e' pra prorrogar a apólice (aí o novo fim e' o ponto
  // do endosso, editável).
  const vigenciaFimFixaEndosso = bloqueadoEndosso && form.motivo !== 'Prorrogação de apólice'
  // Indicacao (quem indicou o cliente novo): so faz sentido pro cliente que esta chegando agora,
  // Tipo Novo ou Renovacao Externa (renovado de outra seguradora/corretora, tambem novo pra nos).
  const mostrarIndicacao = ['Novo', 'Renovação Externa'].includes(form.motivo)
  // Status so e editavel manualmente entre Em Analise/Pendente/Recusada, e so antes de ter Nº
  // oficial preenchido — a partir dai o status passa a ser automatico (emitido/vencida/cancelada).
  const numeroEmissaoAtual = form.eh_endosso ? form.emissao_numero_endosso : form.emissao_numero_apolice
  const statusEditavel = ['em_analise', 'pendente', 'recusada'].includes(form.status) && !numeroEmissaoAtual
  // Depois que a proposta/apolice/endosso e criado (ja tem editId), Data da Proposta, Seguradora,
  // Ramo, Tipo de Documento e Tipo ficam travados — sao os dados que identificam o documento; se
  // algo mudar nesse nivel, o correto e recusar e cadastrar um novo, nao editar este.
  const travadoAposCriar = !!editId
  // Rotulo e genero gramatical do documento, para o aviso de Excluir soar correto seja
  // proposta/apolice (feminino) ou endosso (masculino).
  const rotuloDocumento = form.eh_endosso ? 'endosso' : form.tipo_documento === 'Proposta' ? 'proposta' : 'apólice'
  const genM = form.eh_endosso
  const esteEsta = genM ? 'este' : 'esta'
  const umUma = genM ? 'um' : 'uma'
  const oA = genM ? 'o' : 'a'

  return (
    <>
      {!hideNavigation && carregandoVer && !modal && (
        <div style={{ padding: 40, textAlign: 'center', color: '#888', fontSize: 13 }}>Carregando...</div>
      )}
      {!hideNavigation && !modal && !carregandoVer && (
        <div style={{ padding: '32px 24px 0' }}>
          <h2 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>Apólices</h2>
          <div style={{ fontSize: 13, color: '#888', marginTop: 4, marginBottom: 20 }}>Consulte as apólices emitidas.</div>
          <div style={{ display: 'flex', gap: 12, marginBottom: 16, justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ position: 'relative', maxWidth: 420, width: '100%' }}>
              <input className="form-input" placeholder="Buscar por nome, CPF/CNPJ ou nº da apólice/proposta..." value={busca}
                onChange={e => { setBusca(e.target.value); setMostrarSugestoesBusca(true); navBusca.reset() }}
                onFocus={() => setMostrarSugestoesBusca(true)}
                onBlur={() => setTimeout(() => setMostrarSugestoesBusca(false), 150)}
                onKeyDown={navBusca.onKeyDown}
                style={{ width: '100%', border: '2px solid rgba(var(--primary-rgb),0.15)', borderRadius: 10 }} />
              {mostrarSugestoesBusca && busca.trim() && sugestoesBusca.length > 0 && (
                <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 20, background: '#fff', border: '1px solid #D9DDE3', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', maxHeight: 320, overflowY: 'auto' }}>
                  {sugestoesBusca.map((s, i) => (
                    <button key={s.chave} type="button" onMouseDown={() => { setMostrarSugestoesBusca(false); setBusca(s.valor) }}
                      onMouseEnter={() => navBusca.setIndice(i)}
                      style={{ width: '100%', textAlign: 'left', border: 'none', background: i === navBusca.indice ? 'rgba(var(--primary-rgb),0.08)' : '#fff', padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #F1F3F5', fontSize: 13, color: '#1A1A2E' }}>
                      {s.valor}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button type="button" className="btn btn-secondary" style={{ flexShrink: 0, whiteSpace: 'nowrap' }} onClick={() => setUsarFiltro(v => !v)}>
              {usarFiltro ? 'Fechar filtros' : 'Abrir filtros'}{temCriterioApolices(filtros) && <span style={{ color: 'var(--primary)', marginLeft: 6 }}>●</span>}
            </button>
            <div style={{ flex: 1 }} />
            <button className="btn btn-primary" onClick={() => abrirModal()}>+ Nova Apólice</button>
          </div>
          {usarFiltro && (() => {
            const emitidas = apolices.filter(a => ['emitido', 'cancelada', 'vencida'].includes(a.status))
            const opcoesDe = (campo) => [...new Set(emitidas.map(a => a[campo]).filter(Boolean))]
              .sort((x, y) => x.localeCompare(y, 'pt-BR')).map(v => ({ valor: v, label: v }))
            const simNao = (campo, label) => (
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label">{label}</label>
                <select className="form-select" value={filtros[campo]} onChange={e => setFiltroAv(campo, e.target.value)}>
                  <option value="">Todas</option>
                  <option value="com">Com {label.toLowerCase()}</option>
                  <option value="sem">Sem {label.toLowerCase()}</option>
                </select>
              </div>
            )
            return (
              <div className="card" style={{ marginBottom: 16, padding: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 12 }}>
                  <SelecaoMultipla label="Seguradora" opcoes={opcoesDe('seguradora')} valores={filtros.seguradoras} onChange={v => setFiltroAv('seguradoras', v)} />
                  <SelecaoMultipla label="Ramo" opcoes={opcoesDe('ramo')} valores={filtros.ramos} onChange={v => setFiltroAv('ramos', v)} />
                  <SelecaoMultipla label="Status" opcoes={STATUS_FILTRO_APOLICES} valores={filtros.status} onChange={v => setFiltroAv('status', v)} />
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    {simNao('sinistro', 'Sinistro')}
                    {simNao('assistencia', 'Assistência')}
                  </div>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label className="form-label">Vigência — pela data</label>
                    <select className="form-select" value={filtros.periodoCampo} onChange={e => setFiltroAv('periodoCampo', e.target.value)}>
                      {DATAS_PERIODO_APOLICES.map(d => <option key={d.campo} value={d.campo}>{d.label}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label className="form-label">Início</label>
                    <input className="form-input" type="date" value={filtros.periodoDe} onChange={e => setFiltroAv('periodoDe', e.target.value)} />
                  </div>
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label className="form-label">Fim</label>
                    <input className="form-input" type="date" value={filtros.periodoAte} onChange={e => setFiltroAv('periodoAte', e.target.value)} />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-secondary" disabled={JSON.stringify(filtros) === JSON.stringify(FILTROS_APOLICES_VAZIOS)}
                      onClick={() => setFiltros(FILTROS_APOLICES_VAZIOS)}>Limpar filtros</button>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      )}
      {!hideNavigation && !modal && !carregandoVer && <div className="page-content" style={{ paddingTop: 0 }}>
        <div className="card">
          {(filtroCliente || filtroApoliceId) && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, padding: '8px 14px', background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 8 }}>
              <span style={{ fontSize: 13, color: '#1D4ED8' }}>
                {filtroApoliceId
                  ? <>Mostrando apenas o documento encontrado na busca (<strong>{apolices.find(a => String(a.id) === String(filtroApoliceId))?.numero_apolice || apolices.find(a => String(a.id) === String(filtroApoliceId))?.emissao_numero_apolice || `#${filtroApoliceId}`}</strong>)</>
                  : <>Filtrando por: <strong>{clientes.find(c => String(c.id) === String(filtroCliente))?.nome || 'Cliente'}</strong></>}
              </span>
              <button className="btn btn-sm btn-secondary" onClick={() => { setFiltroCliente(''); setFiltroApoliceId('') }} style={{ marginLeft: 'auto' }}>Limpar</button>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
            <span style={{ fontSize: 12, color: '#888' }}>{filtradas.length} apólice{filtradas.length !== 1 ? 's' : ''}</span>
          </div>
          <div className="table-wrap" ref={tableWrapRef}>
            <table className="table-borda-destaque table-compacta">
              <thead>
                <tr>
                  {colunasApolices.map(c => (
                    <SortableTh key={c.key} colKey={c.key} sortCol={sortCol} sortDir={sortDir} onSort={toggleSort}>{c.label}</SortableTh>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {paginacao.itensPagina.map(a => {
                  const sv = statusLabel(a.status)
                  const cancelada = a.status === 'cancelada'
                  // td tem `color: #333` fixo no CSS global, entao herdar cor cinza so pelo <tr> nao
                  // funciona — precisa aplicar a cor em cada <td> individualmente.
                  const corCancelada = cancelada ? { color: '#bbb' } : undefined
                  return (
                    <tr key={a.id}>
                      <td style={corCancelada}>
                        <div
                          style={{ fontWeight: 600, fontSize: 13, color: cancelada ? '#bbb' : 'var(--primary)', cursor: 'pointer' }}
                          title="Ver dados do cliente"
                          onClick={() => { sessionStorage.setItem('abrirClienteId', a.cliente_id); navigate('/clientes') }}
                        >{a.cliente_nome}</div>
                        {a.motivo && <div style={{ fontSize: 11, color: cancelada ? '#bbb' : '#888' }}>{a.motivo}</div>}
                      </td>
                      <td style={corCancelada}>{a.cliente_cpf_cnpj || '—'}</td>
                      <td style={corCancelada}><span className="badge badge-blue">{a.tipo_documento || '—'}</span></td>
                      <td style={{ ...corCancelada, textAlign: 'center' }}>{a.seguradora || '—'}</td>
                      <td style={corCancelada}>
                        {a.ramo || '—'}
                        {a.combinado_residencial && <div><EtiquetaCombinado tipo={a.combinado_residencial} /></div>}
                      </td>
                      <td style={{ ...corCancelada, ...(cancelada ? { textDecoration: 'line-through' } : null) }}>{a.numero_apolice || a.emissao_numero_apolice || '—'}</td>
                      <td style={{ ...corCancelada, ...(cancelada ? { textDecoration: 'line-through' } : null) }}>{a.emissao_numero_endosso || '—'}</td>
                      <td style={corCancelada}>
                        {a.data_inicio ? a.data_inicio.split('T')[0].split('-').reverse().join('/') : '—'}
                        {a.data_vencimento ? ' → ' + a.data_vencimento.split('T')[0].split('-').reverse().join('/') : ''}
                      </td>
                      <td style={corCancelada}>R$ {parseFloat(a.premio_total || a.valor_premio || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                      <td><span className={`badge ${sv.cls}`}>{sv.label}</span></td>
                      <td>
                        <div style={{ display: 'flex', gap: 6, position: 'relative' }}>
                          <button className="btn btn-secondary btn-sm btn-icon" title="Ver" style={{ color: 'var(--primary)' }} onClick={() => abrirDocumentoRelacionado(a.id)}><IconVisualizar size={14} /></button>
                          {/* Endossar/Renovar so na ponta da cadeia (documento que ninguem mais
                              referencia como origem — pode ser a propria apolice-mae, um endosso
                              ou uma renovacao) e nunca em documento cancelado. */}
                          {!idsComFilho.has(String(a.id)) && a.status !== 'cancelada' && (
                            <div ref={acoesAbertoId === a.id ? acoesMenuRef : null} style={{ position: 'relative' }}>
                              <button className="btn btn-secondary btn-sm btn-icon" style={{ color: 'var(--primary)' }} onClick={(e) => {
                                if (acoesAbertoId === a.id) { setAcoesAbertoId(null); return }
                                // Abre pra cima so quando ha mais espaco na janela ali do que embaixo —
                                // usa a janela inteira (nao o table-wrap) porque o menu e' position:fixed.
                                const rectBotao = e.currentTarget.getBoundingClientRect()
                                const espacoAbaixo = window.innerHeight - rectBotao.bottom
                                const espacoAcima = rectBotao.top
                                const abrirCima = espacoAbaixo < 140 && espacoAcima > espacoAbaixo
                                setAcoesMenuPos({
                                  right: window.innerWidth - rectBotao.right,
                                  ...(abrirCima ? { bottom: window.innerHeight - rectBotao.top + 4 } : { top: rectBotao.bottom + 4 }),
                                })
                                setAcoesAbertoId(a.id)
                              }} title="Ações"><IconAcoes size={14} /></button>
                              {acoesAbertoId === a.id && acoesMenuPos && (
                                <div style={{
                                  position: 'fixed', zIndex: 9999, ...acoesMenuPos,
                                  background: '#fff', border: '1px solid #e0e0e0', borderRadius: 6,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)', minWidth: 150, overflow: 'hidden'
                                }}>
                                  <button type="button" onClick={() => { setAcoesAbertoId(null); endossar(a.id) }} style={{
                                    display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px',
                                    background: 'none', border: 'none', cursor: 'pointer', fontSize: 13
                                  }} onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'} onMouseLeave={e => e.currentTarget.style.background = 'none'}>Endossar</button>
                                  <button type="button" onClick={() => { setAcoesAbertoId(null); renovar(a.id) }} style={{
                                    display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px',
                                    background: 'none', border: 'none', cursor: 'pointer', fontSize: 13
                                  }} onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'} onMouseLeave={e => e.currentTarget.style.background = 'none'}>Renovar</button>
                                  <button type="button" onClick={() => {
                                    setAcoesAbertoId(null)
                                    sessionStorage.setItem('sinistroNovaApolice', JSON.stringify({
                                      id: a.id, cliente_id: a.cliente_id, cliente_nome: a.cliente_nome,
                                      numero_apolice: a.numero_apolice, emissao_numero_apolice: a.emissao_numero_apolice,
                                      seguradora: a.seguradora, ramo: a.ramo
                                    }))
                                    navigate('/sinistros')
                                  }} style={{
                                    display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px',
                                    background: 'none', border: 'none', cursor: 'pointer', fontSize: 13
                                  }} onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'} onMouseLeave={e => e.currentTarget.style.background = 'none'}>Sinistros</button>
                                  <button type="button" onClick={() => { setAcoesAbertoId(null); gerarCardCRM(a) }} style={{
                                    display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px',
                                    background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap'
                                  }} onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'} onMouseLeave={e => e.currentTarget.style.background = 'none'}>Gerar Card CRM</button>
                                </div>
                              )}
                            </div>
                          )}
                          {basesComSinistro.has(apoliceBaseId(a.id)) && (
                            <button type="button" title="Tem ou teve sinistro" onClick={() => abrirUltimoDaApolice(sinistrosLista, a, 'sinistroAbrirId', 'sinistroVoltarPara', '/sinistros')}
                              style={{ width: 28, height: 28, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', borderRadius: 6, background: 'var(--danger)', color: '#fff', cursor: 'pointer' }}>
                              <IconSinistro size={16} />
                            </button>
                          )}
                          {basesComAssistencia.has(apoliceBaseId(a.id)) && (
                            <button type="button" title="Tem ou teve assistência" onClick={() => abrirUltimoDaApolice(assistenciasLista, a, 'assistenciaAbrirId', 'assistenciaVoltarPara', '/assistencias')}
                              style={{ width: 28, height: 28, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', borderRadius: 6, background: '#EAB308', color: '#fff', cursor: 'pointer' }}>
                              <IconAssistencia size={16} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
                {filtradas.length === 0 && <tr><td colSpan={11} style={{ textAlign: 'center', color: '#aaa', padding: 32 }}>
                  {pesquisou ? 'Nenhuma apólice encontrada' : 'Use a busca ou o Filtro para ver as apólices.'}
                </td></tr>}
              </tbody>
            </table>
          </div>
          <Paginacao {...paginacao} rotulo="apólice" />
        </div>
      </div>}

      {modal && (
        <div style={{ padding: '24px 24px 40px' }}>
          <div style={{ marginBottom: 14 }}>
            <button type="button" onClick={() => {
              if (foiAlterado()) setConfirmacao({ tipo: 'fechar' })
              else fecharModal()
            }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: 13, fontWeight: 600, padding: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
              ‹ Voltar para {hideNavigation ? voltarLabel : (voltarExterno?.label || 'Apólices')}
            </button>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
              <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>{editId ? (form.tipo_documento || 'Apólice') : (form.tipo_documento || 'Nova Apólice')}</h2>
              {!editId && (
                <>
                  <input
                    ref={pdfInputRef}
                    type="file"
                    accept=".pdf"
                    style={{ display: 'none' }}
                    onChange={e => { handleImportarPdf(e.target.files[0]); e.target.value = '' }}
                  />
                  <button
                    type="button"
                    disabled={importando}
                    onClick={() => pdfInputRef.current.click()}
                    style={{
                      background: importando ? '#f0f0f0' : 'var(--primary-light)',
                      color: importando ? '#999' : 'var(--primary)',
                      border: '1px solid var(--primary)',
                      borderRadius: 8,
                      padding: '6px 14px',
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: importando ? 'not-allowed' : 'pointer',
                      fontFamily: 'inherit',
                    }}
                  >
                    {importando ? 'Lendo PDF...' : '📄 Importar PDF'}
                  </button>
                </>
              )}
            </div>
          </div>
          <div>
            {form.cliente_id && (() => {
              const nome = clientes.find(c => String(c.id) === String(form.cliente_id))?.nome || ''
              return nome ? (
                <div className="card" style={{ textAlign: 'center', marginBottom: 20 }}>
                  <button type="button" onClick={() => {
                    if (foiAlterado()) setConfirmacao({ tipo: 'sairCliente' })
                    else irParaCliente()
                  }} style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontFamily: 'inherit', fontSize: 22, fontWeight: 700,
                    color: 'var(--primary)', letterSpacing: '0.01em'
                  }}>
                    {nome}
                  </button>
                </div>
              ) : null
            })()}

            <form onSubmit={salvar}>

              <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start' }}>
                {editId && (
                  <div style={{ width: 260, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 20 }}>
                    {form.cliente_id && (() => {
                      const clienteInfo = clientes.find(c => String(c.id) === String(form.cliente_id))
                      if (!clienteInfo) return null
                      return (
                        <div className="card" style={{ border: '2px solid rgba(var(--primary-rgb),0.15)' }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
                            Dados do Cliente
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 13 }}>
                            <div>
                              <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>CPF/CNPJ</div>
                              <div style={{ color: '#333' }}>{clienteInfo.cpf_cnpj || '—'}</div>
                            </div>
                            <div>
                              <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>Telefone{clienteInfo.telefones?.length > 1 ? 's' : ''}</div>
                              {clienteInfo.telefones?.length ? clienteInfo.telefones.map((t, i) => (
                                <div key={i} style={{ color: '#333' }}>{t.numero}{t.nome ? ` (${t.nome})` : ''}</div>
                              )) : <div style={{ color: '#333' }}>—</div>}
                            </div>
                            <div>
                              <div style={{ fontSize: 11, color: '#999', marginBottom: 2 }}>E-mail{clienteInfo.emails?.length > 1 ? 's' : ''}</div>
                              {clienteInfo.emails?.length ? clienteInfo.emails.map((e, i) => (
                                <div key={i} style={{ color: '#333', wordBreak: 'break-all' }}>{e}</div>
                              )) : <div style={{ color: '#333' }}>—</div>}
                            </div>
                          </div>
                        </div>
                      )
                    })()}
                  <div className="card">
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 10 }}>
                      Histórico do Documento
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {agruparComEndossos(historicoDocumentos).map(doc => {
                        const ativo = String(doc.id) === String(editId)
                        const canceladoNoHistorico = doc.status === 'cancelada' || doc.status === 'recusada'
                        // Endosso aparece recuado, com uma linha conectando ao card da apolice-mae
                        // acima, para deixar visivel que ele "pertence" aquele documento (aditivo).
                        // Renovacao NAO entra aqui: tem vigencia propria e nova, e aparece como um
                        // card independente, igual a uma apolice nova.
                        const ehFilho = !!doc.documento_origem_id && !!doc.eh_endosso
                        return (
                          <div key={doc.id} style={{ position: 'relative', marginLeft: ehFilho ? 18 : 0 }}>
                            {ehFilho && (<>
                              <div style={{ position: 'absolute', top: -8, left: -12, width: 2, height: 'calc(50% + 8px)', background: 'var(--primary)', opacity: 0.35 }} />
                              <div style={{ position: 'absolute', top: '50%', left: -12, width: 12, height: 2, background: 'var(--primary)', opacity: 0.35 }} />
                            </>)}
                            <button type="button" onClick={() => abrirDocumentoRelacionado(doc.id)} style={{
                              width: '100%',
                              textAlign: 'left',
                              padding: '10px 12px',
                              borderRadius: 8,
                              border: ativo ? '1px solid var(--primary)' : '1px solid #e5e7eb',
                              background: ativo ? 'var(--primary-light)' : '#fff',
                              cursor: 'pointer',
                              display: 'flex',
                              gap: 10,
                              alignItems: 'flex-start'
                            }}>
                              <span style={{ fontSize: 18, lineHeight: 1, marginTop: 1, flexShrink: 0 }}>📄</span>
                              <div style={{ minWidth: 0 }}>
                                <div style={{
                                  fontSize: 13, fontWeight: 600,
                                  color: ativo ? 'var(--primary)' : canceladoNoHistorico ? '#bbb' : '#1f2937',
                                  textDecoration: canceladoNoHistorico ? 'line-through' : 'none'
                                }}>
                                  {faseLabel(doc)}
                                </div>
                                <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>
                                  {doc.data_inicio
                                    ? doc.data_inicio.split('T')[0].split('-').reverse().join('/') + (doc.data_vencimento ? ' a ' + doc.data_vencimento.split('T')[0].split('-').reverse().join('/') : '')
                                    : 'Sem data'}
                                </div>
                                <div style={{
                                  fontSize: 12, color: '#666', marginTop: 4,
                                  textDecoration: canceladoNoHistorico ? 'line-through' : 'none',
                                  wordBreak: 'break-all'
                                }}>
                                  {doc.numero_apolice || doc.emissao_numero_apolice || doc.numero_proposta || `#${doc.id}`}
                                </div>
                              </div>
                            </button>
                          </div>
                        )
                      })}
                      {historicoDocumentos.length === 0 && (
                        <div style={{ fontSize: 12, color: '#999' }}>Nenhum documento relacionado encontrado.</div>
                      )}
                    </div>
                  </div>
                  </div>
                )}

                <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 14 }}>

              {/* ===== CARD DADOS ===== */}
              <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 12px', paddingBottom: 6, borderBottom: '2px solid var(--primary-light)' }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Dados</span>
                  {statusEditavel ? (
                    <select
                      className={`badge ${statusLabel(form.status).cls}`}
                      style={{ fontSize: 14, fontWeight: 700, padding: '6px 28px 6px 16px', border: 'none', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' }}
                      value={form.status}
                      onChange={e => {
                        const status = e.target.value
                        // Proposta recusada vira tipo 'Devolvida'; se voltar de Recusada, volta a ser Proposta.
                        setForm(f => ({
                          ...f, status,
                          ...(!f.eh_endosso && status === 'recusada' && f.tipo_documento === 'Proposta' ? { tipo_documento: 'Devolvida' } : {}),
                          ...(!f.eh_endosso && status !== 'recusada' && f.status === 'recusada' && f.tipo_documento === 'Devolvida' ? { tipo_documento: 'Proposta' } : {}),
                        }))
                      }}
                    >
                      <option value="em_analise">Em Análise</option>
                      <option value="pendente">Pendente</option>
                      <option value="recusada">Recusada</option>
                    </select>
                  ) : (
                    <span className={`badge ${statusLabel(form.status).cls}`} style={{ fontSize: 14, fontWeight: 700, padding: '6px 16px' }}>{statusLabel(form.status).label}</span>
                  )}
                </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Data da Proposta {travadoAposCriar && <span style={{ color: '#aaa', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <input className="form-input" type="date" value={form.data_proposta} onChange={e => setField('data_proposta', e.target.value)} disabled={travadoAposCriar} style={travadoAposCriar ? { background: '#f8f9fa', color: '#666' } : undefined} />
                    </div>
                    <div className="form-group" style={{ gridColumn: 'span 2' }}>
                      <label className="form-label">Segurado (Cliente) * {bloqueadoEndosso && <span style={{ color: '#bbb', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                        <div style={{ position: 'relative', flex: 1 }}>
                          <input
                            className="form-input"
                            value={clienteBusca}
                            onChange={e => selecionarClientePorBusca(e.target.value)}
                            onFocus={() => setMostrarSugestoesCliente(true)}
                            onBlur={() => setTimeout(() => setMostrarSugestoesCliente(false), 150)}
                            placeholder="Digite o nome do cliente..."
                            autoComplete="off"
                            required
                            disabled={bloqueadoEndosso}
                            style={{ opacity: bloqueadoEndosso ? 0.6 : 1 }}
                          />
                          {!bloqueadoEndosso && mostrarSugestoesCliente && clientesFiltrados.length > 0 && (
                            <div style={{
                              position: 'absolute',
                              top: 'calc(100% + 4px)',
                              left: 0,
                              right: 0,
                              zIndex: 20,
                              background: '#fff',
                              border: '1px solid #D9DDE3',
                              borderRadius: 8,
                              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                              maxHeight: 220,
                              overflowY: 'auto'
                            }}>
                              {clientesFiltrados.map(cliente => (
                                <button
                                  key={cliente.id}
                                  type="button"
                                  onMouseDown={() => selecionarCliente(cliente)}
                                  style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: '#fff',
                                    padding: '10px 12px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #F1F3F5'
                                  }}
                                >
                                  <div style={{ fontSize: 13, color: '#1A1A2E', fontWeight: 600 }}>{cliente.nome}</div>
                                  <div style={{ fontSize: 11, color: '#7A7F87', marginTop: 2 }}>{cliente.cpf_cnpj || 'Sem CPF/CNPJ'}</div>
                                </button>
                              ))}
                            </div>
                          )}
                          {clienteNaoCadastrado && (
                            <div style={{ marginTop: 6, fontSize: 12, color: '#A32D2D' }}>
                              Cliente nao cadastrado
                            </div>
                          )}
                        </div>
                        {clienteNaoCadastrado && (
                          <button
                            type="button"
                            className="btn btn-secondary"
                            style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                            onClick={abrirCadastroCliente}
                          >
                            + Novo Cliente
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Nº Proposta</label>
                      <input className="form-input" value={form.numero_proposta} onChange={e => setField('numero_proposta', e.target.value)} />
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Seguradora * {(bloqueadoEndosso || travadoAposCriar) && <span style={{ color: '#aaa', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <select className="form-select" value={form.seguradora} onChange={e => setField('seguradora', e.target.value)} required disabled={bloqueadoEndosso || travadoAposCriar} style={travadoAposCriar ? { background: '#f8f9fa', color: '#666' } : bloqueadoEndosso ? { opacity: 0.6 } : undefined}>
                        <option value="">Selecione...</option>
                        {seguradoras.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Ramo * {(bloqueadoEndosso || travadoAposCriar) && <span style={{ color: '#aaa', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <select className="form-select" value={form.ramo} onChange={e => onChangeRamo(e.target.value)} required disabled={bloqueadoEndosso || travadoAposCriar} style={travadoAposCriar ? { background: '#f8f9fa', color: '#666' } : bloqueadoEndosso ? { opacity: 0.6 } : undefined}>
                        <option value="">Selecione...</option>
                        {ramos.map(r => <option key={r}>{r}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Tipo de Documento * {travadoAposCriar && <span style={{ color: '#aaa', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <select className="form-select" value={form.tipo_documento} onChange={e => { setField('tipo_documento', e.target.value); setForm(f => ({ ...f, motivo: '' })) }} required disabled={travadoAposCriar} style={travadoAposCriar ? { background: '#f8f9fa', color: '#666' } : undefined}>
                        {tiposDoc.map(t => <option key={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {form.eh_endosso ? 'Tipo de Endosso' : 'Tipo'} {form.tipo_documento === 'Devolvida' && <span style={{ color: '#aaa', fontWeight: 400 }}>(indisponível)</span>}
                      </label>
                      <select className="form-select"
                        value={form.motivo}
                        onChange={e => setField('motivo', e.target.value)}
                        disabled={form.tipo_documento === 'Devolvida'}
                        style={form.tipo_documento === 'Devolvida' ? { opacity: 0.4 } : undefined}>
                        <option value="">—</option>
                        {getTipos(form.eh_endosso ? 'Endosso' : form.tipo_documento).map(m => <option key={m}>{m}</option>)}
                      </select>
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: mostrarIndicacao ? '1fr 0.6fr 0.6fr 0.8fr 1fr' : 'repeat(4, 1fr)', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Nº Apólice Atual {bloqueadoEndosso && <span style={{ color: '#bbb', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <input className="form-input" value={form.numero_apolice} onChange={e => setField('numero_apolice', e.target.value)} disabled={bloqueadoEndosso} style={{ opacity: bloqueadoEndosso ? 0.6 : 1 }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Início da Vigência</label>
                      <input className="form-input" type="date" value={form.vigencia_inicio}
                        onChange={e => {
                          const inicio = e.target.value
                          let fim = form.vigencia_fim
                          if (inicio && form.tipo_documento !== 'Endosso' && !vigenciaFimFixaEndosso) {
                            const d = new Date(inicio)
                            d.setFullYear(d.getFullYear() + 1)
                            fim = d.toISOString().split('T')[0]
                          }
                          const novo = { ...form, vigencia_inicio: inicio, vigencia_fim: fim }
                          setForm(recalcular(novo))
                        }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Fim da Vigência {vigenciaFimFixaEndosso && <span style={{ color: '#bbb', fontWeight: 400 }}>(normalmente fixo no endosso — edite se precisar corrigir)</span>}</label>
                      <input className="form-input" type="date" value={form.vigencia_fim} onChange={e => setField('vigencia_fim', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Nº Apólice Renovada {(form.motivo === 'Novo' || bloqueadoEndosso) && <span style={{ color: '#bbb', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <input className="form-input" type="number"
                        value={form.numero_apolice_renovada}
                        onChange={e => setField('numero_apolice_renovada', e.target.value)}
                        disabled={form.motivo === 'Novo' || bloqueadoEndosso}
                        style={{ opacity: (form.motivo === 'Novo' || bloqueadoEndosso) ? 0.4 : 1 }}
                        placeholder="0" />
                    </div>
                    {mostrarIndicacao && (
                      <div className="form-group">
                        <label className="form-label">Indicação</label>
                        <div style={{ position: 'relative' }}>
                          <input
                            className="form-input"
                            value={indicacaoBusca}
                            onChange={e => selecionarIndicacaoPorBusca(e.target.value)}
                            onFocus={() => setMostrarSugestoesIndicacao(true)}
                            onBlur={() => setTimeout(() => setMostrarSugestoesIndicacao(false), 150)}
                            placeholder="Quem indicou?"
                            autoComplete="off"
                          />
                          {mostrarSugestoesIndicacao && indicacoesFiltradas.length > 0 && (
                            <div style={{
                              position: 'absolute',
                              top: 'calc(100% + 4px)',
                              left: 0,
                              right: 0,
                              zIndex: 20,
                              background: '#fff',
                              border: '1px solid #D9DDE3',
                              borderRadius: 8,
                              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                              maxHeight: 220,
                              overflowY: 'auto'
                            }}>
                              {indicacoesFiltradas.map(cliente => (
                                <button
                                  key={cliente.id}
                                  type="button"
                                  onMouseDown={() => selecionarIndicacao(cliente)}
                                  style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    border: 'none',
                                    background: '#fff',
                                    padding: '10px 12px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #F1F3F5'
                                  }}
                                >
                                  <div style={{ fontSize: 13, color: '#1A1A2E', fontWeight: 600 }}>{cliente.nome}</div>
                                  <div style={{ fontSize: 11, color: '#7A7F87', marginTop: 2 }}>{cliente.cpf_cnpj || 'Sem CPF/CNPJ'}</div>
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {form.eh_endosso && (
                    <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: 12 }}>
                      <div className="form-group">
                        <label className="form-label">Nº do Endosso</label>
                        <input className="form-input" value={form.emissao_numero_endosso} readOnly style={{ background: '#f8f9fa', color: '#666' }} placeholder="Preencha na aba Emissão" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Observação</label>
                        <input className="form-input" value={form.endosso_observacao} onChange={e => setField('endosso_observacao', e.target.value)} placeholder="Observação sobre este endosso..." />
                      </div>
                    </div>
                  )}
              </div>

              {/* ===== CARD ITENS ===== */}
              <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
                {sec('Itens')}
                <ItensAba apoliceId={editId} clienteId={form.cliente_id} ramo={form.ramo} seguradora={form.seguradora} itensPendentes={itensParaCopiar} setItensPendentes={setItensParaCopiar} dadosVeiculoImportado={form} />
              </div>

              {/* ===== CARD FINANCEIRO ===== */}
              <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
                  {sec(form.eh_endosso ? 'Financeiro do Endosso' : 'Financeiro')}
                  <div style={{ display: 'grid', gridTemplateColumns: mostrarPlDuo ? '1fr 1fr 1fr 1fr 90px 1fr 1fr 90px 1fr' : '1fr 1fr 1fr 90px 1fr 1fr 90px 1fr', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Prêmio Líquido</label>
                      <input className="form-input" placeholder="R$ 0,00" value={form.premio_liquido}
                        onChange={e => setForm(calcularValores('premio_liquido', e.target.value))}
                        onBlur={e => { const v = parseMoney(e.target.value); if(v) setForm(f => calcularValores('premio_liquido', formatMoney(v))) }} />
                    </div>
                    {mostrarPlDuo && (
                      <div className="form-group">
                        <label className="form-label" title="Prêmio líquido do residencial do HDI DUO">PL DUO</label>
                        <input className="form-input" placeholder="R$ 0,00" value={form.pl_duo}
                          onChange={e => setForm(calcularValores('pl_duo', e.target.value))}
                          onBlur={e => { const v = parseMoney(e.target.value); if(v) setForm(f => calcularValores('pl_duo', formatMoney(v))) }} />
                      </div>
                    )}
                    <div className="form-group">
                      <label className="form-label">Adicional</label>
                      <input className="form-input" placeholder="R$ 0,00" value={form.adicional}
                        onChange={e => setForm(calcularValores('adicional', e.target.value))}
                        onBlur={e => { const v = parseMoney(e.target.value); if(v) setForm(f => calcularValores('adicional', formatMoney(v))) }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Desconto</label>
                      <input className="form-input" placeholder="R$ 0,00" value={form.desconto}
                        onChange={e => setForm(calcularValores('desconto', e.target.value))}
                        onBlur={e => { const v = parseMoney(e.target.value); if(v) setForm(f => calcularValores('desconto', formatMoney(v))) }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">IOF (%)</label>
                      <input className="form-input" value={form.iof_pct}
                        onChange={e => setForm(calcularValores('iof_pct', e.target.value))}
                        placeholder="7,38" style={{ textAlign: 'center' }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Valor do IOF <span style={{ color: '#aaa', fontWeight: 400 }}>(calc)</span></label>
                      <input className="form-input" value={form.iof_valor} readOnly style={{ background: '#f8f9fa', color: '#666' }} placeholder="R$ 0,00" />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Prêmio Total <span style={{ color: '#aaa', fontWeight: 400 }}>(calc)</span></label>
                      <input className="form-input" value={form.premio_total} readOnly style={{ background: '#f8f9fa', fontWeight: 600, color: 'var(--primary)' }} placeholder="R$ 0,00" />
                    </div>
                    <div className="form-group">
                      <label className="form-label">% Comissão</label>
                      <input className="form-input" value={form.comissao_pct}
                        onChange={e => {
                          const raw = e.target.value.replace(/[^0-9]/g, '')
                          setForm(calcularValores('comissao_pct', maskPct(raw)))
                        }}
                        placeholder="00,00%" style={{ textAlign: 'center' }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Valor da Comissão</label>
                      <input className="form-input" value={form.comissao} readOnly style={{ background: '#f8f9fa', fontWeight: 600, color: '#3B6D11' }} placeholder="R$ 0,00" />
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '220px 110px 100px 110px 1fr', gap: 12, marginTop: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Forma de Pagamento</label>
                      <select className="form-select" value={form.forma_pagamento} onChange={e => setField('forma_pagamento', e.target.value)}>
                        {formasPag.map(f => <option key={f}>{f}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Qtde Parcelas</label>
                      <input className="form-input" type="text" inputMode="numeric" maxLength={2}
                        value={form.quantidade_parcelas}
                        onChange={e => setField('quantidade_parcelas', e.target.value.replace(/\D/g,'').slice(0,2))}
                        placeholder="00" style={{ textAlign: 'center', fontWeight: 600 }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">1ª Parc.(dias)</label>
                      <input className="form-input" type="text" inputMode="numeric" maxLength={2}
                        value={form.prazo_primeira_parcela}
                        onChange={e => setField('prazo_primeira_parcela', e.target.value.replace(/\D/g,'').slice(0,2))}
                        placeholder="00" style={{ textAlign: 'center' }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Dia Fixo (demais)</label>
                      <input className="form-input" type="text" inputMode="numeric" maxLength={2}
                        value={form.dia_fixo_parcelas}
                        onChange={e => setField('dia_fixo_parcelas', e.target.value.replace(/\D/g,'').slice(0,2))}
                        placeholder="00" style={{ textAlign: 'center' }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Forma de Recebimento</label>
                      <select className="form-select" value={form.forma_recebimento_comissao} onChange={e => setField('forma_recebimento_comissao', e.target.value)}>
                        {formasRecComissao.map(f => <option key={f}>{f}</option>)}
                      </select>
                    </div>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '16px 0 12px' }}>
                    {!form.vigencia_inicio && (
                      <span style={{ fontSize: 12, color: '#854F0B', background: '#FAEEDA', padding: '3px 10px', borderRadius: 6 }}>
                        ⚠ Preencha a data de início da vigência no card Dados
                      </span>
                    )}
                    {!form.quantidade_parcelas && (
                      <span style={{ fontSize: 12, color: '#854F0B', background: '#FAEEDA', padding: '3px 10px', borderRadius: 6 }}>
                        ⚠ Preencha a quantidade de parcelas acima
                      </span>
                    )}
                  </div>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr>
                          <th colSpan={5} style={{ padding: '6px 10px 4px', textAlign: 'center', fontSize: 12, color: 'var(--primary)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Parcelas</th>
                          <th colSpan={form.forma_recebimento_comissao === 'Esgotamento' ? 4 : 3} style={{ padding: '6px 10px 4px', textAlign: 'center', fontSize: 12, color: 'var(--primary)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', borderLeft: '1px solid #e5e5e5' }}>Comissões</th>
                        </tr>
                        <tr style={{ background: '#f8f9fa' }}>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600, width: 50 }}>Nº</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600 }}>Forma de Pagamento</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600 }}>Venc. da Parcela</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600, width: 100 }}>Valor da Parcela</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600 }}>Status da Parcela</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600, borderLeft: '1px solid #e5e5e5' }}>Data da Comissão</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600, width: 100 }}>Valor da Comissão</th>
                          <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 11, color: '#888', fontWeight: 600 }}>Status da Comissão</th>
                          {form.forma_recebimento_comissao === 'Esgotamento' && <th style={{ width: 40 }}></th>}
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: Math.max(form.parcelas.length, form.parcelas_comissao.length) }).map((_, i) => {
                          const p = form.parcelas[i]
                          const pc = form.parcelas_comissao[i]
                          return (
                            <tr key={i} style={{ borderBottom: '1px solid #f0f0f0', opacity: p?.status === 'Cancelada' ? 0.55 : 1 }}>
                              <td style={{ padding: '6px 10px', color: '#888', fontWeight: 700, fontSize: 14 }}>{String(i + 1).padStart(2,'0')}</td>
                              <td style={{ padding: '6px 6px' }}>
                                {p ? (
                                  <select className="form-select" style={{ padding: '5px 8px', fontSize: 12 }} value={p.forma_pagamento} onChange={e => setParcela(i, 'forma_pagamento', e.target.value)}>
                                    {formasPag.map(f => <option key={f}>{f}</option>)}
                                  </select>
                                ) : '—'}
                              </td>
                              <td style={{ padding: '6px 6px' }}>
                                {p ? <input className="form-input" type="date" style={{ padding: '5px 8px', fontSize: 12 }} value={p.vencimento} onChange={e => setParcela(i, 'vencimento', e.target.value)} /> : '—'}
                              </td>
                              <td style={{ padding: '6px 6px', width: 100, maxWidth: 100 }}>
                                {p ? <input className="form-input" style={{ padding: '5px 8px', fontSize: 12 }} placeholder="R$ 0,00" value={p.valor} onChange={e => setParcela(i, 'valor', e.target.value)} /> : '—'}
                              </td>
                              <td style={{ padding: '6px 6px' }}>
                                {p ? (
                                  <select className="form-select" style={{ padding: '5px 8px', fontSize: 12 }} value={p.status || 'Pendente'} onChange={e => setParcela(i, 'status', e.target.value)}>
                                    <option>Pendente</option>
                                    <option>Paga</option>
                                    <option>Cancelada</option>
                                  </select>
                                ) : '—'}
                              </td>
                              <td style={{ padding: '6px 6px', borderLeft: '1px solid #f0f0f0' }}>
                                {pc ? <input className="form-input" type="date" style={{ padding: '5px 8px', fontSize: 12 }} value={pc.data} onChange={e => setParcelaComissao(i, 'data', e.target.value)} /> : '—'}
                              </td>
                              <td style={{ padding: '6px 6px', width: 100, maxWidth: 100 }}>
                                {pc ? (
                                  <input className="form-input" placeholder="R$ 0,00" value={pc.valor}
                                    readOnly={form.forma_recebimento_comissao !== 'Esgotamento'}
                                    style={{ padding: '5px 8px', fontSize: 12, background: form.forma_recebimento_comissao !== 'Esgotamento' ? '#f8f9fa' : '#fff' }}
                                    onChange={e => setParcelaComissao(i, 'valor', e.target.value)} />
                                ) : '—'}
                              </td>
                              <td style={{ padding: '6px 6px' }}>
                                {pc ? (
                                  <select className="form-select" style={{ padding: '5px 8px', fontSize: 12 }} value={pc.status} onChange={e => setParcelaComissao(i, 'status', e.target.value)}>
                                    <option>Pendente</option>
                                    <option>Recebido</option>
                                    <option>Atrasado</option>
                                  </select>
                                ) : '—'}
                              </td>
                              {form.forma_recebimento_comissao === 'Esgotamento' && (
                                <td style={{ padding: '6px 6px' }}>
                                  {pc && form.parcelas_comissao.length > 1 && <button type="button" className="btn btn-danger btn-sm" onClick={() => remParcelaComissao(i)}>✕</button>}
                                </td>
                              )}
                            </tr>
                          )
                        })}
                        {form.parcelas.length === 0 && form.parcelas_comissao.length === 0 && (
                          <tr><td colSpan={9} style={{ textAlign: 'center', color: '#aaa', padding: 24, fontSize: 13 }}>Preencha a quantidade de parcelas acima</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {form.forma_recebimento_comissao === 'Esgotamento' && (
                    <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: 8 }} onClick={addParcelaComissao}>+ Adicionar parcela</button>
                  )}
              </div>

              {/* ===== CARD EMISSÃO ===== */}
              <div ref={emissaoCardRef} className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
                  {sec('Dados de Emissão')}
                  <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr 180px', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Data de Emissão</label>
                      <input className="form-input" type="date" value={form.emissao_data} onChange={e => setField('emissao_data', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Número da Apólice {bloqueadoEndosso && <span style={{ color: '#bbb', fontWeight: 400 }}>(indisponível)</span>}</label>
                      <input ref={numeroApoliceInputRef} className="form-input" maxLength={20} value={form.emissao_numero_apolice}
                        onChange={e => {
                          const val = e.target.value.replace(/\D/g,'').slice(0,20)
                          setForm(f => ({ ...f, emissao_numero_apolice: val, numero_apolice: val, ...(val ? { status: 'emitido', tipo_documento: 'Apólice' } : {}) }))
                        }}
                        disabled={bloqueadoEndosso}
                        style={{ opacity: bloqueadoEndosso ? 0.6 : 1 }}
                        placeholder="00000000000000000000" />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Número do Endosso</label>
                      <input className="form-input" maxLength={8} value={form.emissao_numero_endosso}
                        onChange={e => {
                          const val = e.target.value.replace(/\D/g,'').slice(0,8)
                          setForm(f => ({ ...f, emissao_numero_endosso: val, ...(val ? { status: 'emitido', tipo_documento: 'Endosso' } : {}) }))
                        }}
                        placeholder="00000000" disabled={!form.eh_endosso} style={{ opacity: !form.eh_endosso ? 0.4 : 1 }} />
                    </div>
                  </div>
                  {mostrarPlDuo && (
                    <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr 180px', gap: 12 }}>
                      <div />
                      <div className="form-group">
                        <label className="form-label" title="HDI DUO: o residencial é emitido numa apólice separada">Nº Apólice DUO (residencial)</label>
                        <input className="form-input" maxLength={20} value={form.emissao_numero_apolice_duo}
                          onChange={e => setForm(f => ({ ...f, emissao_numero_apolice_duo: e.target.value.replace(/\D/g, '').slice(0, 20) }))}
                          placeholder="00000000000000000000" />
                      </div>
                    </div>
                  )}

                  <div ref={envioCardRef}>
                  {sec('Envio')}
                  <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: 12 }}>
                    <div className="form-group">
                      <label className="form-label">Data do Envio</label>
                      <input ref={dataEnvioInputRef} className="form-input" type="date" value={form.emissao_data_envio} onChange={e => setField('emissao_data_envio', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Forma do Envio <span style={{ color: '#aaa', fontWeight: 400 }}>(pode selecionar mais de uma)</span></label>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
                        {['E-mail','Whatsapp','Correio','Em mãos'].map(forma => {
                          const selecionado = form.emissao_forma_envio?.includes(forma)
                          return (
                            <button key={forma} type="button" onClick={() => {
                              const atual = form.emissao_forma_envio || []
                              setField('emissao_forma_envio', selecionado ? atual.filter(f => f !== forma) : [...atual, forma])
                            }} style={{
                              padding: '6px 14px', borderRadius: 20, border: '1px solid',
                              cursor: 'pointer', fontSize: 13, fontWeight: 500, fontFamily: 'inherit',
                              background: selecionado ? 'var(--primary-light)' : '#fff',
                              borderColor: selecionado ? 'var(--primary)' : '#ddd',
                              color: selecionado ? 'var(--primary)' : '#666'
                            }}>{selecionado ? '✓ ' : ''}{forma}</button>
                          )
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Observações Gerais</label>
                    <textarea className="form-input" rows={4} value={form.emissao_obs} onChange={e => setField('emissao_obs', e.target.value)} placeholder="Observações sobre a emissão..." style={{ resize: 'vertical' }} />
                  </div>
                  </div>
              </div>

              {/* ===== CARD ANEXOS ===== */}
              <div className="card" style={{ paddingTop: 14, paddingBottom: 16 }}>
                {sec('Anexos')}
                <div className="form-group">
                  <label className="form-label">Link da assinatura digital</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input className="form-input" placeholder="https://..." value={form.link_assinatura} onChange={e => setField('link_assinatura', e.target.value)} />
                    {/^https?:\/\//i.test(form.link_assinatura || '') && (
                      <a className="btn btn-secondary" href={form.link_assinatura.trim()} target="_blank" rel="noopener noreferrer" style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>Abrir</a>
                    )}
                  </div>
                </div>
                <AnexosAba apoliceId={editId} salvarApolice={salvarApoliceAutomatico} onEnviarEmail={abrirEnvioEmail} onEnviarWhatsApp={abrirEnvioWhatsApp} refreshKey={anexosRefreshKey} />
              </div>

                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10, marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setConfirmacao({ tipo: 'cancelar' })}>Cancelar</button>
                {editId && <button type="button" className="btn btn-danger btn-icon" title="Excluir" onClick={() => setConfirmacao({ tipo: 'excluir' })}><IconExcluir size={16} /></button>}
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvando...' : (form.eh_endosso ? 'Salvar Endosso' : form.tipo_documento === 'Proposta' ? 'Salvar Proposta' : 'Salvar Apólice')}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Confirmação */}
      {confirmacao && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: (confirmacao.tipo === 'salvarCancelamento' || confirmacao.tipo === 'salvarRecusa') ? 440 : 380, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            {confirmacao.tipo === 'salvarCancelamento' ? (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>⚠️</div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>Cancelar apólice</div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
                  Este endosso de <strong>{form.motivo}</strong> vai colocar a apólice — e todos os endossos anteriores dela — como <strong>Cancelada</strong> a partir da data de emissão. Deseja também cancelar as parcelas do prêmio ainda vincendas (não pagas)?
                </div>
                {form.motivo === 'Cancelamento por Sinistro' && (
                  <div style={{ fontSize: 12, color: '#854F0B', background: '#FAEEDA', padding: '8px 10px', borderRadius: 6, marginBottom: 16 }}>
                    ⚠ Em cancelamento por sinistro a apólice costuma ser quitada — normalmente as parcelas são mantidas.
                  </div>
                )}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button className="btn btn-secondary" onClick={() => setConfirmacao(null)} disabled={loading}>Voltar</button>
                  <button className="btn btn-secondary" onClick={() => confirmarSalvarCancelamento(false)} disabled={loading}>Manter parcelas</button>
                  <button className="btn btn-danger" onClick={() => confirmarSalvarCancelamento(true)} disabled={loading}>{loading ? 'Salvando...' : 'Cancelar parcelas e salvar'}</button>
                </div>
              </>
            ) : confirmacao.tipo === 'salvarRecusa' ? (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>⚠️</div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>Recusar proposta?</div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
                  {form.motivo === 'Novo'
                    ? 'Esta é a Proposta Inicial do cliente. Se ele não tiver nenhum outro documento vigente, o cadastro dele será marcado como Inativo ao salvar.'
                    : 'Esta é uma Proposta de Renovação. Se o cliente não tiver nenhum outro documento vigente, o cadastro dele será marcado como Inativo ao salvar.'}
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button className="btn btn-secondary" onClick={() => setConfirmacao(null)} disabled={loading}>Voltar</button>
                  <button className="btn btn-danger" onClick={confirmarSalvar} disabled={loading}>{loading ? 'Salvando...' : 'Sim, recusar e salvar'}</button>
                </div>
              </>
            ) : confirmacao.tipo === 'excluir' ? (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>⚠️</div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e', textTransform: 'capitalize' }}>Excluir {rotuloDocumento}?</div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
                  Excluir {umUma} {rotuloDocumento} é uma medida extrema no cadastro, use somente em último caso. O correto é recusá-l{oA} no sistema e cadastrar {umUma} nov{oA}, se for o caso.
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button className="btn btn-secondary" onClick={() => setConfirmacao(null)} disabled={loading}>Ok</button>
                  <button className="btn btn-danger" onClick={() => { setConfirmacao(null); setPedirSenhaMasterExcluir(true) }} disabled={loading}>Excluir mesmo assim</button>
                </div>
              </>
            ) : confirmacao.tipo === 'sairCliente' ? (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>💾</div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>Salvar antes de sair?</div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
                  Você tem alterações não salvas nesta proposta. Deseja salvar antes de ir para os dados do cliente?
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button className="btn btn-secondary" onClick={() => setConfirmacao(null)} disabled={loading}>Cancelar</button>
                  <button className="btn btn-danger" onClick={() => confirmarSairCliente(false)} disabled={loading}>Sair sem salvar</button>
                  <button className="btn btn-primary" onClick={() => confirmarSairCliente(true)} disabled={loading}>{loading ? 'Salvando...' : 'Salvar e sair'}</button>
                </div>
              </>
            ) : confirmacao.tipo === 'endossoSugerido' ? (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>❓</div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>PDF parece um Endosso</div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
                  Este PDF parece ser um Endosso da apólice nº <strong>{confirmacao.endossoInfo.numero_apolice}</strong> (vigência final {confirmacao.endossoInfo.vigencia_fim.split('-').reverse().join('/')}), não uma proposta nova. Deseja lançar como Endosso dessa apólice?
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button className="btn btn-secondary" disabled={loading} onClick={async () => {
                    const { data, file } = confirmacao
                    setConfirmacao(null)
                    await preencherEDecidirSalvar(data, file)
                  }}>Não, é proposta nova</button>
                  <button className="btn btn-primary" disabled={loading} onClick={async () => {
                    const { data, endossoInfo, file } = confirmacao
                    setConfirmacao(null)
                    const baseForm = await endossar(endossoInfo.apolice_id)
                    if (!baseForm) return
                    const merged = await preencherFormularioComDados(data, baseForm)
                    await criarApoliceEItemDoImport(merged, file, itensEndossoRef.current)
                  }}>Sim, é Endosso</button>
                </div>
              </>
            ) : (
              <>
                <div style={{ fontSize: 20, marginBottom: 8 }}>
                  {confirmacao.tipo === 'salvar' ? '💾' : '⚠️'}
                </div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>
                  {confirmacao.tipo === 'salvar' ? 'Salvar apólice?' : 'Cancelar edição?'}
                </div>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
                  {confirmacao.tipo === 'salvar'
                    ? 'Deseja salvar todas as informações preenchidas?'
                    : 'Deseja cancelar? As alterações não salvas serão perdidas.'}
                </div>
                <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                  <button className="btn btn-secondary" onClick={() => setConfirmacao(null)}>
                    {confirmacao.tipo === 'salvar' ? 'Voltar' : 'Continuar editando'}
                  </button>
                  <button
                    className={`btn ${confirmacao.tipo === 'salvar' ? 'btn-primary' : 'btn-danger'}`}
                    onClick={() => {
                      if (confirmacao.tipo === 'salvar') confirmarSalvar()
                      else { setConfirmacao(null); fecharModal() }
                    }}>
                    {confirmacao.tipo === 'salvar' ? 'Sim, salvar' : 'Sim, cancelar'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {pedirSenhaMasterExcluir && (
        <SenhaMasterModal
          titulo={`Excluir ${rotuloDocumento}?`}
          mensagem="Confirme com a Senha Master para excluir este documento definitivamente."
          onCancelar={() => setPedirSenhaMasterExcluir(false)}
          onConfirmar={async (senha) => {
            await confirmarExcluirDocumento(senha)
            setPedirSenhaMasterExcluir(false)
          }}
        />
      )}

      {/* Modal de Envio de E-mail (anexo da Proposta/Apólice) */}
      {whatsModal && (
        <div className="modal-overlay" style={{ zIndex: 400 }} onClick={e => { if (e.target === e.currentTarget) setWhatsModal(null) }}>
          <div className="modal" style={{ maxWidth: 560 }}>
            <div className="modal-header">
              <span className="modal-title">Enviar por WhatsApp</span>
              <button className="modal-close" onClick={() => setWhatsModal(null)}>×</button>
            </div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
              {whatsModal.anexos.length === 1 ? 'Anexo' : `Anexos (${whatsModal.anexos.length})`}: <strong>{whatsModal.anexos.map(a => a.nome).join(', ')}</strong>
              <div style={{ marginTop: 6 }}>O WhatsApp Web abre na conversa com a mensagem pronta e o PDF é baixado — arraste o arquivo para a conversa e envie.</div>
            </div>
            <div className="form-group">
              <label className="form-label">Modelo</label>
              <select className="form-select" value={whatsModal.templateId} disabled={whatsModal.carregando} onChange={e => aplicarModeloWhatsApp(e.target.value)}>
                <option value="">Selecione um modelo...</option>
                {emailTemplates.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Celular *</label>
              {whatsModal.telefones.length > 1 && (
                <select className="form-select" style={{ marginBottom: 6 }} value={whatsModal.telefones.some(t => t.numero === whatsModal.telefone) ? whatsModal.telefone : ''}
                  onChange={e => setWhatsModal(m => ({ ...m, telefone: e.target.value }))}>
                  {whatsModal.telefones.map((t, i) => <option key={i} value={t.numero}>{t.numero}{t.nome ? ` — ${t.nome}` : ''}</option>)}
                  <option value="">Outro (digitar abaixo)</option>
                </select>
              )}
              <input className="form-input" placeholder="(41) 99999-9999" value={whatsModal.telefone}
                onChange={e => setWhatsModal(m => ({ ...m, telefone: e.target.value }))} />
              {(() => {
                const obs = whatsModal.telefones.find(t => t.numero === whatsModal.telefone)?.nome
                return obs ? <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Obs.: {obs}</div> : null
              })()}
              {whatsModal.semMarcado && (
                <div style={{ fontSize: 12, color: '#b26a00', marginTop: 4 }}>Nenhum telefone deste cliente está marcado como WhatsApp no cadastro — mostrando todos.</div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Mensagem</label>
              <textarea className="form-input" rows={10} value={whatsModal.carregando ? 'Carregando...' : whatsModal.texto} disabled={whatsModal.carregando}
                onChange={e => setWhatsModal(m => ({ ...m, texto: e.target.value }))} style={{ resize: 'vertical' }} />
            </div>
            {whatsModal.erro && <div className="alert alert-error">{whatsModal.erro}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
              <button type="button" className="btn btn-secondary" onClick={() => setWhatsModal(null)}>Cancelar</button>
              <button type="button" className="btn" style={{ background: '#25D366', borderColor: '#25D366', color: '#fff' }}
                disabled={whatsModal.carregando} onClick={confirmarEnvioWhatsApp}>Abrir WhatsApp e baixar PDF</button>
            </div>
          </div>
        </div>
      )}
      {emailModal && (
        <div className="modal-overlay" style={{ zIndex: 400 }} onClick={e => { if (e.target === e.currentTarget) setEmailModal(null) }}>
          <div className="modal" style={{ maxWidth: 560 }}>
            <div className="modal-header">
              <span className="modal-title">Enviar por E-mail</span>
              <button className="modal-close" onClick={() => setEmailModal(null)}>×</button>
            </div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
              {emailModal.anexos.length === 1 ? 'Anexo' : `Anexos (${emailModal.anexos.length})`}: <strong>{emailModal.anexos.map(a => a.nome).join(', ')}</strong>
            </div>
            <div className="form-group">
              <label className="form-label">Modelo de e-mail</label>
              <select className="form-select" value={emailForm.templateId} onChange={e => aplicarTemplateEmail(e.target.value)}>
                <option value="">Selecione um modelo...</option>
                {emailTemplates.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Destinatário *</label>
              <input className="form-input" type="email" placeholder="email@exemplo.com" value={emailForm.destinatario} onChange={e => setEmailForm(f => ({ ...f, destinatario: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Assunto *</label>
              <input className="form-input" value={emailForm.assunto} onChange={e => setEmailForm(f => ({ ...f, assunto: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Mensagem</label>
              <textarea className="form-input" rows={8} value={emailForm.corpo} onChange={e => setEmailForm(f => ({ ...f, corpo: e.target.value }))} style={{ resize: 'vertical' }} />
            </div>
            {erroEmail && <div className="alert alert-error">{erroEmail}</div>}
            {emailEnviado && <div className="alert" style={{ background: 'var(--success-light)', color: 'var(--success)' }}>✓ E-mail enviado com sucesso!</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
              <button type="button" className="btn btn-secondary" onClick={() => setEmailModal(null)}>Cancelar</button>
              <button type="button" className="btn btn-primary" disabled={enviandoEmail || emailEnviado} onClick={enviarEmailAnexo}>{enviandoEmail ? 'Enviando...' : 'Enviar'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

// Componente de Editar Cliente inline (abre sobre a apólice)
// Componente de Itens da Apólice
const fmtMoney = v => {
  if (v === null || v === undefined || v === '') return ''
  const texto = String(v)
  const negativo = texto.includes('-')
  const n = typeof v === 'number'
    ? Math.abs(v)
    : (texto.includes(',')
      ? (parseFloat(texto.replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.')) || 0)
      : (parseFloat(texto.replace(/[^0-9.]/g, '')) || 0))
  const formatado = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${negativo ? '-' : ''}R$ ${formatado}`
}
const pMoney = v => parseFloat((v||'').replace(/[R$ .]/g,'').replace(',','.'))||0
// Dados do carro trocados por inteiro num endosso de substituicao de veiculo.
const CAMPOS_VEICULO_SUBSTITUICAO = ['item_fipe', 'item_modelo', 'item_ano_fab', 'item_ano_mod', 'item_zero_km', 'item_placa', 'item_chassi', 'item_cor', 'item_passageiros', 'item_combustivel']
// Auto + Residencial no mesmo seguro (pedido do usuario em 07/10).
const TIPOS_COMBINADO = ['Proteção Combinada', 'DUO', 'Auto + Res']
const RAMOS_AUTO_COMBINADO = ['Automóvel', 'Carta Verde']
const CAMPOS_LOCAL_RISCO = ['res_cep', 'res_endereco', 'res_numero', 'res_complemento', 'res_bairro', 'res_cidade', 'res_estado', 'res_tipo']
export function EtiquetaCombinado({ tipo }) {
  if (!tipo) return null
  return (
    <span title="Seguro Auto com residencial junto" style={{display:'inline-block',fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:10,background:'#E6F1FB',color:'#185FA5',whiteSpace:'nowrap',verticalAlign:'middle'}}>
      🏠 {tipo}
    </span>
  )
}

const initIF = (r) => ({ descricao_item:'', ramo:r||'', item_fipe:'', item_modelo:'', item_ano_fab:'', item_ano_mod:'', item_zero_km:'Não', item_placa:'', item_chassi:'', item_cor:'', item_passageiros:'', item_combustivel:'Flex', item_gnv:'Não', item_bonus:'', item_codigo_ci:'', item_casco:'Sem cobertura', item_pct_fipe:'', item_franquia:'Obrigatória', item_valor_franquia:'', item_rcf_mat:'', item_rcf_corp:'', item_danos_morais:'', item_app_morte:'', item_app_invalidez:'', item_app_dmh:'', item_assist24h:'', item_vidros:'', item_carro_reserva:'', item_obs:'', cond_nome:'', cond_cpf:'', cond_nascimento:'', cond_estado_civil:'', item_uso:'', item_uso_carga_tipo:'', item_condutores_jovens:'', res_cep:'', res_endereco:'', res_numero:'', res_complemento:'', res_bairro:'', res_cidade:'', res_estado:'', res_tipo:'', res_construcao:'', res_uso:'', res_renovacao:'', res_bonus:'', res_atividade:'', combinado_residencial:'' })

// As coberturas universais de Automóvel (Casco, Franquia, RCF, APP, Assist. 24h, Vidros, Carro
// Reserva...) agora vem 100% do cadastro dinamico (Cadastro > Coberturas) — sao pre-cadastradas
// como fixas (nao podem ser excluidas) pra toda seguradora, com tipo/opcoes editaveis por
// seguradora. Documentos antigos, de antes dessa mudanca, podem ter essas respostas guardadas nas
// colunas dedicadas da tabela (item_casco, item_franquia...) em vez de coberturas_dinamicas —
// esse mapa serve so pra continuar enxergando esses valores antigos ao editar o item.
const normalizarCampo = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim()
// Valor de uma cobertura pelo nome do campo do cadastro: exato primeiro; senao ignorando espaco
// sobrando, acento e maiuscula (o cadastro tem nomes como " Responsabilidade Civil Familiar" e
// "...Terceiros " com espaco a mais, que nunca batiam com o que o leitor do PDF devolve).
function pegarCobertura(obj, campo) {
  if (!obj || typeof obj !== 'object') return undefined
  if (obj[campo] !== undefined) return obj[campo]
  const alvo = normalizarCampo(campo)
  const chave = Object.keys(obj).find(k => normalizarCampo(k) === alvo)
  return chave !== undefined ? obj[chave] : undefined
}
const COLUNA_LEGADO_POR_CAMPO = [
  { bate: (c) => normalizarCampo(c) === 'casco', coluna: 'item_casco' },
  { bate: (c) => normalizarCampo(c).includes('fipe'), coluna: 'item_pct_fipe' },
  { bate: (c) => normalizarCampo(c) === 'franquia', coluna: 'item_franquia' },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('valor') && n.includes('franquia') }, coluna: 'item_valor_franquia', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('rcf') && n.includes('materia') }, coluna: 'item_rcf_mat', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('rcf') && n.includes('corpora') }, coluna: 'item_rcf_corp', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('danos') && n.includes('morais') }, coluna: 'item_danos_morais', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('app') && n.includes('morte') }, coluna: 'item_app_morte', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('app') && n.includes('invalidez') }, coluna: 'item_app_invalidez', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('app') && n.includes('dmh') }, coluna: 'item_app_dmh', moeda: true },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('assist') && n.includes('24') }, coluna: 'item_assist24h' },
  { bate: (c) => normalizarCampo(c).includes('vidro'), coluna: 'item_vidros' },
  { bate: (c) => { const n = normalizarCampo(c); return n.includes('carro') && n.includes('reserva') }, coluna: 'item_carro_reserva' },
]
const valorLegado = (item, campo) => {
  const def = COLUNA_LEGADO_POR_CAMPO.find(d => d.bate(campo))
  if (!def) return undefined
  const v = item[def.coluna]
  if (v === null || v === undefined || v === '') return undefined
  return def.moeda ? fmtMoney(v) : v
}

// Acha uma cobertura dinamica do item (cadastrada em Cadastro > Coberturas) pelo nome, ignorando
// acento/maiuscula — usado na lista-resumo de Itens de ramos sem campos proprios (ex.: Vida
// Individual), pra mostrar coberturas relevantes em vez de colunas de veiculo vazias.
const buscarCobertura = (item, ...termos) => {
  const dinamicas = item?.coberturas_dinamicas
  if (!dinamicas || typeof dinamicas !== 'object') return ''
  const chave = Object.keys(dinamicas).find(k => {
    const n = normalizarCampo(k)
    return termos.every(t => n.includes(t))
  })
  return (chave ? dinamicas[chave] : '') || ''
}

function ItensAba({ apoliceId, clienteId, ramo, seguradora, itensPendentes, setItensPendentes, dadosVeiculoImportado }) {
  const [itens, setItens] = useState([])
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(initIF(ramo))
  const [editItemId, setEditItemId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [coberturas, setCoberturas] = useState([])
  const [cobValues, setCobValues] = useState({})
  // Auto + Residencial (Proteção Combinada/DUO/Auto + Res): coberturas residenciais do item de
  // Automovel, com os campos de Cadastro > Coberturas > <seguradora> > Residencial.
  const [coberturasRes, setCoberturasRes] = useState([])
  const [cobResValues, setCobResValues] = useState({})
  const [buscandoCep, setBuscandoCep] = useState(false)
  const f = (campo, val) => setForm(p => ({...p, [campo]: val}))
  const sec = (t) => <div style={{fontSize:14,fontWeight:700,color:'var(--primary)',textTransform:'uppercase',letterSpacing:'0.06em',margin:'0 0 10px',paddingBottom:6,borderBottom:'2px solid var(--primary-light)'}}>{t}</div>

  // Local de Risco (Residencial/Empresarial/Condomínio): preenche Rua/Bairro/Cidade/Estado
  // automaticamente assim que o CEP completa os 8 digitos.
  const buscarCepItem = async (cepFormatado) => {
    const raw = cepFormatado.replace(/\D/g, '')
    if (raw.length !== 8) return
    setBuscandoCep(true)
    try {
      const res = await fetch(`https://viacep.com.br/ws/${raw}/json/`)
      const data = await res.json()
      if (!data.erro) {
        setForm(p => ({ ...p, res_endereco: data.logradouro || p.res_endereco, res_bairro: data.bairro || p.res_bairro, res_cidade: data.localidade || p.res_cidade, res_estado: data.uf || p.res_estado }))
      }
    } catch {}
    finally { setBuscandoCep(false) }
  }

  const carregarItens = (aid) => {
    if(!aid) return
    api.get(`/itens/apolice/${aid}`)
      .then(r => setItens(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItens([]))
  }
  // Documento ainda nao salvo (endosso/renovacao recem-aberto): mostra o preview dos itens que
  // serao copiados da apolice/endosso de origem ao salvar, em vez de ir buscar por apoliceId (null).
  useEffect(() => {
    if (apoliceId) carregarItens(apoliceId)
    else setItens(Array.isArray(itensPendentes) ? itensPendentes : [])
  }, [apoliceId, itensPendentes])

  useEffect(() => {
    if (!seguradora || !RAMOS_AUTO_COMBINADO.includes(ramo)) { setCoberturasRes([]); return }
    api.get(`/coberturas/${encodeURIComponent(seguradora)}/Residencial`)
      .then(r => setCoberturasRes(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCoberturasRes([]))
  }, [seguradora, ramo])

  // Valores do combinado vindos do PDF/banco -> formato do formulario (moeda formatada).
  const valoresCombinado = (origem) => {
    const vals = {}
    const fonte = origem && typeof origem === 'object' ? origem : {}
    coberturasRes.forEach(c => {
      const v = pegarCobertura(fonte, c.campo)
      vals[c.campo] = v === undefined || v === null || v === '' ? '' : (c.tipo === 'moeda' ? fmtMoney(v) : v)
    })
    return vals
  }

  useEffect(() => {
    if(!seguradora || !ramo) { setCoberturas([]); return }
    api.get(`/coberturas/${encodeURIComponent(seguradora)}/${encodeURIComponent(ramo)}`)
      .then(r => setCoberturas(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCoberturas([]))
  }, [seguradora, ramo])

  const abrirNovo = () => {
    setEditItemId(null)
    const base = initIF(ramo)
    const vals = {}
    coberturas.forEach(c => { vals[c.campo] = '' })
    // Primeiro item de um documento recem-importado de PDF (Automóvel/Carta Verde): traz os dados
    // do veiculo que o parser ja extraiu pro form da Proposta, em vez de abrir tudo em branco de
    // novo. So no primeiro item — a partir do 2º, cada veiculo e diferente e deve ser digitado.
    if (itens.length === 0 && ['Automóvel', 'Carta Verde', 'Residencial', 'Empresarial'].includes(ramo) && dadosVeiculoImportado) {
      const p = dadosVeiculoImportado
      const camposTexto = ['Residencial', 'Empresarial'].includes(ramo)
        ? ['res_cep','res_endereco','res_numero','res_complemento','res_bairro','res_cidade','res_estado','res_construcao','res_tipo','res_uso','res_atividade','item_obs']
        : ['item_fipe','item_modelo','item_ano_fab','item_ano_mod','item_zero_km','item_placa','item_chassi','item_passageiros','item_combustivel','item_gnv','item_bonus','item_codigo_ci','item_casco','item_obs','cond_nome','cond_cpf','cond_nascimento','cond_estado_civil','item_uso','item_uso_carga_tipo','item_condutores_jovens']
      camposTexto.forEach(c => { if (p[c]) base[c] = p[c] })
      if (p.combinado_residencial && RAMOS_AUTO_COMBINADO.includes(ramo)) {
        base.combinado_residencial = p.combinado_residencial
        CAMPOS_LOCAL_RISCO.forEach(c => { if (p[c]) base[c] = p[c] })
      }
      const camposMoeda = ['item_rcf_mat','item_rcf_corp','item_app_morte','item_app_invalidez']
      camposMoeda.forEach(c => { if (p[c] != null && p[c] !== '') base[c] = fmtMoney(p[c]) })
      if (p.coberturas_dinamicas && typeof p.coberturas_dinamicas === 'object') {
        // Piloto de IA (Yelum): ja devolve os valores prontos, por nome de campo da cobertura.
        coberturas.forEach(c => {
          const v = pegarCobertura(p.coberturas_dinamicas, c.campo)
          if (v !== undefined && v !== null && v !== '') vals[c.campo] = c.tipo === 'moeda' ? fmtMoney(v) : v
        })
        // "Valor do Casco" nao e' campo do cadastro (substitui o % FIPE em Valor Determinado)
        const casco = p.coberturas_dinamicas['Valor do Casco']
        if (casco) vals['Valor do Casco'] = fmtMoney(casco)
      } else {
        // Parser de regex (demais seguradoras): Casco, RCF, APP etc. agora sao coberturas
        // dinamicas — usa o mesmo mapa de campo legado -> coluna que ja serve pra enxergar
        // valores antigos ao editar item, so que aqui na direcao inversa: cobertura dinamica
        // <- valor que o parser guardou na coluna legada.
        coberturas.forEach(c => {
          const v = valorLegado(p, c.campo)
          if (v !== undefined && v !== '') vals[c.campo] = v
        })
      }
    }
    setForm(base)
    setCobValues(vals)
    setCobResValues(valoresCombinado(itens.length === 0 ? dadosVeiculoImportado?.coberturas_residencial : null))
    setModal(true)
  }
  const abrirEditar = (item) => {
    setEditItemId(item.id)
    setForm({ descricao_item:item.descricao_item||'', ramo:item.ramo||ramo||'', item_fipe:item.item_fipe||'', item_modelo:item.item_modelo||'', item_ano_fab:item.item_ano_fab||'', item_ano_mod:item.item_ano_mod||'', item_zero_km:item.item_zero_km||'Não', item_placa:item.item_placa||'', item_chassi:item.item_chassi||'', item_cor:item.item_cor||'', item_passageiros:item.item_passageiros||'', item_combustivel:item.item_combustivel||'Flex', item_gnv:item.item_gnv||'Não', item_bonus:item.item_bonus||'', item_codigo_ci:item.item_codigo_ci||'', item_casco:item.item_casco||'Sem cobertura', item_pct_fipe:item.item_pct_fipe||'', item_franquia:item.item_franquia||'Obrigatória', item_valor_franquia:item.item_valor_franquia?fmtMoney(item.item_valor_franquia):'', item_rcf_mat:item.item_rcf_mat?fmtMoney(item.item_rcf_mat):'', item_rcf_corp:item.item_rcf_corp?fmtMoney(item.item_rcf_corp):'', item_danos_morais:item.item_danos_morais?fmtMoney(item.item_danos_morais):'', item_app_morte:item.item_app_morte?fmtMoney(item.item_app_morte):'', item_app_invalidez:item.item_app_invalidez?fmtMoney(item.item_app_invalidez):'', item_app_dmh:item.item_app_dmh?fmtMoney(item.item_app_dmh):'', item_assist24h:item.item_assist24h||'', item_vidros:item.item_vidros||'', item_carro_reserva:item.item_carro_reserva||'', item_obs:item.item_obs||'',
      cond_nome:item.cond_nome||'', cond_cpf:item.cond_cpf||'', cond_nascimento:item.cond_nascimento?item.cond_nascimento.split('T')[0]:'', cond_estado_civil:item.cond_estado_civil||'', item_uso:item.item_uso||'', item_uso_carga_tipo:item.item_uso_carga_tipo||'', item_condutores_jovens:item.item_condutores_jovens||'',
      res_cep:item.res_cep||'', res_endereco:item.res_endereco||'', res_numero:item.res_numero||'', res_complemento:item.res_complemento||'', res_bairro:item.res_bairro||'', res_cidade:item.res_cidade||'', res_estado:item.res_estado||'', res_tipo:item.res_tipo||'', res_construcao:item.res_construcao||'', res_uso:item.res_uso||'', res_renovacao:item.res_renovacao||'', res_bonus:item.res_bonus||'', res_atividade:item.res_atividade||'', combinado_residencial:item.combinado_residencial||''  })
    setCobResValues(valoresCombinado(item.coberturas_residencial))
    const vals = {}
    coberturas.forEach(c => {
      const valor = pegarCobertura(item.coberturas_dinamicas, c.campo) ?? valorLegado(item, c.campo) ?? ''
      vals[c.campo] = c.tipo === 'moeda' ? fmtMoney(valor) : valor
    })
    if (item.coberturas_dinamicas?.['Valor do Casco']) vals['Valor do Casco'] = fmtMoney(item.coberturas_dinamicas['Valor do Casco'])
    const extras = item.coberturas_dinamicas?.[CHAVE_BENEFICIARIOS_EXTRAS]
    if (Array.isArray(extras) && extras.length) vals[CHAVE_BENEFICIARIOS_EXTRAS] = extras
    setCobValues(vals)
    setModal(true)
  }
  const excluir = async (id) => {
    if (!(await confirmar('Excluir este item?'))) return
    // Documento ainda nao salvo (Renovar/Endossar/Novo antes do Salvar principal): o item so
    // existe na lista local de pendentes, que e copiada para o backend quando o documento e salvo.
    if (!apoliceId) {
      const novaLista = itens.filter(it => String(it.id) !== String(id))
      setItens(novaLista)
      if (setItensPendentes) setItensPendentes(novaLista)
      return
    }
    await api.delete(`/itens/${id}`)
    carregarItens(apoliceId)
  }
  const salvar = async (e) => {
    if(e && e.preventDefault) e.preventDefault()
    if(e && e.stopPropagation) e.stopPropagation()
    setLoading(true)
    try {
      if (!apoliceId) {
        const payload = { ...form, coberturas_dinamicas: cobValues, coberturas_residencial: form.combinado_residencial ? cobResValues : {} }
        const novaLista = editItemId != null
          ? itens.map(it => String(it.id) === String(editItemId) ? { ...it, ...payload, id: it.id } : it)
          : [...itens, { ...payload, id: `novo-${Date.now()}` }]
        setItens(novaLista)
        if (setItensPendentes) setItensPendentes(novaLista)
        setModal(false)
        return
      }
      const payload = { ...form, apolice_id: apoliceId, coberturas_dinamicas: cobValues, coberturas_residencial: form.combinado_residencial ? cobResValues : {} }
      if(editItemId) await api.put(`/itens/${editItemId}`, payload)
      else await api.post('/itens', payload)
      setModal(false)
      carregarItens(apoliceId)
    } catch(err) { avisar('Erro ao salvar item: '+(err.response?.data?.erro || err.message)) }
    finally { setLoading(false) }
  }

  // `combinado`: campo das coberturas residenciais do Auto + Residencial (outro conjunto de valores).
  const renderCampoDinamico = (cob, combinado = false, pctDecimal = false) => {
    const opcoes = Array.isArray(cob.opcoes) ? cob.opcoes : (typeof cob.opcoes === 'string' ? JSON.parse(cob.opcoes || '[]') : [])
    const val = (combinado ? cobResValues : cobValues)[cob.campo] || ''
    const set = (v) => {
      if (combinado) { setCobResValues(p => ({...p, [cob.campo]: v})); return }
      // Lógica automática Allianz: Vidros → Proteção de Pneus e Pequenos Reparos
      if(seguradora === 'Allianz' && cob.campo === 'Vidros') {
        const plano34 = v.includes('Plano 3') || v.includes('Planos 3') || v.includes('Plano 4')
        const autoVal = plano34 ? 'Sim' : 'Não'
        setCobValues(p => ({...p, [cob.campo]: v, 'Proteção de Pneus': autoVal, 'Pequenos Reparos': autoVal}))
      } else {
        setCobValues(p => ({...p, [cob.campo]: v}))
      }
    }
    // Modalidade "Valor Determinado": nao existe % da FIPE, o casco e' contratado por um valor fixo —
    // o campo "% FIPE" vira "Valor do Casco" (moeda), gravado em coberturas_dinamicas['Valor do Casco'].
    if (!combinado && normalizarCampo(cob.campo).includes('fipe')) {
      const chaveModalidade = Object.keys(cobValues).find(k => normalizarCampo(k) === 'modalidade')
      if (/determinad/i.test(cobValues[chaveModalidade] || '')) {
        const valCasco = cobValues['Valor do Casco'] || ''
        const setCasco = (v) => setCobValues(p => ({ ...p, 'Valor do Casco': v }))
        return (
          <div key={cob.campo} className="form-group">
            <label className="form-label">Valor do Casco</label>
            <input className="form-input" placeholder="R$ 0,00" value={valCasco}
              onChange={e=>setCasco(e.target.value)}
              onBlur={e=>setCasco(e.target.value.trim() === '' ? '' : fmtMoney(pMoney(e.target.value)))} />
          </div>
        )
      }
    }
    if(cob.tipo === 'lista') return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <select className="form-select" value={val} onChange={e=>set(e.target.value)}>
          <option value="">—</option>
          {/* value explicito: sem ele o navegador colapsa espaco duplo do texto ("15  Dias CR Manual")
              e o valor salvo deixa de bater com a opcao, aparecendo em branco */}
          {opcoes.map(o=><option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    )
    if(cob.tipo === 'booleano') return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <select className="form-select" value={val} onChange={e=>set(e.target.value)}>
          <option value="">—</option>
          <option>Sim</option><option>Não</option>
        </select>
      </div>
    )
    if(cob.tipo === 'moeda') return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <input className="form-input" placeholder="R$ 0,00" value={val}
          onChange={e=>set(e.target.value)}
          onBlur={e=>set(e.target.value.trim() === '' ? '' : fmtMoney(pMoney(e.target.value)))} />
      </div>
    )
    if(cob.tipo === 'texto') return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <input className="form-input" placeholder="Digite..." value={val} onChange={e=>set(e.target.value)} />
      </div>
    )
    if (pctDecimal) return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <input className="form-input" value={val}
          onChange={e=>set(digitarPctDecimal(e.target.value))}
          onBlur={e=>set(formatarPctDecimal(e.target.value))}
          placeholder="%" />
      </div>
    )
    return (
      <div key={cob.campo} className="form-group">
        <label className="form-label">{cob.campo}</label>
        <input className="form-input" value={val}
          onChange={e=>set(e.target.value.replace(/\D/g,'').slice(0,3))}
          onBlur={e=>{ const v = e.target.value.replace(/\D/g,''); if(v) set(parseInt(v)+'%') }}
          placeholder="%" />
      </div>
    )
  }

  return (<>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
      <span style={{fontSize:13,color:'#555'}}><strong>{itens.length}</strong> item(ns)</span>
      <button type="button" className="btn btn-primary btn-sm" onClick={abrirNovo}>+ Adicionar Item</button>
    </div>
    {!apoliceId && (!clienteId || !seguradora || !ramo) && <div style={{padding:16,background:'#FAEEDA',borderRadius:8,fontSize:13,color:'#854F0B'}}>⚠ Preencha o Segurado, Seguradora e Ramo no card Dados antes de adicionar itens.</div>}
    {itens.length===0 && apoliceId && <div style={{padding:32,textAlign:'center',color:'#aaa',background:'#f8f9fa',borderRadius:8}}>Nenhum item. Clique em "+ Adicionar Item".</div>}
    {itens.length>0 && (
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:13,tableLayout:'fixed'}}>
        <thead><tr style={{background:'#f8f9fa'}}>
          <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600,width:50}}>Item</th>
          {ramo === 'Vida Individual' ? (<>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600}}>Segurado</th>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600}}>Cobertura de Morte</th>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600}}>Cobertura de Funeral</th>
          </>) : ['Residencial', 'Empresarial', 'Condomínio'].includes(ramo) ? (<>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600,width:130}}>CEP</th>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600}}>Endereço</th>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600,width:ramo === 'Empresarial' ? 260 : 140}}>{ramo === 'Empresarial' ? 'Atividade' : 'Tipo'}</th>
          </>) : (<>
            <th style={{padding:'8px 12px',textAlign:'left',fontSize:11,color:'#888',fontWeight:600}}>Veículo</th>
            <th style={{padding:'8px 12px',textAlign:'center',fontSize:11,color:'#888',fontWeight:600,width:120}}>Ano Fabricação</th>
            <th style={{padding:'8px 12px',textAlign:'center',fontSize:11,color:'#888',fontWeight:600,width:110}}>Ano Modelo</th>
            <th style={{padding:'8px 12px',textAlign:'center',fontSize:11,color:'#888',fontWeight:600,width:100}}>Placa</th>
          </>)}
          <th style={{width:150,padding:'8px 12px'}}></th>
        </tr></thead>
        <tbody>{itens.map(item => (
          <tr key={item.id} style={{borderBottom:'1px solid #f0f0f0'}}>
            <td style={{padding:'10px 12px',fontWeight:700,fontSize:16,color:'var(--primary)'}}>{String(item.numero_item).padStart(2,'0')}</td>
            {ramo === 'Vida Individual' ? (<>
              <td style={{padding:'10px 12px',fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.descricao_item||'—'}</td>
              <td style={{padding:'10px 12px'}}>{buscarCobertura(item,'morte')||'—'}</td>
              <td style={{padding:'10px 12px'}}>{buscarCobertura(item,'funeral')||'—'}</td>
            </>) : ['Residencial', 'Empresarial', 'Condomínio'].includes(ramo) ? (<>
              <td style={{padding:'10px 12px'}}>{item.res_cep||'—'}</td>
              <td style={{padding:'10px 12px',fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.res_endereco ? `${item.res_endereco}${item.res_numero ? ', '+item.res_numero : ''}` : '—'}</td>
              <td style={{padding:'10px 12px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={ramo === 'Empresarial' ? (item.res_atividade || '') : undefined}>{(ramo === 'Empresarial' ? item.res_atividade : item.res_tipo)||'—'}</td>
            </>) : (<>
              <td style={{padding:'10px 12px',fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                {item.item_modelo||'—'}
                {item.combinado_residencial && <span style={{marginLeft:8}}><EtiquetaCombinado tipo={item.combinado_residencial} /></span>}
              </td>
              <td style={{padding:'10px 12px',textAlign:'center'}}>{item.item_ano_fab||'—'}</td>
              <td style={{padding:'10px 12px',textAlign:'center'}}>{item.item_ano_mod||'—'}</td>
              <td style={{padding:'10px 12px',textAlign:'center'}}>{item.item_placa||'—'}</td>
            </>)}
            <td style={{padding:'10px 12px'}}>
              <div style={{display:'flex',gap:6}}>
                <button type="button" className="btn btn-secondary btn-sm btn-icon" title="Editar" onClick={()=>abrirEditar(item)}><IconEditar size={14} /></button>
                <button type="button" className="btn btn-danger btn-sm btn-icon" title="Excluir" onClick={()=>excluir(item.id)}><IconExcluir size={14} /></button>
              </div>
            </td>
          </tr>
        ))}</tbody>
      </table>
    )}
    {modal && ReactDOM.createPortal(
      <div className="modal-overlay" style={{zIndex:9999}} onClick={e => { e.stopPropagation(); if(e.target === e.currentTarget) setModal(false) }}>
        <div className="modal" style={{maxWidth:960, width:'95vw'}} onClick={e => e.stopPropagation()}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
            <span style={{fontSize:16,fontWeight:600}}>{editItemId?'Editar Item':'Novo Item'}</span>
            <button onClick={()=>setModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#888'}}>×</button>
          </div>
          <div>
            {/* ===== DADOS DO VEÍCULO (Automóvel / Carta Verde) ===== */}
            {['Automóvel', 'Carta Verde'].includes(ramo) && (<>
            {sec('Dados do Veículo')}
            <div style={{display:'grid',gridTemplateColumns:'120px 1fr 90px 90px 80px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Nº FIPE</label><input className="form-input" value={form.item_fipe} onChange={e=>f('item_fipe',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Modelo</label><input className="form-input" value={form.item_modelo} onChange={e=>f('item_modelo',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Ano Fab.</label><input className="form-input" maxLength={4} value={form.item_ano_fab} onChange={e=>f('item_ano_fab',e.target.value.replace(/\D/g,'').slice(0,4))} placeholder="0000" /></div>
              <div className="form-group"><label className="form-label">Ano Mod.</label><input className="form-input" maxLength={4} value={form.item_ano_mod} onChange={e=>f('item_ano_mod',e.target.value.replace(/\D/g,'').slice(0,4))} placeholder="0000" /></div>
              <div className="form-group"><label className="form-label">Zero km?</label><select className="form-select" value={form.item_zero_km} onChange={e=>f('item_zero_km',e.target.value)}><option>Não</option><option>Sim</option></select></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'110px 1fr 110px 80px 1fr 70px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Placa</label><input className="form-input" maxLength={7} value={form.item_placa} onChange={e=>f('item_placa',e.target.value.toUpperCase().slice(0,7))} placeholder="ABC1234" /></div>
              <div className="form-group"><label className="form-label">Chassi</label><input className="form-input" maxLength={17} value={form.item_chassi} onChange={e=>f('item_chassi',e.target.value.toUpperCase().slice(0,17))} /></div>
              <div className="form-group"><label className="form-label">Cor</label><input className="form-input" maxLength={12} value={form.item_cor} onChange={e=>f('item_cor',e.target.value.slice(0,12))} /></div>
              <div className="form-group"><label className="form-label">Passag.</label><input className="form-input" maxLength={2} value={form.item_passageiros} onChange={e=>f('item_passageiros',e.target.value.replace(/\D/g,'').slice(0,2))} /></div>
              <div className="form-group"><label className="form-label">Combustível</label><select className="form-select" value={form.item_combustivel} onChange={e=>f('item_combustivel',e.target.value)}>{['Flex','Gasolina','Etanol','Elétrico','Híbrido','Outros'].map(c=><option key={c}>{c}</option>)}</select></div>
              <div className="form-group"><label className="form-label">GNV?</label><select className="form-select" value={form.item_gnv} onChange={e=>f('item_gnv',e.target.value)}><option>Não</option><option>Sim</option></select></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'80px 1fr',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Bônus</label><input className="form-input" maxLength={2} value={form.item_bonus} onChange={e=>f('item_bonus',e.target.value.replace(/\D/g,'').slice(0,2))} /></div>
              <div className="form-group"><label className="form-label">Código C.I.</label><input className="form-input" maxLength={18} value={form.item_codigo_ci} onChange={e=>f('item_codigo_ci',e.target.value.replace(/\D/g,'').slice(0,18))} /></div>
            </div>

            {sec('Dados do Condutor')}
            <div style={{display:'grid',gridTemplateColumns:'1fr 160px 140px 170px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Nome do Condutor</label><input className="form-input" value={form.cond_nome} onChange={e=>f('cond_nome',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">CPF</label><input className="form-input" maxLength={14} value={form.cond_cpf} onChange={e=>f('cond_cpf',maskCPF(e.target.value))} placeholder="000.000.000-00" /></div>
              <div className="form-group"><label className="form-label">Nascimento</label><input type="date" className="form-input" value={form.cond_nascimento} onChange={e=>f('cond_nascimento',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Estado Civil</label>
                <select className="form-select" value={form.cond_estado_civil} onChange={e=>f('cond_estado_civil',e.target.value)}>
                  <option value="">—</option>
                  {['Solteiro(a)','Casado(a)','Divorciado(a)','Viúvo(a)','União Estável'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns: form.item_uso === 'Transporte de Carga' ? '1fr 1fr 1fr' : '1fr 1fr',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Uso do Veículo</label>
                <select className="form-select" value={form.item_uso} onChange={e=>f('item_uso',e.target.value)}>
                  <option value="">—</option>
                  {['Particular','Comercial','Transporte de Aplicativo','Transporte de Carga','Locadora'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              {form.item_uso === 'Transporte de Carga' && (
                <div className="form-group"><label className="form-label">Tipo de Carga</label><input className="form-input" value={form.item_uso_carga_tipo} onChange={e=>f('item_uso_carga_tipo',e.target.value)} /></div>
              )}
              <div className="form-group"><label className="form-label">Condutores Jovens?</label>
                <select className="form-select" value={form.item_condutores_jovens} onChange={e=>f('item_condutores_jovens',e.target.value)}>
                  <option value="">—</option>
                  {['Sim do sexo feminino','Sim do sexo masculino','Sim de ambos os sexos','Não'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            </div>
            </>)}

            {/* ===== DADOS DO IMÓVEL (Empresarial / Condomínio) ===== */}
            {['Empresarial', 'Condomínio'].includes(ramo) && (<>
            {sec('Local de Risco')}
            <div style={{display:'grid',gridTemplateColumns:'130px 1fr 80px 1fr',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">CEP {buscandoCep && <span style={{color:'#888',fontWeight:400}}>buscando...</span>}</label>
                <input className="form-input" maxLength={10} placeholder="00.000-000"
                  value={form.res_cep||''}
                  onChange={e=>{
                    let v=e.target.value.replace(/\D/g,'').slice(0,8)
                    if(v.length>5) v=v.slice(0,2)+'.'+v.slice(2,5)+'-'+v.slice(5)
                    else if(v.length>2) v=v.slice(0,2)+'.'+v.slice(2)
                    f('res_cep',v)
                    buscarCepItem(v)
                  }} />
              </div>
              <div className="form-group"><label className="form-label">Endereço</label><input className="form-input" value={form.res_endereco||''} onChange={e=>f('res_endereco',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Número</label><input className="form-input" maxLength={6} value={form.res_numero||''} onChange={e=>f('res_numero',e.target.value.replace(/\D/g,'').slice(0,6))} /></div>
              <div className="form-group"><label className="form-label">Complemento</label><input className="form-input" maxLength={20} value={form.res_complemento||''} onChange={e=>f('res_complemento',e.target.value.slice(0,20))} /></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 60px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Bairro</label><input className="form-input" maxLength={30} value={form.res_bairro||''} onChange={e=>f('res_bairro',e.target.value.slice(0,30))} /></div>
              <div className="form-group"><label className="form-label">Cidade</label><input className="form-input" maxLength={30} value={form.res_cidade||''} onChange={e=>f('res_cidade',e.target.value.slice(0,30))} /></div>
              <div className="form-group"><label className="form-label">Estado</label><input className="form-input" maxLength={2} value={form.res_estado||''} onChange={e=>f('res_estado',e.target.value.toUpperCase().slice(0,2))} placeholder="UF" /></div>
            </div>
            {ramo === 'Empresarial' ? (
            // Empresarial: sem Tipo de Residência/Uso; Atividade da empresa no lugar
            <div style={{display:'grid',gridTemplateColumns:'1fr 2fr',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Construção</label>
                <select className="form-select" value={form.res_construcao||''} onChange={e=>f('res_construcao',e.target.value)}>
                  <option value="">—</option>
                  {['Superior','Sólida','Mista','Inferior'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Atividade</label>
                <input className="form-input" maxLength={255} value={form.res_atividade||''} onChange={e=>f('res_atividade',e.target.value)} placeholder="Atividade da empresa no local" />
              </div>
            </div>
            ) : (
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Tipo de Residência</label>
                <select className="form-select" value={form.res_tipo||''} onChange={e=>f('res_tipo',e.target.value)}>
                  <option value="">—</option>
                  {['Casa','Apartamento','Condomínio Fechado'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Construção</label>
                <select className="form-select" value={form.res_construcao||''} onChange={e=>f('res_construcao',e.target.value)}>
                  <option value="">—</option>
                  {['Superior','Sólida','Mista','Inferior'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Uso</label>
                <select className="form-select" value={form.res_uso||''} onChange={e=>f('res_uso',e.target.value)}>
                  <option value="">—</option>
                  {['Habitual','Veraneio','Desocupado'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            </div>
            )}
            <div style={{display:'grid',gridTemplateColumns:'120px 80px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Renovação</label>
                <select className="form-select" value={form.res_renovacao||''} onChange={e=>f('res_renovacao',e.target.value)}>
                  <option value="">—</option>
                  <option>Sim</option><option>Não</option>
                </select>
              </div>
              <div className="form-group"><label className="form-label">Bônus</label><input className="form-input" maxLength={2} value={form.res_bonus||''} onChange={e=>f('res_bonus',e.target.value.replace(/\D/g,'').slice(0,2))} /></div>
            </div>
            </>)}

            {/* ===== LOCAL DE RISCO + IMÓVEL (Residencial) ===== */}
            {ramo === 'Residencial' && (<>
            {sec('Local de Risco')}
            <div style={{display:'grid',gridTemplateColumns:'130px 1fr 80px 1fr',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">CEP {buscandoCep && <span style={{color:'#888',fontWeight:400}}>buscando...</span>}</label>
                <input className="form-input" maxLength={10} placeholder="00.000-000"
                  value={form.res_cep||''}
                  onChange={e=>{
                    let v=e.target.value.replace(/\D/g,'').slice(0,8)
                    if(v.length>5) v=v.slice(0,2)+'.'+v.slice(2,5)+'-'+v.slice(5)
                    else if(v.length>2) v=v.slice(0,2)+'.'+v.slice(2)
                    f('res_cep',v)
                    buscarCepItem(v)
                  }} />
              </div>
              <div className="form-group"><label className="form-label">Rua</label><input className="form-input" value={form.res_endereco||''} onChange={e=>f('res_endereco',e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Número</label><input className="form-input" maxLength={6} value={form.res_numero||''} onChange={e=>f('res_numero',e.target.value.replace(/\D/g,'').slice(0,6))} /></div>
              <div className="form-group"><label className="form-label">Complemento</label><input className="form-input" maxLength={20} value={form.res_complemento||''} onChange={e=>f('res_complemento',e.target.value.slice(0,20))} /></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 60px',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Bairro</label><input className="form-input" maxLength={30} value={form.res_bairro||''} onChange={e=>f('res_bairro',e.target.value.slice(0,30))} /></div>
              <div className="form-group"><label className="form-label">Cidade</label><input className="form-input" maxLength={30} value={form.res_cidade||''} onChange={e=>f('res_cidade',e.target.value.slice(0,30))} /></div>
              <div className="form-group"><label className="form-label">Estado</label><input className="form-input" maxLength={2} value={form.res_estado||''} onChange={e=>f('res_estado',e.target.value.toUpperCase().slice(0,2))} placeholder="UF" /></div>
            </div>
            {sec('Imóvel')}
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',rowGap:5,columnGap:12}}>
              <div className="form-group"><label className="form-label">Construção</label>
                <select className="form-select" value={form.res_construcao||''} onChange={e=>f('res_construcao',e.target.value)}>
                  <option value="">—</option>
                  {['Superior','Sólida','Mista','Inferior'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Tipo</label>
                <select className="form-select" value={form.res_tipo||''} onChange={e=>f('res_tipo',e.target.value)}>
                  <option value="">—</option>
                  {['Casa','Casa em Condomínio','Apartamento'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Uso</label>
                <select className="form-select" value={form.res_uso||''} onChange={e=>f('res_uso',e.target.value)}>
                  <option value="">—</option>
                  {['Habitual','Veraneio','Desocupado'].map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            </div>
            <div className="form-group"><label className="form-label">Observações</label><textarea className="form-input" rows={3} value={form.item_obs} onChange={e=>f('item_obs',e.target.value)} style={{resize:'vertical'}} /></div>
            </>)}

            {/* ===== DADOS DO ITEM (Bike / Equipamentos) ===== */}
            {['Bike', 'Equipamentos'].includes(ramo) && (<>
            {sec(ramo === 'Bike' ? 'Dados da Bike' : 'Dados do Equipamento')}
            <div className="form-group">
              <label className="form-label">Modelo</label>
              <input className="form-input" value={form.descricao_item} onChange={e=>f('descricao_item',e.target.value)} placeholder={ramo === 'Bike' ? 'Ex: Caloi Elite Carbon 2024' : 'Ex: Notebook Dell Inspiron'} />
            </div>
            </>)}

            {/* ===== SEGURADO (Vida Individual) ===== */}
            {ramo === 'Vida Individual' && (<>
            {sec('Segurado')}
            <div className="form-group">
              <label className="form-label">Nome do Segurado</label>
              <input className="form-input" value={form.descricao_item} onChange={e=>f('descricao_item',e.target.value)} placeholder="Nome completo do segurado" />
            </div>
            </>)}

            {/* Coberturas: 100% cadastro dinamico (Cadastro > Coberturas). As universais de
                Automóvel vem pre-cadastradas como fixas (nao aparecem aqui se a seguradora nao
                tiver nenhuma cobertura cadastrada pro ramo — cai no aviso abaixo). */}
            {ramo === 'Vida Individual' ? (() => {
              const norm = (c) => normalizarCampo(c.campo)
              const cobNomeSegurado = coberturas.find(c => norm(c) === 'nome do segurado')
              const cobBeneficiario = coberturas.find(c => norm(c).includes('beneficiario'))
              const cobIndenizacao = coberturas.find(c => norm(c).includes('indenizacao'))
              const cobParentesco = coberturas.find(c => norm(c).includes('parentesco'))
              const cobMorte = coberturas.find(c => norm(c) === 'morte')
              const fixas = [cobNomeSegurado, cobBeneficiario, cobIndenizacao, cobParentesco, cobMorte].filter(Boolean)
              const demaisCoberturas = coberturas.filter(c => !fixas.includes(c))
              return (<>
                {(cobBeneficiario || cobIndenizacao || cobParentesco || cobMorte) && (<>
                  {sec(`Coberturas — ${seguradora}`)}
                  {(cobBeneficiario || cobIndenizacao || cobParentesco) && (
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',rowGap:5,columnGap:12}}>
                      {cobBeneficiario && renderCampoDinamico(cobBeneficiario)}
                      {cobIndenizacao && renderCampoDinamico(cobIndenizacao, false, true)}
                      {cobParentesco && renderCampoDinamico(cobParentesco)}
                    </div>
                  )}
                  {/* Beneficiarios a partir do 2o: lista em coberturas_dinamicas[CHAVE_BENEFICIARIOS_EXTRAS];
                      o 1o continua nos campos do Cadastro > Coberturas acima. */}
                  {cobBeneficiario && (() => {
                    const extras = Array.isArray(cobValues[CHAVE_BENEFICIARIOS_EXTRAS]) ? cobValues[CHAVE_BENEFICIARIOS_EXTRAS] : []
                    const setExtras = (lista) => setCobValues(p => ({ ...p, [CHAVE_BENEFICIARIOS_EXTRAS]: lista }))
                    const setExtra = (i, campo, v) => setExtras(extras.map((b, idx) => idx === i ? { ...b, [campo]: v } : b))
                    const pctNum = v => parsePct(digitarPctDecimal(v))
                    const totalPct = Math.round((pctNum(cobIndenizacao && cobValues[cobIndenizacao.campo]) + extras.reduce((s, b) => s + pctNum(b.pct), 0)) * 100) / 100
                    return (<>
                      {extras.map((b, i) => (
                        <div key={i} style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 32px',rowGap:5,columnGap:12,alignItems:'end'}}>
                          <div className="form-group"><label className="form-label">Beneficiário {i + 2}</label>
                            <input className="form-input" placeholder="Digite..." value={b.nome || ''} onChange={e=>setExtra(i,'nome',e.target.value)} /></div>
                          <div className="form-group"><label className="form-label">% Indenização</label>
                            <input className="form-input" placeholder="%" value={b.pct || ''}
                              onChange={e=>setExtra(i,'pct',digitarPctDecimal(e.target.value))}
                              onBlur={e=>setExtra(i,'pct',formatarPctDecimal(e.target.value))} /></div>
                          <div className="form-group"><label className="form-label">Parentesco</label>
                            <input className="form-input" placeholder="Digite..." value={b.parentesco || ''} onChange={e=>setExtra(i,'parentesco',e.target.value)} /></div>
                          <div className="form-group">
                            <button type="button" className="btn btn-danger btn-sm" title="Remover beneficiário" onClick={()=>setExtras(extras.filter((_, idx) => idx !== i))}>✕</button>
                          </div>
                        </div>
                      ))}
                      <div style={{display:'flex',alignItems:'center',gap:12,margin:'2px 0 10px'}}>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={()=>setExtras([...extras, { nome: '', pct: '', parentesco: '' }])}>+ Adicionar beneficiário</button>
                        {extras.length > 0 && cobIndenizacao && (
                          <span style={{fontSize:12,color: totalPct === 100 ? '#3B6D11' : '#A32D2D'}}>Total: {String(totalPct).replace('.', ',')}%{totalPct !== 100 ? ' (deveria somar 100%)' : ''}</span>
                        )}
                      </div>
                    </>)
                  })()}
                  {cobMorte && (
                    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',rowGap:5,columnGap:12}}>
                      {renderCampoDinamico(cobMorte)}
                    </div>
                  )}
                </>)}
                {demaisCoberturas.length > 0 && (<>
                  {sec('Demais Coberturas')}
                  <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',rowGap:5,columnGap:12}}>
                    {demaisCoberturas.map(cob => renderCampoDinamico(cob))}
                  </div>
                </>)}
              </>)
            })() : coberturas.length > 0 && (<>
              {sec(`Coberturas — ${seguradora}`)}
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',rowGap:5,columnGap:12}}>
                {coberturas.map(cob => renderCampoDinamico(cob))}
              </div>
            </>)}
            {RAMOS_AUTO_COMBINADO.includes(ramo) && (<>
              {sec('Residencial combinado (Auto + Residencial)')}
              <div style={{display:'grid',gridTemplateColumns:'260px 1fr',rowGap:5,columnGap:12}}>
                <div className="form-group"><label className="form-label">Este seguro tem residencial junto?</label>
                  <select className="form-select" value={form.combinado_residencial||''} onChange={e=>f('combinado_residencial',e.target.value)}>
                    <option value="">Não</option>
                    {TIPOS_COMBINADO.map(o=><option key={o} value={o}>{o}</option>)}
                  </select>
                </div>
                <div style={{fontSize:12,color:'#888',alignSelf:'center'}}>Porto, Azul e Itaú: Proteção Combinada · HDI: DUO · demais seguradoras: Auto + Res</div>
              </div>
              {form.combinado_residencial && (<>
                <div style={{fontSize:12,fontWeight:700,color:'#666',margin:'6px 0'}}>Endereço do imóvel</div>
                <div style={{display:'grid',gridTemplateColumns:'130px 1fr 80px 1fr',rowGap:5,columnGap:12}}>
                  <div className="form-group"><label className="form-label">CEP {buscandoCep && <span style={{color:'#888',fontWeight:400}}>buscando...</span>}</label>
                    <input className="form-input" maxLength={10} placeholder="00000-000" value={form.res_cep||''}
                      onChange={e=>{ let v=e.target.value.replace(/\D/g,'').slice(0,8); if(v.length>5) v=v.slice(0,5)+'-'+v.slice(5); f('res_cep',v); buscarCepItem(v) }} />
                  </div>
                  <div className="form-group"><label className="form-label">Rua</label><input className="form-input" value={form.res_endereco||''} onChange={e=>f('res_endereco',e.target.value)} /></div>
                  <div className="form-group"><label className="form-label">Número</label><input className="form-input" maxLength={6} value={form.res_numero||''} onChange={e=>f('res_numero',e.target.value.slice(0,6))} /></div>
                  <div className="form-group"><label className="form-label">Complemento</label><input className="form-input" maxLength={20} value={form.res_complemento||''} onChange={e=>f('res_complemento',e.target.value.slice(0,20))} /></div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 60px 180px',rowGap:5,columnGap:12}}>
                  <div className="form-group"><label className="form-label">Bairro</label><input className="form-input" maxLength={30} value={form.res_bairro||''} onChange={e=>f('res_bairro',e.target.value.slice(0,30))} /></div>
                  <div className="form-group"><label className="form-label">Cidade</label><input className="form-input" maxLength={30} value={form.res_cidade||''} onChange={e=>f('res_cidade',e.target.value.slice(0,30))} /></div>
                  <div className="form-group"><label className="form-label">Estado</label><input className="form-input" maxLength={2} value={form.res_estado||''} onChange={e=>f('res_estado',e.target.value.toUpperCase().slice(0,2))} placeholder="UF" /></div>
                  <div className="form-group"><label className="form-label">Tipo</label>
                    <select className="form-select" value={form.res_tipo||''} onChange={e=>f('res_tipo',e.target.value)}>
                      <option value="">—</option>
                      {['Casa','Casa em Condomínio','Apartamento'].map(o=><option key={o}>{o}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{fontSize:12,fontWeight:700,color:'#666',margin:'6px 0'}}>Coberturas residenciais</div>
                {coberturasRes.length > 0 ? (
                  <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',rowGap:5,columnGap:12}}>
                    {coberturasRes.map(cob => renderCampoDinamico(cob, true))}
                  </div>
                ) : (
                  <div style={{padding:12,background:'#FAEEDA',borderRadius:8,fontSize:12,color:'#854F0B'}}>
                    ⚠ Nenhuma cobertura de Residencial cadastrada para {seguradora}. Cadastre em Cadastro &gt; Coberturas &gt; {seguradora} &gt; Residencial.
                  </div>
                )}
              </>)}
            </>)}
            {ramo !== 'Residencial' && <div className="form-group" style={{marginTop:8}}><label className="form-label">Observações</label><textarea className="form-input" rows={6} value={form.item_obs} onChange={e=>f('item_obs',e.target.value)} style={{resize:'vertical'}} /></div>}
            <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16,paddingTop:12,borderTop:'1px solid #f0f0f0'}}>
              <button type="button" className="btn btn-secondary" onClick={()=>setModal(false)}>Cancelar</button>
              <button type="button" className="btn btn-primary" disabled={loading} onClick={salvar}>{loading?'Salvando...':'Salvar Item'}</button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    )}
  </>)
}
